window.sizeChartData = window.sizeChartData || null;
window.settings = window.settings || null;
window.pageData = window.pageData || null;
window.shop = window.shop || "";
// 添加全局变量存储 fit 数据
window.fitChartsData = window.fitChartsData || null;
// Exception collection function
let exceptionCollector = {

  // Error code definitions
  ERROR_CODES: {
    INITIALIZATION_ERROR: 'SC_INIT_001',
    API_ERROR: 'SC_API_002',
    BUTTON_PLACEMENT_ERROR: 'SC_BTN_003',
    TOOLTIP_SELECTORS_ERROR: 'SC_TIP_004',
    TOOLTIP_FILTERING_ERROR: 'SC_TIP_005',
    TOOLTIP_DATA_ERROR: 'SC_TIP_006',
    RADIO_SELECTORS_ERROR: 'SC_RAD_007',
    THEME_COMPATIBILITY_ERROR: 'SC_THM_008',
    SIZE_INFO_ERROR: 'SC_SIZ_009',
    GENERAL_ERROR: 'SC_GEN_999'
  },

  // Get today's date string (YYYY-MM-DD format)
  getTodayDateString: function () {
    const today = new Date();
    return today.getFullYear() + '-' +
      String(today.getMonth() + 1).padStart(2, '0') + '-' +
      String(today.getDate()).padStart(2, '0');
  },

  // Get storage key for current shop and theme
  getStorageKey: function () {
    const shop = window.shop || window.Shopify?.shop || window.location.hostname;
    const themeName = window.Shopify?.theme?.schema_name || 'unknown';
    return `pify_exception_sent_${shop}_${themeName}`;
  },

  // Clean up old localStorage entries (older than 3 days)
  cleanupOldEntries: function () {
    try {
      const today = new Date();
      const threeDaysAgo = new Date(today.getTime() - 3 * 24 * 60 * 60 * 1000);
      const cutoffDate = threeDaysAgo.getFullYear() + '-' +
        String(threeDaysAgo.getMonth() + 1).padStart(2, '0') + '-' +
        String(threeDaysAgo.getDate()).padStart(2, '0');

      // Get all keys that start with our prefix
      const keysToCheck = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('pify_exception_sent_')) {
          keysToCheck.push(key);
        }
      }

      // Remove entries older than 3 days
      keysToCheck.forEach(key => {
        try {
          const storedDate = localStorage.getItem(key);
          if (storedDate && storedDate < cutoffDate) {
            localStorage.removeItem(key);
          }
        } catch (error) {
          // If any error occurs with a specific key, remove it
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      // Failed to cleanup old entries
    }
  },

  // Check if exceptions were already sent today for current shop/theme
  hasSentToday: function () {
    try {
      // Clean up old entries periodically (run cleanup on every check)
      // This only removes entries older than 3 days, ensuring today's record is preserved
      this.cleanupOldEntries();

      const storageKey = this.getStorageKey();
      const lastSentDate = localStorage.getItem(storageKey);
      const todayDate = this.getTodayDateString();

      // Compare stored date with today's date
      // Returns true if already sent today, false if not sent today or no record exists
      return lastSentDate === todayDate;
    } catch (error) {
      // Failed to check last sent date
      // If any error occurs, allow sending (return false)
      return false;
    }
  },

  // Mark that exceptions were sent today for current shop/theme
  markSentToday: function () {
    try {
      const storageKey = this.getStorageKey();
      const todayDate = this.getTodayDateString();
      localStorage.setItem(storageKey, todayDate);
    } catch (error) {
      // Failed to mark sent date
    }
  },

  // Get error code based on function name
  getErrorCode: function (functionName) {
    const functionToCodeMap = {
      'sizechart_initialization': this.ERROR_CODES.INITIALIZATION_ERROR,
      'sizechart_api_error': this.ERROR_CODES.API_ERROR,
      'sizechart_button_placement': this.ERROR_CODES.BUTTON_PLACEMENT_ERROR,
      'sizechart_tooltip_selectors': this.ERROR_CODES.TOOLTIP_SELECTORS_ERROR,
      'sizechart_tooltip_filtering': this.ERROR_CODES.TOOLTIP_FILTERING_ERROR,
      'sizechart_tooltip_data': this.ERROR_CODES.TOOLTIP_DATA_ERROR,
      'sizechart_radio_selectors': this.ERROR_CODES.RADIO_SELECTORS_ERROR,
      'Not compatible with the theme': this.ERROR_CODES.THEME_COMPATIBILITY_ERROR,
      'The corresponding size information was not found': this.ERROR_CODES.SIZE_INFO_ERROR
    };

    return functionToCodeMap[functionName] || this.ERROR_CODES.GENERAL_ERROR;
  },

  // Collect exception information
  collect: function (functionName, description) {
    try {
      // If already sent today, no need to collect new exceptions
      if (this.hasSentToday()) {
        return;
      }

      // Mark as sent immediately to prevent duplicate requests
      this.markSentToday();

      const clientInfoObject = {
        shop: window.shop || window.Shopify?.shop || window.location.hostname, // Current store information
        themeName: window.Shopify?.theme?.schema_name || '', // Current topic name
      };

      const errorCode = this.getErrorCode(functionName);

      const exception = {
        shop: window.shop || window.Shopify?.shop || window.location.hostname,
        errorCode: errorCode, // Error code for backend filtering
        function: functionName, // Identify the functional module with the problem
        description: description, // Problem description
        clientInfo: JSON.stringify(clientInfoObject),
        url: window.location.href, // Current page URL
        date: this.getTodayDateString() // Add today's date
      };

      // Send exception immediately
      this.sendException(exception);

    } catch (error) {
      // Failed to collect exception
    }
  },



  // Send exception information
  sendException: function (exception) {
    try {
      const xhr = new XMLHttpRequest();
      const baseUrl = getApiBaseUrl();
      xhr.open('POST', `${baseUrl}/api/front/exceptions`, true);
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Exception reported successfully
        } else {
          // Failed to report exception
        }
      };

      xhr.onerror = function () {
        // Network error when reporting exception
      };

      xhr.send(JSON.stringify(exception));
    } catch (error) {
      // Failed to send exception
    }
  },
};

getPageSizeChartData();

function getPageSizeChartData() {
  const scriptElement = document.getElementById('pify-sizechart-data');
  if (scriptElement) {
    try {
      window.pageData = JSON.parse(scriptElement.textContent);
      window.shop = window.pageData.shopDomain || window.Shopify.shop || (window.Shopify && window.Shopify.shop) || window.location.hostname;
      return window.pageData;
    } catch (error) {
      // Parse error
    }
  }
  return null;
}

function getEnvironment() {
  // Development environment
  if (window.shop === 'prodevolop5.myshopify.com') {
    return 'development';
  }

  // Test environment domains
  const testDomains = [
    'prodevolop14.myshopify.com',
    'vnryw.myshopify.com',
    'tiuer.myshopify.com',
    'vnryh.myshopify.com',
    'vnehw.myshopify.com',
    'vnrye.myshopify.com',
    'cvnes.myshopify.com',
    'vechw.myshopify.com',
    'dfgbn.myshopify.com',
    'sdfsk.myshopify.com',
    'vnxge.myshopify.com',
    'qvyrv.myshopify.com',
    'tyuvq.myshopify.com',
    'ptigw.myshopify.com',
    'hao01.myshopify.com',
    'bht4e.myshopify.com',
  ];

  if (testDomains.includes(window.shop)) {
    return 'test';
  }

  return 'production';
}

function getApiBaseUrl() {
  const env = getEnvironment();
  const API_URLS = {
    development: 'https://localhost',
    test: 'https://size-chart-test.pifyapp.com',
    production: 'https://size-chart.pifyapp.com'
  };
  return API_URLS[env];
}

function fetchSizeChartData() {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const baseUrl = getApiBaseUrl();
    xhr.open('GET', `https://size-chart.pifyapp.com/api/front/sizecharts?shop=toesox-tavinoir.myshopify.com`, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const response = JSON.parse(xhr.responseText);
          if (response && response.success) {
            // 存储 fitProfiles 到全局 pageData 对象
            if (!window.pageData) {
              window.pageData = {};
            }
            window.pageData.fitProfiles = response.fitProfiles || [];

            resolve({
              data: response.data,
              settings: response.settings,
              fitProfiles: response.fitProfiles || []
            });
          }
        } catch (error) {
          reject(error);
        }
      } else {
        reject(new Error(`API request failed, status code: ${xhr.status}`));
      }
    };

    xhr.onerror = function () {
      reject(new Error('Network error, unable to connect to API'));
    };

    xhr.send();
  });
}

// 创建按钮图标的通用方法
function createButtonIcon(buttonDiv) {
  // 使用自定义图标或默认图标
  const iconPath = window.settings?.buttonIcon || `https://size-chart.pifyapp.com/assets/images/icons/icon6.svg`;
  const resolvedPath = resolveImagePath(iconPath);
  
  if (resolvedPath) {
    const img = document.createElement('img');
    img.src = resolvedPath;
    img.className = 'pify_button_icon';
    buttonDiv.appendChild(img);
  }
}

function initializeSizeChart() {
  fetchSizeChartData()
    .then((result) => {
      try {
        window.sizeChartData = result.data;
        window.settings = result.settings;
        addCustomButtons();
        addStyleSheet();
      } catch (error) {
        exceptionCollector.collect(
          'sizechart_initialization',
          'Error during size chart initialization process'
        );
      }
    })
    .catch(error => {
      exceptionCollector.collect(
        'sizechart_api_error',
        'Failed to fetch size chart data from API'
      );
    });
}

function renderModule(module) {
  const moduleContainer = document.createElement('div');
  moduleContainer.className = 'pify_module_container';

  switch (module.type) {
    case 'table':
      moduleContainer.appendChild(renderTable(module.content));
      break;
    case 'text':
      moduleContainer.appendChild(renderText(module.content));
      break;
    case 'image':
      moduleContainer.appendChild(renderImage(module.content));
      break;
  }

  return moduleContainer;
}

function renderTable(content) {
  const container = document.createElement('div');
  container.className = 'pify_table_container';

  const tableModule = document.createElement('div');
  tableModule.className = 'tableModule';

  const unitContainer = document.createElement('div');
  unitContainer.className = 'pify_unit_container';

  const tableId = 'table_' + Math.random().toString(36).substr(2, 9);
  container.dataset.tableId = tableId;
  container.dataset.currentUnit = content.unit || 'cm';
  container.dataset.initialUnit = content.unit || 'cm';

  ['cm', 'inch'].forEach(unit => {
    const label = document.createElement('label');
    label.className = 'pify_unit_label';

    const radio = document.createElement('input');
    radio.type = 'radio';
    radio.name = `unit_${tableId}`;
    radio.value = unit;
    radio.checked = container.dataset.currentUnit === unit;
    radio.onchange = () => handleUnitChange(unit, container);

    const text = document.createElement('span');
    text.textContent = unit === 'cm' ? 'Centimeter' : 'Inch';

    label.appendChild(radio);
    label.appendChild(text);
    unitContainer.appendChild(label);
  });

  // Table
  const table = document.createElement('table');
  table.className = 'pify_size_table';
  table.dataset.tableId = tableId;
  table.dataset.hoveredRow = -1;
  table.dataset.hoveredCol = -1;

  // Table header
  const thead = document.createElement('thead');
  const headerRow = document.createElement('tr');
  content.headers.forEach((header, index) => {
    const th = document.createElement('th');
    th.className = 'pify_table_header';
    th.textContent = header;
    th.dataset.colIndex = index;

    th.addEventListener('mouseenter', () => {
      table.dataset.hoveredCol = index;
      updateTableHighlight(table);
    });

    th.addEventListener('mouseleave', () => {
      table.dataset.hoveredCol = -1;
      updateTableHighlight(table);
    });

    headerRow.appendChild(th);
  });
  thead.appendChild(headerRow);
  table.appendChild(thead);

  // Table content
  const tbody = document.createElement('tbody');
  content.tableData.forEach((row, rowIndex) => {
    const tr = document.createElement('tr');
    content.headers.forEach((header, colIndex) => {
      const td = document.createElement('td');
      td.className = 'pify_table_cell';
      const key = Object.keys(row).find(k => k === header);
      td.textContent = key ? row[key] : '-';

      td.dataset.rowIndex = rowIndex;
      td.dataset.colIndex = colIndex;

      td.addEventListener('mouseenter', () => {
        table.dataset.hoveredRow = rowIndex;
        table.dataset.hoveredCol = colIndex;
        updateTableHighlight(table);
      });

      td.addEventListener('mouseleave', () => {
        table.dataset.hoveredRow = -1;
        table.dataset.hoveredCol = -1;
        updateTableHighlight(table);
      });

      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });
  table.appendChild(tbody);

  // Only show unit container for non-text tables
  if (!content.isTextTable) {
    tableModule.appendChild(unitContainer);
  }
  tableModule.appendChild(table);
  container.appendChild(tableModule);
  return container;
}

function renderText(content) {
  const container = document.createElement('div');
  container.className = 'pify_text_container';
  container.innerHTML = content;
  return container;
}

function resolveImagePath(path) {
  if (!path) return '';

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const env = getEnvironment();
  if (env === 'development') {
    const normalizedPath = path.startsWith('/') ? path : '/' + path;
    return 'https://localhost' + normalizedPath;
  }

  if (path.startsWith('/')) {
    const baseUrl = getApiBaseUrl();
    return baseUrl + path;
  }

  return path;
}

function renderImage(content) {
  const container = document.createElement('div');
  container.className = 'pify_image_container';

  const img = document.createElement('img');
  img.src = resolveImagePath(content);

  img.onerror = function () {
    this.style.display = 'none';
    const errorText = document.createElement('div');
    errorText.className = 'pify_image_error';
    container.appendChild(errorText);
  };

  container.appendChild(img);
  return container;
}

function formatNumber(num) {
  const formatted = parseFloat(num).toFixed(2);
  if (formatted.endsWith('.00')) {
    return formatted.slice(0, -3);
  }
  if (formatted.endsWith('0')) {
    return formatted.slice(0, -1);
  }
  return formatted;
}

function handleUnitChange(newUnit, container) {
  container.dataset.currentUnit = newUnit;

  const table = container.querySelector('.pify_size_table');
  if (!table) return;

  const initialUnit = container.dataset.initialUnit || 'cm';

  if (!container.dataset.originalData) {
    const originalData = [];
    const rows = table.querySelectorAll('tbody tr');
    rows.forEach(row => {
      const rowData = [];
      const cells = row.querySelectorAll('td');
      cells.forEach((cell, index) => {
        if (index > 0 && cell.textContent !== '-') {
          const value = parseFloat(cell.textContent);
          if (!isNaN(value)) {
            rowData.push(value);
          } else {
            rowData.push(cell.textContent);
          }
        } else {
          rowData.push(cell.textContent);
        }
      });
      originalData.push(rowData);
    });
    container.dataset.originalData = JSON.stringify(originalData);
    container.dataset.originalUnit = initialUnit;
  }

  const originalData = JSON.parse(container.dataset.originalData);
  const originalUnit = container.dataset.originalUnit || 'cm';

  const rows = table.querySelectorAll('tbody tr');
  rows.forEach((row, rowIndex) => {
    const cells = row.querySelectorAll('td');
    cells.forEach((cell, index) => {
      if (index > 0 && cell.textContent !== '-') {
        const value = parseFloat(cell.textContent);
        if (!isNaN(value) && originalData[rowIndex] && originalData[rowIndex][index] !== undefined) {
          const originalValue = originalData[rowIndex][index];
          if (originalUnit === 'cm' && newUnit === 'inch') {
            cell.textContent = formatNumber(originalValue / 2.54);
          } else if (originalUnit === 'inch' && newUnit === 'cm') {
            cell.textContent = Math.round(originalValue * 2.54);
          } else if (originalUnit === newUnit) {
            cell.textContent = originalValue.toString();
          } else {
            cell.textContent = originalValue.toString();
          }
        }
      }
    });
  });
}

function createModal(sizeChart,index) {
  if(sizeChart.code == "a1a7e74c-d89a-49dc-996f-eab1d70d0503" || sizeChart.code == "8f98ab4c-26c5-4e4f-9a7b-f7f7774fd11e" || sizeChart.code == "d9e46f01-1873-4e18-841a-fcffc141b028"){
    const link = document.createElement("a");
    link.setAttribute("tabindex", "0");
    link.className = "item";
    if (index === 0) {
      link.classList.add('active');
    }
    link.setAttribute("data-name", sizeChart.name.toLowerCase());
    link.textContent = sizeChart.name;

    document.querySelector('.main-tab').append(link);

    // Modal
    
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'overlay ' + sizeChart.name.toLowerCase();

    if (index === 0) {
      modalOverlay.classList.add('active');
    }

    const modalContent = document.createElement('div');
    modalContent.className = 'pify_modal_content';

    // close button
    const closeButton = document.createElement('button');
    closeButton.className = 'pify_close_button';
    closeButton.innerHTML = '✕';

    // tab
    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'pify_tabs_container hidden';

    // Content area
    const contentContainer = document.createElement('div');
    contentContainer.className = 'pify_size_chart_content';

    // Create tabs - using data from sizeChart.settings.blocks
    const tabs = sizeChart.settings.blocks;
    var click = null;
    tabs.forEach((tab, index) => {
      const tabElement = document.createElement('div');
      tabElement.className = `pify_tab ${index === 0 ? 'pify_tab_active' : ''}`;
      tabElement.textContent = tab.name;
      // tabElement.onclick = () => switchTab(index, contentContainer, sizeChart,click=true);
      tabElement.onclick = () => switchTab(index, contentContainer, sizeChart, tabElement,click=true);
      tabsContainer.appendChild(tabElement);
    });

    // Assemble modal
  //   modalContent.appendChild(closeButton);
    modalContent.appendChild(tabsContainer);
    modalContent.appendChild(contentContainer);
    modalOverlay.appendChild(modalContent);

    // Close events
    closeButton.onclick = () => modalOverlay.remove();
    modalOverlay.onclick = (e) => {
      if (e.target === modalOverlay) {
        modalOverlay.remove();
      }
    };

    switchTab(0, contentContainer, sizeChart,false);

    return modalOverlay;
  }
}

  document.getElementById('size-chart-data').addEventListener('click', function (e) {
    const clicked = e.target;
    
    // Check if a tab item was clicked
    if (clicked.classList.contains('item')) {
      const name = clicked.getAttribute('data-name').toLowerCase();

      // Remove active from all overlays
      document.querySelectorAll('.overlay').forEach(overlay => {
        overlay.classList.remove('active');
      });

      // Activate the corresponding overlay
      const targetOverlay = document.querySelector('.overlay.' + name);
      if (targetOverlay) {
        targetOverlay.classList.add('active');
      }

      // (Optional) toggle active on tabs
      document.querySelectorAll('.main-tab .item').forEach(tab => {
        tab.classList.remove('active');
      });
      clicked.classList.add('active');
    }
  });

function switchTab(selectedIndex, contentContainer, sizeChart,tabElement) {
  const tabs = document.querySelectorAll('.pify_tab');
    // tabs.forEach((tab, index) => {
      // if (index === selectedIndex) {
        // tab.classList.add('pify_tab_active');
      // } else {
        // tab.classList.remove('pify_tab_active');
      // }
    // });
    if(tabElement){
      tabElement.parentNode.querySelectorAll('.pify_tab').forEach((tab, index)=>{
        tab.classList.remove('pify_tab_active');
      })
      tabElement.classList.add('pify_tab_active')
    }

  contentContainer.innerHTML = '';

  const currentTab = sizeChart.settings.blocks[selectedIndex];
  if (currentTab && currentTab.modules) {
    currentTab.modules.forEach(module => {
      contentContainer.appendChild(renderModule(module));
    });
  }
}

function shouldDisplaySizeChart(sizeChart) {
  if (!sizeChart || !sizeChart.settings || !sizeChart.settings.targeting) {
    return false;
  }

  const isProductPage = window.location.pathname.startsWith('/products/') ||
    window.location.pathname.includes('/products/');
  if (!isProductPage) {
    return false;
  }

  if (sizeChart.settings.targeting.displayPosition === 'all') return true;
  if (sizeChart.settings.targeting.displayPosition === 'products') {
    if (!window.pageData || !window.pageData.productId) return false;

    return sizeChart.settings.targeting.selectedProducts.some(product => {
      if (!product || !product.id) return false;

      const productId = product.id.split('/').pop();
      const productIdStr = String(productId);
      const pageProductIdStr = String(window.pageData.productId);

      return productIdStr === pageProductIdStr;
    });
  }
  if (sizeChart.settings.targeting.displayPosition === 'collections') {
    if (!window.pageData || !window.pageData.collectionIds || !Array.isArray(window.pageData.collectionIds)) return false;

    return sizeChart.settings.targeting.selectedCollections.some(collection => {
      if (!collection || !collection.id) return false;

      const collectionId = collection.id.split('/').pop();
      const collectionIdStr = String(collectionId);

      return window.pageData.collectionIds.some(pageCollectionId =>
        String(pageCollectionId) === collectionIdStr
      );
    });
  }
  if (sizeChart.settings.targeting.displayPosition === 'tags') {
    if (!window.pageData || !window.pageData.productTags || !Array.isArray(window.pageData.productTags)) return false;
    if (!sizeChart.settings.targeting.productTags || !Array.isArray(sizeChart.settings.targeting.productTags)) return false;

    return sizeChart.settings.targeting.productTags.some(tag =>
      window.pageData.productTags.includes(tag)
    );
  }

  return false;
}

function getButtonContainerClasses() {
  return [
    'product-form__buttons',
    'product-form__controls',
    'product-form__actions',
    'product-form__button-container',
    'product-form__payment-container',
    'product-form__atc-container',
    'product-form__submit-container',
    'product-form__cta',
    'product-form__buttons-container',
    'product-form__add-to-cart',
    'product__submit',
    'product__buttons',
    'product-page__submit',
    'add-to-cart-container',
    'atc-btn-container',
    'button-wrapper',
    'button-container',
    'btn-wrapper',
    'form-actions',
    'product-form__buy-buttons',
    'product-form__atc-wrapper',
    'product-form__button-wrapper',
    'product-form__submit-wrapper',
    'product-form__action-wrapper',
    'product-buy-buttons',
    'product-add-to-cart',
    'product-form-inline-atc',
    'product-form__buy-now',
    'product-form__payment-buttons',
    'product-form__buttons--primary',
    'product-form__buttons--secondary',
    'button-action-wrapper',
    'btn-cart-wrapper',
    'atc-button-container',
    'product-summary__add-to-cart',
    'product-checkout-buttons'
  ];
}

function findButtonContainer(element, containerSelectors) {
  // First check if there are specific parent container class names
  const specificContainers = [
    'qty_addtocart_btns',
    'product-form__buttons',
    'product-form__controls',
    'product-form__actions',
    'product-form__button-container',
    'product-form__payment-container',
    'product-form__atc-container',
    'product-form__submit-container',
    'product-form__cta',
    'product-form__buttons-container',
    'product-form__add-to-cart',
    'product__submit',
    'product__buttons',
    'product-page__submit',
    'add-to-cart-container',
    'atc-btn-container',
    'button-wrapper',
    'button-container',
    'btn-wrapper',
    'form-actions'
  ];

  // Check all parent elements
  let currentElement = element;
  while (currentElement) {
    // Check if the current element's class name matches a specific container
    if (currentElement.classList) {
      for (const className of specificContainers) {
        if (currentElement.classList.contains(className)) {
          return currentElement;
        }
      }
    }
    currentElement = currentElement.parentElement;
  }

  // If no specific container is found, try using the provided selectors
  for (const selector of containerSelectors) {
    const container = element.closest(selector);
    if (container) {
      return container;
    }
  }

  return null;
}

function getThemeSelectors() {
  const defaultSelectors = {
    buttonSelectors: [
      'button[name="add"][type="submit"]',
      'input[name="add"][type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      '#AddToCart',
      '#add-to-cart',
      '[id*="AddToCart"]',
      '.product-form__submit',
      '.add-to-cart',
      '.addtocart',
      '.dT_AddToCart',
      '.add-to-cart-btn',
      'button[class*="add-to-cart"]',
      'input[class*="add-to-cart"]',
      '.btn-cart',
      '.enj-add-to-cart-btn',
      'button[name="add"]',
      'button[type="submit"]',
      'input[type="submit"]',
      'button.button-add-to-cart',
      'button.product__add-to-cart',
      'button.product-form__add-btn',
      'button.button-action',
      'button.add-to-cart-button',
      'button.js-cart-link',
      'button[aria-label="Add to cart"]',
      'button[name="add"].btn-main',
      'input[type="submit"][data-add_to_cart]',
      'input[type="submit"].add-to-cart-btn',
      'form[action*="/cart/add"]'
    ],
    containerSelectors: [
      '.product-form__buttons',
      '.product-form__controls',
      '.product-form__actions',
      '.product-form__button-container',
      '.product-form__payment-container',
      '.product-form__atc-container',
      '.product-form__submit-container',
      '.product-form__cta',
      '.product-form__buttons-container',
      '.product-form__add-to-cart',
      '.product__submit',
      '.product__buttons',
      '.product-page__submit',
      '.add-to-cart-container',
      '.atc-btn-container',
      '.button-wrapper',
      '.button-container',
      '.btn-wrapper',
      '.form-actions'
    ],
    sizeSelectorPatterns: [
      'div.variant-dropdown',
      'select[id^="template"][id*="single-option-form"]',
      'select[id*="Product-SingleOptionSelector"]',
      'select[id*="Option-template"]',
      'select.Form__Select',
      'select#option-size',
      'fieldset.product-option',
      'fieldset.product-form__input',
      'fieldset[role="radiogroup"]',
      'fieldset.js.product-form-input',
      'fieldset[data-option-name="Size"]',
      'fieldset.product-selector__wrapper',
      'div.product-option-row',
      'select.product-form__select',
      'select.product-form__variant-select',
      'div.product-form__input--dropdown select',
      'div.variant-field',
      'div.variant-swatch',
      'div.styled-pills-radio',
      'div.product-selector-option.select-size',
      'fieldset.radio__fieldset',
      'div.variant-picker__input',
      'div.variant-picker__option-values',
      'fieldset.js-product-form-input',
      'fieldset.option-selector[data-option="Size"]',
      'div.main-product__fieldset',
      'fieldset.variant-picker__input',
      'div.radio__fieldset',
      'fieldset.variant-input-wrap',
      'div.swatches__container',
      'div.js-variant-selector',
      'fieldset.js.product-form__inpt.size_main',
      'fieldset[data_options="Size"]',
      'fieldset.size_main',
      'div.swatch-element',
      'div.variant-pills-wrapper',
      'div.radio__container',
      'div.product-variant_options-wrap',
      'div.variant-options-wrap',
      'div.variant-radios div.variant-radio',
      'div.product-variant__item--size',
      'div.product-variant__item',
      'fieldset.variant-picker__buttons',
      'fieldset.variant-picker__swatches',
      'div.option-selector__btns',
      'li.size__option',
      'div.product-variant-option',
      'div.xo-product-variant__inner-value',
      'product-option[data-name="Size"]',
      'div.radio-field',
      'div.block-swatch ',
      'div.product-options__default',
      'div.options-selection__option-value',
      'div.variant-input',
      'li.BlockSwatchWrapper',
      'div.label-only-input',
      'div.form-options-wrapper',
      'div[class*="product-options-radio"]',
      'div.radios--container',
      'fieldset.variant-button-wrap',
      'li.variant--item',
      'div.inline-field-wrapper',
      'div.variant-options--wrapper',
      'li.variant-item',
      '.product-option-picker__list',
      'ul.check',
      'div.radio-container',
      'li.variant_option',
      'div.form__variants',
      'li.product-swatch-item',
      'li.swatches-list-item',
      'div.variantPickerButtonsWrap',
      'div.product__variants-radio',
      'div.options-frame',
      'span.leading-solid',
      'div[class*="form-field"]',
      'div.product__color-chips',
      'div.product-form__chip-wrapper',
      'div.option-group__chips-container',
      'div.product-variant-picker__pill-list',
      'ul.clickyboxes',
      'div.product-form__swatch__item',
      'div.product-form__controls-group',
      'div.single-option-selector__wrap-option',
      'fieldset.variant-input-wrapper',
      'select.product-variant-container',
      'select.single-option-selector',
      'select.input-select__select',
      'div.product-form__input-wrapper',
      'div.hdt-product-form__values',
      'div.variant-input-wrap',
      'fieldset.variant-option--buttons',
      'div.t4s-swatch__list',
      'div.product-options__section',
      'div.swatch-group_wrapper',
      'div.input-group',
      'div.swt-type-button',
      'div.product-single-option',
      'div.variants__options',
      'fieldset.product-variant-form-input',
      'div.prd-size',
      'span.option-item[data-option="size"]',
      'div.selector-wrapper',
      'div.tawcvs-swatches',
      'span.swatch[data-value]',
      'div.tt-wrapper',
      'div.option-block',
      'fieldset.prd-option-list',
      'div.product-form__label-container'
    ],
    variantSelectors: [
      'variant-radios',
      'variant-selects',
      'variant-selects[data-type="multiple"]'
    ],
    tooltipStyles: {
      position: 'absolute',
      bottom: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      marginBottom: '10px',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '12px',
      borderRadius: '4px',
      fontSize: '14px',
      zIndex: '999999',
      minWidth: '160px',
      maxWidth: '250px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      pointerEvents: 'none',
      opacity: '0',
      transition: 'opacity 0.2s ease-in-out',
      whiteSpace: 'normal',
      display: 'block !important',
      visibility: 'visible !important'
    }
  };

  return {
    default: defaultSelectors,
    'electro theme': {
      ...defaultSelectors,
      sizeSelectorPatterns: [
        '.swatch-group_inner'
      ]
    },
    'wokiee': {
      ...defaultSelectors,
      sizeSelectorPatterns: [
        'div.tt-wrapper'
      ]
    },
    'nitro': {
      ...defaultSelectors,
      sizeSelectorPatterns: [
        '.bee-swatch',
        '.bee-swatch__item',
        '.bee-product-sizes',
        '.product-option-picker__list',
        '.product-option-picker__list-item',
        'span.option-item[data-option="size"]',
        'div[data-option="size"]',
        'select[name*="size"]',
        'select[name*="Size"]',
        'fieldset[data-option="Size"]',
        'div.size-selector',
        'div.variant-selector',
        'div.product-form__input',
        'div.product-form__buttons'
      ]
    }
  };
}

function getCurrentThemeSelectors() {
  // Get theme name from Shopify.theme.schema_name
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  const normalizedThemeName = themeName.toLowerCase();
  // Check if the theme name exactly matches known themes
  const selectors = getThemeSelectors();
  if (selectors[normalizedThemeName]) {
    return selectors[normalizedThemeName];
  }

  // If no matching theme is found, return default selectors
  return selectors.default;
}

// Helper function to check if an element is visible
function isElementVisible(element) {
  if (!element) return false;
  const style = window.getComputedStyle(element);
  const isBasicallyVisible = style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0';

  if (!isBasicallyVisible) return false;

  const hasSize = element.offsetWidth > 0 && element.offsetHeight > 0;

  if (hasSize) return true;

  // Consider disabled buttons as valid special buttons
  const isSpecialButton = element.tagName === 'BUTTON' ||
    element.tagName === 'INPUT' ||
    element.closest('form[action*="/cart/add"]') !== null ||
    element.hasAttribute('disabled'); // Add disabled elements as special case

  return isSpecialButton;
}

function addCustomButtons() {
  if (!window.sizeChartData || !Array.isArray(window.sizeChartData)) {
    return;
  }

  // Get current theme selectors
  const themeSelectors = getCurrentThemeSelectors();
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  // If there is a box with the class name "pify_size_chart_wrapper" on the page, the button will be inserted into it first.
  const pifyWrapper = document.querySelector('.block-text_EwB88D') || true;
  if (pifyWrapper) {
    // Create a button for each size chart - 完全移除容器，直接添加按钮
    window.sizeChartData.forEach((sizeChart, index) => {
    //   if (!shouldDisplaySizeChart(sizeChart)) return;

      // 简化为单层结构，只保留pify_size_chart_button
      const buttonDiv = document.createElement('div');
      buttonDiv.className = 'pify_size_chart_button pify_inline_button';
      
      // 设置按钮的自定义属性，用于CSS样式应用
      const buttonStyle = window.settings?.inlineButton?.style || {};
      if (buttonStyle.backgroundColor) {
        buttonDiv.style.setProperty('--button-bg-color', buttonStyle.backgroundColor);
      }
      if (buttonStyle.color) {
        buttonDiv.style.setProperty('--button-text-color', buttonStyle.color);
      }
      if (buttonStyle.borderColor) {
        buttonDiv.style.setProperty('--button-border-color', buttonStyle.borderColor);
      }
      if (buttonStyle.borderRadius) {
        buttonDiv.style.setProperty('--button-border-radius', buttonStyle.borderRadius);
      }
      if (buttonStyle.borderWidth) {
        buttonDiv.style.setProperty('--button-border-width', buttonStyle.borderWidth);
      }
      if (buttonStyle.fontSize) {
      buttonDiv.style.setProperty('--button-font-size', buttonStyle.fontSize);
    }
    if (buttonStyle.textDecoration) {
      buttonDiv.style.setProperty('--button-text-decoration', buttonStyle.textDecoration);
    }

      // 创建按钮图标
      createButtonIcon(buttonDiv);

      const textSpan = document.createElement('span');
      textSpan.className = 'pify_button_text';
      textSpan.textContent = window.settings?.buttonText || 'Size Chart';
      buttonDiv.appendChild(textSpan);
     const modal = createModal(sizeChart,index);
    document.querySelector('#size-chart-data').appendChild(modal);

      buttonDiv.addEventListener('click', function () {
      });

    //   pifyWrapper.appendChild(buttonDiv);
    });

    return;
  }
  
  // 根据按钮类型决定创建哪种按钮
  const buttonType = window.settings?.buttonType || 'inline';
  
  // 如果是纯浮动按钮，只创建浮动按钮
  if (buttonType === 'floating') {
    applyFloatingToContainer();
    return;
  }
  
  // 如果是both类型，先创建浮动按钮
  if (buttonType === 'both') {
    applyFloatingToContainer();
  }
  
  // Custom selectors take priority
  const userSelector = window.settings?.inlineButton?.cssSelector;
  let targetElement = null;

  // Try to use custom selector
  if (userSelector) {
    const elements = document.querySelectorAll(userSelector);
    for (const element of elements) {
      if (isElementVisible(element)) {
        targetElement = element;
        break;
      }
    }
  }

  // If custom selector didn't find visible elements, try theme-specific selectors
  if (!targetElement) {
    const themeButtonConfigs = {
      'vantage': {
        selector: '.product-add.clearfix input[type="submit"][name="button"].AddtoCart',
        useContainer: false
      },
      'machina': {
        selector: '.add-to-cart__wrapper.product-form-margin-bottom .add-to-cart__submit .atc-container button[type="submit"][name="add"].add-to-cart-button',
        useContainer: false
      },
      'noire': {
        customHandler: () => {
          // Look for Add to cart button inside item-field container
          const itemFields = document.querySelectorAll('.item-field');
          for (const itemField of itemFields) {
            const addToCartButton = itemField.querySelector('button[type="submit"][name="add"].button.add-to-cart-button.primary-button.text-capitalize');
            if (addToCartButton && isElementVisible(addToCartButton)) {
              // Set the item-field container as target element so we can place size chart button after it
              return itemField;
            }
          }

          // Fallback: if no item-field found, look for any non-floated Add to cart button
          const allNoireButtons = document.querySelectorAll('button[type="submit"][name="add"]');
          for (const button of allNoireButtons) {
            if (!isElementVisible(button)) continue;

            const form = button.closest('form');
            const isFloatedForm = form && form.id && form.id.includes('floated-product-form');

            if (!isFloatedForm) {
              return button;
            }
          }
          return null;
        }
      },
      'nexa': {
        selector: '.main-product_form-btns',
        useContainer: false
      },
      'whisk': {
        selector: '.featured-product__add-to-cart-button',
        useContainer: false
      },
      'zero': {
        selector: '.main-product_atc-btn',
        useContainer: false
      },
      'mono': {
        selector: '.button--primary-outline',
        useContainer: false
      },
      'roam': {
        selector: '.btn-full-width',
        useContainer: false
      },
      'maranello': {
        selector: '.product-actions',
        useContainer: false
      },
      'multi': {
        selector: '[class*="product-form-add-to-cart"]',
        useContainer: false
      },
      'enterprise': {
        selector: '.product-info__add-to-cart',
        useContainer: false
      },
      'align': {
        selector: '.button.button--add-to-cart[name="add"]',
        useContainer: false
      },
      'xtra': {
        selector: '.f8pr-button',
        useContainer: false
      },
      'avenue': {
        selector: '.purchase-section',
        useContainer: false
      },
      'atlantic': {
        selector: '.product-submit',
        useContainer: false
      },
      'tailor': {
        selector: '.button-action',
        useContainer: false
      },
      'label': {
        customHandler: () => {
          const labelButton = document.querySelector('.add-to-cart-btn');
          if (labelButton && isElementVisible(labelButton)) {
            const flexContainer = labelButton.closest('.lg\\:flex');
            return flexContainer || labelButton;
          }
          return null;
        }
      },
      'momentum': {
        selector: '.product--add-to-cart-button',
        useContainer: false
      },
      'lumin': {
        selector: '.product-common_btns-wrap',
        useContainer: false
      },
      'satoshi': {
        selector: '#product-actions',
        useContainer: false
      },
      'responsive': {
        selector: '.purchase-details__buttons',
        useContainer: false
      },
      'zest': {
        selector: 'button[id*="ProductSubmitButton-template"].f-product-form__submit.btn.btn--secondary, .f-product-form__submit.btn.btn--secondary',
        useContainer: false
      },
      'pinnacle': {
        selector: '.single-add-to-cart-button',
        useContainer: false
      },
      'minimog - os 2.0': {
        selector: '.m-product-form--wrapper',
        useContainer: false
      },
      'porto': {
        selector: '.add-to-cart-box',
        useContainer: false
      },
      'lezada os 2.0': {
        selector: '.product-cart-action',
        useContainer: false
      },
      'lumia': {
        selector: '.row.gx-2.gx-xl-3.gy-3',
        useContainer: false
      },
      'elomus': {
        selector: '.button-cart',
        useContainer: false
      },
      'goodwin': {
        selector: '.btn-wrap',
        useContainer: false
      },
      'vinova modamate': {
        selector: '.product-form__item--quantity',
        useContainer: false
      },
      'foxic': {
        selector: '.btn-wrap',
        useContainer: false
      },
      'lusion': {
        selector: '.form-add-cart',
        useContainer: false
      },
      'lusion-christmas': {
        selector: '.form-add-cart',
        useContainer: false
      },
      'aero': {
        selector: '.btn-wishlist',
        useContainer: false
      },
      'corano': {
        selector: '.product-cart-action',
        useContainer: false
      },
      'unero': {
        selector: '.single-add-to-cart-btn',
        useContainer: false
      },
      'vinova salehup': {
        selector: '.product-form__item--submit',
        useContainer: false
      },
      'learts - shopify theme ': {
        selector: '.product-cart-action',
        useContainer: false
      },
      'ella': {
        selector: '.product-form__buttons',
        useContainer: false
      },
      'ecomus': {
        selector: '.hdt-product-form__submit',
        useContainer: false
      },
      'optimal': {
        selector: '.pr_btn',
        useContainer: false
      },
      'ritual': {
        selector: '.product-form-buttons',
        useContainer: false
      },
      'shella': {
        selector: '.product-page-info__button-add-to-cart',
        useContainer: false
      },
      'atelier': {
        selector: '.product-form-buttons',
        useContainer: false
      },
      'lusion-fashion-women': {
        selector: '.gp-product-main-button',
        useContainer: false
      },
      'roxxe': {
        selector: '.product-add-to-cart-wrapper',
        useContainer: false
      },
      'lusion-minimalist': {
        selector: '.product-form--payment-button-no-variants',
        useContainer: false
      },
    };

    const themeConfig = themeButtonConfigs[themeName];
    if (themeConfig) {
      if (themeConfig.customHandler) {
        targetElement = themeConfig.customHandler();
      } else if (themeConfig.selector) {
        const foundElement = document.querySelector(themeConfig.selector);
        if (foundElement && isElementVisible(foundElement)) {
          targetElement = foundElement;
        }
      }
    }

    if (!targetElement) {
      const allButtons = document.querySelectorAll('button[type="submit"], input[type="submit"], button.product-buy-buttons--primary, button-content');
      const addToCartButtons = Array.from(allButtons).filter(button =>
        hasAddToCartText(button) && isElementVisible(button)
      );

      if (addToCartButtons.length > 1) {
        // If there are multiple buttons, try to find the correct one
        // 1. First check the parent element of the button
        const productForm = document.querySelector('form[action="/cart/add"]');
        if (productForm) {
          // Look for the button inside the form
          const formButton = productForm.querySelector('button[type="submit"], input[type="submit"], button-content');
          if (formButton && isElementVisible(formButton)) {
            targetElement = formButton;
          }
        }

        // 2. If not found, check the position of the button
        if (!targetElement) {
          const productInfo = document.querySelector('.product__info, .product-info, .product-details');
          if (productInfo) {
            // Look for the button in the product information area
            const infoButton = productInfo.querySelector('button[type="submit"], input[type="submit"], button-content');
            if (infoButton && isElementVisible(infoButton)) {
              targetElement = infoButton;
            }
          }
        }

        // 3. If still not found, use specific class names
        if (!targetElement) {
          const specificButton = addToCartButtons.find(button =>
            button.classList.contains('ux-cart') ||
            button.classList.contains('button--add-to-cart') ||
            button.classList.contains('product-buy-buttons--primary') ||
            button.classList.contains('product-form__submit') ||
            button.classList.contains('overlay-buy_button') ||
            button.closest('.product-form__buttons') ||
            button.closest('.product-form__submit')
          );
          if (specificButton) {
            targetElement = specificButton;
          }
        }

        // 4. If still not found, select the last visible button
        if (!targetElement) {
          targetElement = addToCartButtons[addToCartButtons.length - 1];
        }
      } else if (addToCartButtons.length === 1) {
        targetElement = addToCartButtons[0];
      }
    }
    if (!targetElement) {
      for (const selector of themeSelectors.buttonSelectors) {
        const elements = document.querySelectorAll(selector);
        for (const element of elements) {
          if (isElementVisible(element)) {
            if (hasAddToCartText(element) || isInAddToCartForm(element)) {
              targetElement = element;
              break;
            }
          }
        }
        if (targetElement) break;
      }
    }
  }

  const position = window.settings?.inlineButton?.detailedPosition || 'above';

  // 创建按钮容器（简化为单层结构）
  const container = document.createElement('div');
  container.className = 'pify_inline_buttons_container';

  // Create a button for each size chart
  window.sizeChartData.forEach((sizeChart, index) => {
    if (!shouldDisplaySizeChart(sizeChart)) return;

    // 简化为单层结构，只保留pify_size_chart_button
    const buttonDiv = document.createElement('div');
    buttonDiv.className = 'pify_size_chart_button pify_inline_button';
    
    // 设置按钮的自定义属性，用于CSS样式应用
    const buttonStyle = window.settings?.inlineButton?.style || {};
    if (buttonStyle.backgroundColor) {
      buttonDiv.style.setProperty('--button-bg-color', buttonStyle.backgroundColor);
    }
    if (buttonStyle.color) {
      buttonDiv.style.setProperty('--button-text-color', buttonStyle.color);
    }
    if (buttonStyle.borderColor) {
      buttonDiv.style.setProperty('--button-border-color', buttonStyle.borderColor);
    }
    if (buttonStyle.borderRadius) {
      buttonDiv.style.setProperty('--button-border-radius', buttonStyle.borderRadius);
    }
    if (buttonStyle.borderWidth) {
      buttonDiv.style.setProperty('--button-border-width', buttonStyle.borderWidth);
    }
    if (buttonStyle.fontSize) {
      buttonDiv.style.setProperty('--button-font-size', buttonStyle.fontSize);
    }
    if (buttonStyle.textDecoration) {
      buttonDiv.style.setProperty('--button-text-decoration', buttonStyle.textDecoration);
    }

    // 创建按钮图标
    createButtonIcon(buttonDiv);

    const textSpan = document.createElement('span');
    textSpan.className = 'pify_button_text';
    textSpan.textContent = window.settings?.buttonText || 'Size Chart';
    buttonDiv.appendChild(textSpan);

    buttonDiv.addEventListener('click', function () {
    });

    container.appendChild(buttonDiv);
  });

  // Try to search for the product information container
  const productInfoContainers = document.querySelectorAll('.product__info-container');
  let visibleProductInfoContainer = null;
  for (const container of productInfoContainers) {
    if (isElementVisible(container)) {
      visibleProductInfoContainer = container;
      break;
    }
  }

  // If the target element has not been found yet, try to look for the "Buy it now" button.
  if (!targetElement) {
    const buyItNowButtons = document.querySelectorAll('button, input[type="submit"], a');
    for (const button of buyItNowButtons) {
      if (isElementVisible(button)) {
        const textContent = (button.textContent || '').toLowerCase();
        const value = (button.value || '').toLowerCase();

        if (textContent.includes('buy it now') || value.includes('buy it now') ||
          textContent.includes('buy now') || value.includes('buy now')) {
          targetElement = button;
          break;
        }
      }
    }
  }

  // If the target element has not been found, try to search for the titles that have the "product__title" class name.
  if (!targetElement) {
    const productTitleElements = document.querySelectorAll('.product__title, .product-title, h1.product__title, h1.product-title');
    for (const titleElement of productTitleElements) {
      if (isElementVisible(titleElement)) {
        targetElement = titleElement;
        break;
      }
    }
  }

  if (targetElement) {
    // Atlantic theme special handling
    if (themeName === 'atlantic' && targetElement.classList.contains('product-submit')) {
      targetElement.parentNode.insertBefore(container, targetElement);
      return;
    }

    // Satoshi theme special handling - insert outside the #product-actions container
    if (themeName === 'satoshi' && targetElement.id === 'product-actions') {
      targetElement.parentNode.insertBefore(container, targetElement);
      return;
    }

    // Lumia theme special handling - insert outside the row container
    if (themeName === 'lumia' && targetElement.classList.contains('row')) {
      targetElement.parentNode.insertBefore(container, targetElement);
      return;
    }

    // If the target element exists, use the new insertion logic
    const buttonContainer = findButtonContainer(targetElement, themeSelectors.containerSelectors);
    const parentElement = targetElement.parentElement;
    const grandParentElement = parentElement?.parentElement;

    if (position === 'above') {
      if (buttonContainer) {
        // If the button container is found, insert it above the container
        buttonContainer.parentNode.insertBefore(container, buttonContainer);
      } else if (parentElement) {
        // If there is a parent element, insert it above the parent element
        parentElement.parentNode.insertBefore(container, parentElement);
      } else if (grandParentElement) {
        // If there is a grandparent element, try to insert it into the grandparent element
        grandParentElement.insertBefore(container, parentElement);
      } else {
        // If there is no suitable parent element, insert it directly in front of the target element
        targetElement.parentNode.insertBefore(container, targetElement);
      }
    } else if (position === 'below') {
      if (buttonContainer) {
        // If the button container is found, insert it below the container
        buttonContainer.parentNode.insertBefore(container, buttonContainer.nextSibling);
      } else if (parentElement) {
        // If there is a parent element, insert it below the parent element
        parentElement.parentNode.insertBefore(container, parentElement.nextSibling);
      } else if (grandParentElement) {
        // If there is a grandparent element, try to insert it into the grandparent element
        grandParentElement.insertBefore(container, parentElement.nextSibling);
      } else {
        // If there is no suitable parent element, insert it directly behind the target element
        targetElement.parentNode.insertBefore(container, targetElement.nextSibling);
      }
    } else if (position === 'inside' && buttonContainer) {
      // If the position is inside and there is a button container
      buttonContainer.insertBefore(container, targetElement);
    } else {
      // Default behavior: insert it in front of the target element
      targetElement.parentNode.insertBefore(container, targetElement);
    }
  } else if (visibleProductInfoContainer) {
    // Only use the product information container as a fallback if no add to cart button is found
    visibleProductInfoContainer.appendChild(container);
  } else {
    // Collect container information on the page
    exceptionCollector.collect(
      'sizechart_button_placement',
      'Failed to find target element for size chart button placement'
    );
  }

  if (
    themeName === 'shella' &&
    targetElement.classList.contains('product-page-info__button-add-to-cart')
  ) {
    const w100 = targetElement.closest('.w-100');
    if (w100) {
      const dFlex = w100.closest('.d-flex');
      if (dFlex && dFlex.parentNode) {
        dFlex.parentNode.insertBefore(container, dFlex);
        return;
      }
    }
  }
}
// 浮动按钮
function applyFloatingToContainer() {
  // 为每个尺寸表创建按钮
  window.sizeChartData.forEach((sizeChart, index) => {
    if (!shouldDisplaySizeChart(sizeChart)) return;

    // 简化为单层结构，只保留pify_size_chart_button
    const buttonDiv = document.createElement('div');
    buttonDiv.className = 'pify_size_chart_button pify_floating_button';
    
    // 设置按钮的自定义属性，用于CSS样式应用
    const buttonStyle = window.settings?.floatingButton?.style || {};
    if (buttonStyle.backgroundColor) {
      buttonDiv.style.setProperty('--button-bg-color', buttonStyle.backgroundColor);
    }
    if (buttonStyle.color) {
      buttonDiv.style.setProperty('--button-text-color', buttonStyle.color);
    }
    if (buttonStyle.borderColor) {
      buttonDiv.style.setProperty('--button-border-color', buttonStyle.borderColor);
    }
    if (buttonStyle.borderRadius) {
      buttonDiv.style.setProperty('--button-border-radius', buttonStyle.borderRadius);
    }
    if (buttonStyle.borderWidth) {
      buttonDiv.style.setProperty('--button-border-width', buttonStyle.borderWidth);
    }
    if (buttonStyle.fontSize) {
      buttonDiv.style.setProperty('--button-font-size', buttonStyle.fontSize);
    }
    if (buttonStyle.textDecoration) {
      buttonDiv.style.setProperty('--button-text-decoration', buttonStyle.textDecoration);
    }

    // 添加图标
    if (window.settings?.buttonIcon && resolveImagePath(window.settings?.buttonIcon)) {
      const img = document.createElement('img');
      img.src = resolveImagePath(window.settings?.buttonIcon);
      img.className = 'pify_button_icon';
      buttonDiv.appendChild(img);
    }

    // 添加文本
    const textSpan = document.createElement('span');
    textSpan.className = 'pify_button_text';
    textSpan.textContent = window.settings?.buttonText || 'Size Chart';
    buttonDiv.appendChild(textSpan);

    // 添加点击事件

    // 直接将按钮添加到body，无需额外容器
    document.body.appendChild(buttonDiv);
  });

  // 设置浮动定位样式
  const applyPositionStyles = () => {
    const buttons = document.querySelectorAll('.pify_floating_button');
    const isMobile = window.innerWidth <= 768;
    const position = isMobile 
      ? (window.settings?.floatingButton?.mobileFloatingPosition || window.settings?.floatingButton?.floatingPosition || 'top-right')
      : (window.settings?.floatingButton?.floatingPosition || 'middle-right');
    
    buttons.forEach(button => {
      // 添加位置类名
      button.className = button.className.replace(/pify_position_\S+/g, '');
      button.classList.add(`pify_position_${position.replace('-', '_')}`);
      
      if (isMobile) {
        button.classList.add('pify_mobile');
        button.classList.remove('pify_desktop');
      } else {
        button.classList.add('pify_desktop');
        button.classList.remove('pify_mobile');
      }
    });
  };
  
  applyPositionStyles();
  
  // 添加窗口大小变化监听器，用于移动端和桌面端切换时重新应用样式
  const handleResize = () => {
    applyPositionStyles();
  };
  
  // 添加防抖处理，避免频繁触发
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 100);
  });
}

function addStyleSheet() {
  const styleSheet = document.createElement('style');
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  let styles = `
      .pify_inline_buttons_container {
        display: block;
        width: 100%;
        margin: 10px 0;
      }

      /* 浮动按钮样式 - 简化为单层结构 */
      .pify_floating_button {
        position: fixed;
        z-index: 9999;
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 12px;
        border-radius: var(--button-border-radius, 8px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        background: var(--button-bg-color, white);
        color: var(--button-text-color, #333);
        border: var(--button-border-width, 1px) solid var(--button-border-color, transparent);
        cursor: pointer;
        transition: all 0.3s ease;
        white-space: nowrap;
        font-size: var(--button-font-size, 14px);
      }

      .pify_floating_button:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        transform: translateY(-1px);
      }

      .pify_button_icon {
        width: calc(var(--button-font-size, 16px) * 1.2);
        height: calc(var(--button-font-size, 16px) * 1.2);
        background: none;
        border-radius: 0;
      }

      .pify_button_text {
        margin: 0;
        font-size: inherit;
        color: inherit;
        text-decoration: var(--button-text-decoration, none);
      }

      /* 位置样式 - 桌面端 */
      .pify_floating_button.pify_desktop.pify_position_top_right {
        position: fixed;
        top: 220px;
        right: -49px;
        transform: rotateZ(270deg);
        border-radius:  var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 0;
      }

      .pify_floating_button.pify_desktop.pify_position_middle_right {
        position: fixed;
        top: 50%;
        right: -49px;
        transform: translateY(-50%) rotateZ(270deg);
        border-radius: var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 0 ;
      }

      .pify_floating_button.pify_desktop.pify_position_bottom_right {
        position: fixed;
        bottom: 120px;
        right: -49px;
        transform: rotateZ(270deg);
        border-radius:  var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 0;
      }

      .pify_floating_button.pify_desktop.pify_position_top_left {
        position: fixed;
        top: 220px;
        left: -49px;
        transform: rotateZ(90deg);
        border-radius:  var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 0;
      }

      .pify_floating_button.pify_desktop.pify_position_middle_left {
        position: fixed;
        top: 50%;
        left: -49px;
        transform: translateY(-50%) rotateZ(90deg);
        border-radius: var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 0;
      }

      .pify_floating_button.pify_desktop.pify_position_bottom_left {
        position: fixed;
        bottom: 120px;
        left: -49px;
        transform: rotateZ(90deg);
        border-radius: var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 0 ;
      }

      /* 位置样式 - 移动端 */
      .pify_floating_button.pify_mobile.pify_position_top_right {
        position: fixed;
        top: 160px;
        right: -30px;
        transform: rotateZ(270deg);
        width:auto;
        padding: 0px 8px;
        border-radius: var(--button-border-radius, 15px) var(--button-border-radius, 15px) 0 0 ;
      }

      .pify_floating_button.pify_mobile.pify_position_top_left {
        position: fixed;
        top: 160px;
        left: -30px;
        transform: rotateZ(90deg);
        width:auto;
        padding: 0px 8px;
        border-radius:var(--button-border-radius, 8px) var(--button-border-radius, 8px) 0 0;
      }

      .pify_floating_button.pify_mobile.pify_position_bottom_right {
        position: fixed;
        bottom: 100px;
        right: -30px;
        transform: rotateZ(270deg);
        width:auto;
        padding: 0px 8px;
        border-radius:var(--button-border-radius, 8px) var(--button-border-radius, 8px) 0 0 ;
      }

      .pify_floating_button.pify_mobile.pify_position_bottom_left {
        position: fixed;
        bottom: 100px;
        left: -30px;
        transform: rotateZ(90deg);
        width:auto;
        padding: 0px 8px;
        border-radius:var(--button-border-radius, 8px) var(--button-border-radius, 8px) 0 0;
      }



      .pify_module_container {
        margin-bottom: 10px;
      }

      .pify_table_container {
        margin-bottom: 10px;
      }

      .pify_unit_container {
        display: inline-block;
        padding: 12px 0;
        text-align: left!important;
      }

      .pify_unit_label {
        display: flex;
        align-items: center;
        gap: 5px;
        cursor: pointer;
        color: rgb(35,35,35);
      }

      .tableModule {
        width: 100%;
        position: relative;
        overflow-y: auto;
        scrollbar-width: thin;
      }

      /* 内联按钮样式 - 与浮动按钮保持一致的设计 */
      .pify_inline_button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 16px;
        width: 160px;
        background-color: var(--button-bg-color, transparent);
        color: var(--button-text-color, #000000);
        border: var(--button-border-width, 1px) solid var(--button-border-color, transparent);
        border-radius: var(--button-border-radius, 6px);
        font-size: var(--button-font-size, 16px);
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        text-decoration: none;
        box-sizing: border-box;
        margin: 8px 0;
        text-align: center;
      }

      .pify_inline_button:hover {
        opacity: 0.9;
        transform: translateY(-1px);
      }

      .pify_inline_button .pify_button_icon {
        width: calc(var(--button-font-size, 16px) * 1.2);
        height: calc(var(--button-font-size, 16px) * 1.2);
        object-fit: contain;
        flex-shrink: 0;
      }

      .pify_inline_button .pify_button_text {
        font-size: inherit;
        color: inherit;
        font-weight: inherit;
        line-height: 1;
        text-decoration: var(--button-text-decoration, none);
      }

      .pify_size_table {
        width: 100%;
        border-collapse: collapse;
      }

      .pify_table_header {
        border: 1px solid #e1e3e5!important;
        background-color: #f6f6f7!important;
        font-weight: 600!important;
        text-align: center!important;
        min-width: 60px!important;
        height: 36px!important;
        vertical-align: middle;
      }

      .pify_table_cell {
        border: 1px solid #e1e3e5!important;
        text-align: center!important;
        min-width: 60px!important;
        height: 36px!important;
        line-height: 36px!important;
      }

      .pify_text_container {
        padding: 10px;
      }

      .pify_text_container h1 {
          font-size: 32px;
          font-weight: bold;
          margin: 0;
          color: #000!important;
      }

      .pify_text_container h2 {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
          color: #000!important;
      }

      .pify_text_container h3 {
          font-size: 24px;
          font-weight: bold;
          margin: 0;
          color: #000!important;
      }

      .pify_text_container h4 {
          font-size: 20px;
          font-weight: bold;
          margin: 0;
          color: #000!important;
      }

      .pify_text_container h5 {
          font-size: 18px;
          font-weight: bold;
          margin: 0;
          color: #000!important;
      }

      .pify_text_container h6 {
          font-size: 16px;
          font-weight: bold;
          margin: 0;
          color: #000!important;
      }

      .pify_text_container ul,
      .pify_text_container ol {
          padding-left: 2em;
          margin: 0.5em 0;
      }

      .pify_text_container ul {
          list-style: disc;
      }

      .pify_text_container ol {
          list-style: decimal;
      }

      .pify_text_container p {
          font-size: 16px;
          margin: 0;
          color: #000;
      }

      .pify_text_container em {
          font-style: italic;
      }

      .pify_text_container strong {
          font-weight: bold;
      }

      .pify_image_container {
        width: 100%;
        height: 380px;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .pify_image_container img{
        width: 100%;
        max-height: 100%;
        display: block;
        margin: 0px auto;
        object-fit: contain;
      }

      .pify_modal_overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }

      .pify_modal_content {
        background: white;
        padding: 20px;
        border-radius: 8px;
        max-width: 850px;
        width: 90%;
        max-height: 90vh;
        overflow-y: auto;
        position: relative;
        scrollbar-width: thin;
        color: #121212BF!important;
        font-size: 16px!important;
      }

      .pify_close_button {
        position: absolute;
        right: 10px;
        top: 10px;
        border: none;
        background: none;
        font-size: 18px;
        cursor: pointer;
        text-align: right;
        color: #000;
        --button-border-color: none;
      }

      .pify_tabs_container {
        display: flex;
        border-bottom: 2px solid #e1e3e5;
        margin-top: 10px;
      }

      .pify_tab {
        padding: 4px 8px;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
      }

      .pify_tab_active {
        border-bottom: 2px solid #000;
        margin-bottom: -2px;
        color: #000;
      }

      .pify_size_chart_button {
        cursor: pointer;
        position: relative;
        padding: 8px 0;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 140px;
        display:flex;
        justify-content: center;
      }



      .pify_unit_label input[type="radio"] {
        accent-color: #000;
        appearance: radio !important;
        min-height: 0!important;
        width: 16px!important;
        height: 16px!important;
        box-shadow: none!important;
        outline: none!important;
        position: relative;
        margin: 0;
      }
      
      .pify_table_header,
      .pify_table_cell {
        transition: background-color 0.2s, color 0.2s;
      }

      .pify_size_tooltip {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 10px;
        background-color: ${window.settings?.primaryInteractiveColor?.backgroundColor || 'rgba(0, 0, 0, 0.8)'};
        color: white;
        padding: 12px;
        border-radius: 4px;
        font-size: 14px;
        z-index: 1000;
        min-width: 160px;
        max-width: 250px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        pointer-events: none; /* 禁用鼠标事件，让点击穿透 */
        opacity: 0 !important;
        transition: all 0.2s ease-in-out;
        white-space: normal;
        display: block !important;
        visibility: visible !important;
      }

      .pify_size_tooltip::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid ${window.settings?.primaryInteractiveColor?.backgroundColor || 'rgba(0, 0, 0, 0.8)'};
      }

      label:hover .pify_size_tooltip,
      .bee-swatch__item:hover .pify_size_tooltip,
      .bee-swatch__item .pify_size_tooltip:hover {
        opacity: 1 !important;
      }

      .pify_tooltip_title {
        font-weight: bold;
        margin-bottom: 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        padding-bottom: 4px;
        text-align: center;
      }

      .pify_tooltip_row {
        margin: 4px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        text-align: center;
      }

      .size-details-table {
        width: 100%;
        border-collapse: collapse;
      }

      .size-details-table th,
      .size-details-table td {
        text-align: center;
        min-width: 68px;
        font-size: 14px;
        white-space: normal;
        padding: 6px 12px;
        color: #121212BF;
      }

      .size-details-table th {
        font-weight: 600;
      }

      .size-details-table td {
        color: #666;
      }

      .selected-size-row {
        background-color: #f6f6f7;
      }

      .selected-size-row td {
        color: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'};
        font-weight: 500;
      }

      .size-details-unit-container {
        display: flex;
        align-items: center;
      }

      .size-details-unit-label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 12px;
        background: #fff;
        border: 1px solid ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'};
        min-width: 40px;
        color: #121212BF;
      }

      .size-details-unit-label:first-child {
        border-right: none;
      }

      .size-details-unit-label input[type="radio"] {
        display: none;
      }

      .size-details-unit-label input[type="radio"]:checked + span {
        color: #fff;
      }

      .size-details-unit-label input[type="radio"]:checked ~ label {
        background: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'} !important;
      }

      .size-details-unit-label:has(input[type="radio"]:checked) {
        background: ${window.settings?.primaryInteractiveColor?.backgroundColor || '#333'} !important;
      }
    `;

  // 主题特定样式
  const themeStyles = {
    'pinnacle': `
        .product-form__input--block {
          overflow: visible !important;
        }

        .product-form__input--block label {
          overflow: visible !important;
        }
      `,
    'shine': `
        .product-option .js-variant-option-label {
          overflow: visible !important;
        }
      `,
    'nimbus': `
        .swatch-block {
          position: relative !important;
        }
        .swatch-block:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
        .variant-picker .swatch-block {
          overflow: visible !important;
        }
        .variant-picker .swatch-block label {
          position: relative !important;
          z-index: 1 !important;
        }
       @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 10px;
          min-width: 30px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
        
        /* 移动端浮动按钮样式优化 */
        .pify_floating_button.pify_mobile {
          padding: 6px 10px;
          border-radius: 6px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
          font-size: 14px;
          gap: 4px;
        }

        /* 移动端内联按钮样式优化 */
        .pify_inline_button {
          padding: 8px 12px;
          font-size: 13px;
          gap: 6px;
          margin: 6px 0;
          width: 140px;
          justify-content: center;
        }

        .pify_size_chart_button {
          width: 140px;
        }

        .pify_inline_button .pify_button_icon {
          width: calc(13px * 1.2);
          height: calc(13px * 1.2);
        }
      }
      `,
    'normcore': `
        .js-variant-option-label {
          overflow: visible !important;
        }
      `,
    'vision': `
        .product-form__input--block {
          overflow: visible !important;
        }

        .product-form__input--block label {
          overflow: visible !important;
        }
      `,
    'impulse': `
        .variant-input {
          overflow: visible !important;
        }

        .variant-input label{
          overflow: visible !important;
        }
      `,
    'motion': `
        .variant-input {
          overflow: visible !important;
        }

        .variant-input label{
          overflow: visible !important;
        }
      `,
    'luxe': `
        .radio-options-wrapper label{
          overflow: visible !important;
        }
      `,
    'roam': `
        .option-value:hover {
          overflow: visible;
        }
      `,
    'vantage': `
        .swatch-element label{
          overflow: visible !important;
        }
      `,
    'flawless': `
        .variant-pills-wrapper label{
          overflow: visible !important;
        }
      `,
    'kidu': `
        .product-card-variants .variant-row--pills {
          flex-wrap: wrap;
        }
      `,
    'creator': `
        .size-details-table th {
          color: #666;
        }
      `,
    'icon': `
        .swatches__swatch--regular label{
          overflow: visible !important;
        }

        .pify_modal_content .pify_close_button {
          width: 30px;
        }

        .pify_tooltip_row {
          height: 22px;
        }
      `,
    'fashionopolism': `
        .swatches__swatch--regular label{
          overflow: visible !important;
        }
      `,
    'wonder': `
        .f-button__list__item label{
          overflow: visible !important;
        }
      `,
    'gem': `
        .variant-button-wrap label{
          overflow: visible !important;
        }
      `,
    'honey': `
        .single-option-selector__option-wrap label{
          overflow: visible !important;
        }
      `,
    'fetch': `
        .variant-button-wrap label{
          overflow: visible !important;
        }
      `,
    'expanse': `
        .variant-button-wrap label{
          overflow: visible !important;
        }
      `,
    'streamline': `
        .variant-input label{
          overflow: visible !important;
        }
      `,
    'drop': `
        .swatches__swatch--regular label{
          overflow: visible !important;
        }
      `,
    'bespoke': `
        .option-value-rounded label{
          overflow: visible !important;
          position: relative !important;
          z-index: 1 !important;
        }
      `,
    'testament': `
        .pify_modal_content .pify_close_button {
          width: 30px;
        }
      `,
    'noire': `
        .size-details-table {
          table-layout: auto;
        }
      `,
    'paris': `
        .product-swatch-item {
          position: relative !important;
          overflow: visible !important;
        }
        .product-swatch-item:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'frame': `
        .single-option-selector__option-wrap label {
          overflow: visible !important;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 6px;
        }
      `,
    'master': `
        .variant-item {
          position: relative !important;
        }
        .variant-item:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'shark': `
        .variant-item {
          position: relative !important;
        }
        .variant-item:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'fame': `
        .variant_option {
          position: relative !important;
        }
        .variant_option:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'yuva': `
        .variant_option {
          position: relative !important;
        }
        .variant_option:hover .pify_size_tooltip {
          opacity: 1 !important;
          visibility: visible !important;
          display: block !important;
        }
      `,
    'eclipse': `
      .variant-option--chips button.chip {
        overflow: visible !important;
      }
    `,
    'showcase': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
      }
    `,
    'beyond': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
        font-size: 12px;
        min-width: 54px;
      }
    `,
    'king': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
        font-size: 12px;
        min-width: 66px;
      }
      .variant--item:hover .pify_size_tooltip {
        opacity: 1 !important;
        visibility: visible !important;
        display: block !important;
      }
    `,
    'xclusive': `
      #f8pr-ul-check-3{
        z-index: 49 !important;
      }
    `,
    'next': `
      #f8pr-ul-check-3{
        z-index: 99 !important;
      }
    `,
    'neat': `
        .size-details-table {
          table-layout: auto;
        }
    `,
    'urban': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 10px;
          min-width: 20px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
        .pify_table_header, .pify_table_cell {
          padding: 0 5px;
          white-space: nowrap;
        }
      }
    `,
    'etheryx': `
      .size-details-table th, .size-details-table td {
        padding: 6px 0;
        font-size: 12px;
        min-width: 42px;
      }
      .size-details-unit-label {
          min-width: 30px;
      }
    `,
    'borders': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 12px;
          min-width: 30px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
      }
    `,
    'boost': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 12px;
          min-width: 30px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 42px;
        }
      }
    `,
    'providence': `
      .size-details-unit-label {
        padding-bottom: 0;
      }
    `,
    'strong': `
      .size-details-table {
          table-layout: auto;
      }
    `,
    'editions': `
      .pify_unit_container {
        display: block;
      }
    `,
    'retina': `
      .size-details-table th, .size-details-table td {
        min-width: 58px;
        font-size: 12px;
        padding: 6px 0;
      }
    `,
    'emporium': `
      .size-details-table th, .size-details-table td {
        min-width: 62px;
        font-size: 12px;
        padding: 6px 0;
      }
    `,
    'sunrise': `
      .size-details-table th, .size-details-table td {
        min-width: 58px;
        font-size: 12px;
        padding: 6px 0;
      }
    `,
    'avenue': `
      .swatch-element .swatch-label.label:hover + label .pify_size_tooltip,
      .swatch-element:hover .pify_size_tooltip {
         opacity: 1 !important;
         visibility: visible !important;
         display: block !important;
      }
      .swatch .swatch-element .label {
          overflow: visible !important;
          position: relative;
      }
      .size-details-table th, .size-details-table td {
        font-size: 13px;
        padding: 6px 0;
      }

    `,
    'grid': `
      .size-details-table th, .size-details-table td {
        padding: 6px 8px;
      }
      .pify_unit_label {
        margin: 0;
      }
      .pify_table_header, .pify_table_cell {
        padding: 0;
      }
      .pify_size_table {
        margin-top: 0;
      }
    `,
    'iris': `
      @media (max-width: 768px) {
        .size-details-unit-label {
          font-size: 10px;
          min-width: 26px;
        }
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
          font-size: 12px;
          min-width: 54px;
        }
      }
    `,
    'kingdom': `
        .size-details-table th, .size-details-table td {
          padding: 6px 0;
        }
        .size-details-unit-container .size-details-unit-label input[type=radio]{
          display: none !important;
        }
    `,
    'zora': `
      .pify_unit_label input[type=radio]{
          display: block !important;
      }
    `,
    'modular': `
      .pify_size_tooltip {
          padding: 2px;
      }
    `,
    'masonry': `
        .size-details-table th, .size-details-table td {
          padding: 6px 4px;
        }
    `,
    'bazaar': `
      input[type=radio]:checked~.radio-label {
        pointer-events: auto !important;
      }
    `,
    'responsive': `
      .pify_modal_content .pify_close_button {
          width: 30px;
          padding: 0;
      }
      .pify_modal_content .pify_close_button:hover {
          background-color: transparent;
      }
    `,
    'highlight': `
      .pify_inline_buttons_container {
        margin-left: 10px;
      }
    `,
    'whisk': `
      .size-details-table {
        table-layout: auto;
      }
      .size-details-table th {
        white-space: nowrap;
      }
    `,
    'mojave': `
      .pify_inline_buttons_container {
        grid-column: 1 / -1;
      }
    `,
    'wpbingo': `
        .single-option-selector label{
          overflow: visible !important;
        }
    `,
    'electro theme': `
        .input-group {
          overflow: visible !important;
        }
    `,
    'lusion': `
      .pify_size_tooltip {
          padding: 2px;
      }
    `,
    'goodwin': `
      .size-list {
          overflow: visible !important;
      }
    `,
    'vegist': `
      .size-details-table th, .size-details-table td {
          padding: 6px 4px;
          font-size: 12px;
          min-width: 45px;
          white-space: nowrap;
      }
    `,
    'horizon': `
      .variant-option__button-label {
        overflow: visible !important;
      }
    `,
    'optimal': `
      .swatch-element label.size {
        overflow: visible !important;
      }
    `
  };

  // Add theme-specific styles
  if (themeName && themeStyles[themeName]) {
    styles += themeStyles[themeName];
  }

  if (window.settings && window.settings?.customCSS) {
    styles += window.settings?.customCSS;
  }

  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

// Initialize stylesheet function on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    addStyleSheet();
    initializeSizeChart();
      // 立即添加 Fit 选择器样式，确保在DOM准备好时就可用
    addFitSelectorStyles();
  });
} else {
  addStyleSheet();
  initializeSizeChart();
  addFitSelectorStyles();
}

function updateTableHighlight(table) {
  const hoveredRow = parseInt(table.dataset.hoveredRow);
  const hoveredCol = parseInt(table.dataset.hoveredCol);
  // 获取单元格hover背景颜色设置
  const hoverBackgroundColor = window.settings?.primaryInteractiveColor?.backgroundColor || window.settings?.appearance?.hoverBackgroundColor || 'rgb(51, 51, 51)';
  table.querySelectorAll('th, td').forEach(cell => {
    cell.style.backgroundColor = '';
    cell.style.color = '';
  });

  if (hoveredRow >= 0 && hoveredCol >= 0) {
    const hoveredCell = table.querySelector(`td[data-row-index= "${hoveredRow}"][data-col-index= "${hoveredCol}"]`);
    if (hoveredCell) {
      hoveredCell.style.setProperty('background-color', hoverBackgroundColor, 'important');
      hoveredCell.style.setProperty('color', 'white', 'important');
    }

    const headerCell = table.querySelector(`th[data-col-index="${hoveredCol}"]`);
    if (headerCell) {
      headerCell.style.setProperty('background-color', hoverBackgroundColor, 'important');
      headerCell.style.setProperty('color', 'white', 'important');
    }

    const rowHeader = table.querySelector(`td[data-row-index= "${hoveredRow}"][data-col-index="0"]`);
    if (rowHeader) {
      rowHeader.style.setProperty('background-color', hoverBackgroundColor, 'important');
      rowHeader.style.setProperty('color', 'white', 'important');
    }
  }
}

function hasAddToCartText(element) {
  const textContent = (element.textContent || '').toLowerCase();
  const value = (element.value || '').toLowerCase();

  // Use regex to match
  const cartTextRegex = /(add\s+to\s+(cart|bag|basket)|purchase|buy\s+now|pre-?order)/i;
  if (cartTextRegex.test(textContent) || cartTextRegex.test(value)) {
    return true;
  }

  // Check data attributes
  const dataAttributes = [
    'data-add-to-cart-text',
    'data-button-text',
    'data-atc-text',
    'data-product-button',
    'data-text-add-to-cart',
    'data-add_to_cart'
  ];

  return dataAttributes.some(attr => {
    const attrValue = element.getAttribute(attr);
    return attrValue && cartTextRegex.test(attrValue);
  });
}

function isInAddToCartForm(element) {
  const form = element.closest('form');
  if (!form) return false;

  const formAction = form.getAttribute('action') || '';
  return formAction.includes('/cart/add') ||
    form.querySelector('[name="add"]') !== null ||
    form.id.toLowerCase().includes('add-to-cart') ||
    form.className.toLowerCase().includes('add-to-cart');
}

// Add size selector tooltip functionality
function addSizeSelectorTooltip() {
  // addSizeSelectorTooltip function called
  
  const isProductPage = true;
  // Check if current page is product page
  if (!isProductPage) return;

  if (!window.sizeChartData || !Array.isArray(window.sizeChartData)) {
    // No sizeChartData available
    return;
  }

  // Check if any size chart should be displayed based on targeting configuration
  const hasDisplayableSizeChart = window.sizeChartData.some(sizeChart => shouldDisplaySizeChart(sizeChart));
  // Check if has displayable size chart
  if (!hasDisplayableSizeChart) {
    return;
  }

  // Get current theme name
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase();
  // Get theme name

  // Themes that should skip tooltip functionality
  const skipTooltipThemes = [
    'infinity',
    'refine',
    'debut',
    'startup',
    'next',
    'xclusive',
    'xtra',
    'forge',
    'electro',
    'amber',
    'erickson',
    'retina',
    'emporium',
    'parallax',
    'responsive',
    'nostalgia',
    'lumin',
    'woodstock',
    'highlight',
    'marble',
    'etheryx',
    'aisle',
    'futurer',
    'redefine',
    'madrid',
    'space',
    'paper',
    'warehouse',
    'zest',
    'showtime',
    'eclipse',
    'vincent',
    'aurora',
    'pursuit',
    'ascension',
    'pinnacle',
    'borders',
    'vision',
    'bullet',
    'creative',
    'venue',
    'blockshop',
    'canopy',
    'sahara',
    'keystone',
    'satoshi',
    'local',
    'showcase'
  ];

  // Skip functionality for specified themes
  if (skipTooltipThemes.includes(themeName)) {
    exceptionCollector.collect(
      'Not compatible with the theme',
      `Tooltip functionality skipped for theme: ${themeName} (intentionally disabled for compatibility)`
    );
    return;
  }

  // Get current theme selectors
  const themeSelectors = getCurrentThemeSelectors();
  // Get theme selectors

  // Get custom size selector patterns from settings (priority)
  const customSizeSelectorCss = window.settings?.sizeSelector;
  // Get custom size selector CSS
  let sizeSelectorPatterns = [];

  // 1. Try custom selectors first
  if (customSizeSelectorCss && customSizeSelectorCss.trim()) {
    // Split by comma and clean up
    sizeSelectorPatterns = customSizeSelectorCss.split(',').map(s => s.trim()).filter(s => s.length > 0);
    // Using custom sizeSelectorPatterns
  } else {
    // No custom size selector patterns found
  }

  // 2. If no custom selectors or no elements found, use theme selectors
  let potentialSelectors = [];

  if (sizeSelectorPatterns.length > 0) {
    // Searching with custom patterns
    for (const pattern of sizeSelectorPatterns) {
      try {
        const elements = document.querySelectorAll(pattern);
        // Pattern search result
        if (elements.length > 0) {
          potentialSelectors = potentialSelectors.concat(Array.from(elements));
        }
      } catch (error) {
        // Error with pattern search
      }
    }
  }

  // 3. If custom selectors didn't find anything, fallback to theme selectors
  if (potentialSelectors.length === 0) {
    // Fallback to theme selectors
    sizeSelectorPatterns = themeSelectors.sizeSelectorPatterns;
    // Theme sizeSelectorPatterns
    for (const pattern of sizeSelectorPatterns) {
      const elements = document.querySelectorAll(pattern);
      // Theme pattern search result
      if (elements.length > 0) {
        potentialSelectors = potentialSelectors.concat(Array.from(elements));
      }
    }
  }

  // Remove duplicates: if the same element is matched by multiple patterns
  potentialSelectors = [...new Set(potentialSelectors)];
  // Special handling for XO theme dropdown structure
  const xoSelectors = document.querySelectorAll('xo-popover[xo-name*="filter-select-custom-Size"], .xo-field-select-custom__popover');
  if (xoSelectors.length > 0) {
    potentialSelectors = potentialSelectors.concat(Array.from(xoSelectors));
  }

  // Potential selectors found
  
  if (potentialSelectors.length === 0) {
    // Collect compatibility anomaly information - No size selectors were found
    exceptionCollector.collect(
      'sizechart_tooltip_selectors',
      'Failed to find size selector elements for tooltip functionality'
    );
    // No potential selectors found, attempting to find any size-related elements
    
    // 尝试查找任何包含尺码相关文本的元素
    const sizeKeywords = ['size', 'Size', 'SIZE', 'taille', 'talla', 'größe', 'サイズ', '尺寸', '尺码'];
    const allElements = document.querySelectorAll('*');
    const sizeRelatedElements = [];
    
    allElements.forEach(el => {
      const text = el.textContent || '';
      const className = el.className || '';
      const id = el.id || '';
      const dataAttrs = Array.from(el.attributes).map(attr => attr.name + '=' + attr.value).join(' ');
      
      if (sizeKeywords.some(keyword => 
        text.includes(keyword) || 
        className.includes(keyword) || 
        id.includes(keyword) ||
        dataAttrs.includes(keyword)
      )) {
        sizeRelatedElements.push({
          tagName: el.tagName,
          className: el.className,
          id: el.id,
          textContent: el.textContent?.substring(0, 50),
          outerHTML: el.outerHTML?.substring(0, 200)
        });
      }
    });
    
    // Found size-related elements
    
    // 尝试查找常见的表单元素
    const formElements = document.querySelectorAll('select, input[type="radio"], input[type="checkbox"], button, label');
    const formElementsInfo = Array.from(formElements).slice(0, 20).map(el => ({
      tagName: el.tagName,
      type: el.type,
      className: el.className,
      id: el.id,
      name: el.name,
      value: el.value,
      textContent: el.textContent?.substring(0, 30)
    }));
    
    // Found form elements
    
    return;
  }

  // 2. Filter out real size selectors

  const sizeSelectors = potentialSelectors.filter(selector => {
    if (themeName === 'wokiee') {
      if (selector.classList.contains('tt-wrapper')) {
        const titleElement = selector.querySelector('.tt-title-options');
        if (titleElement) {
          const titleText = titleElement.textContent.trim().toLowerCase();
          if (titleText.includes('size') || titleText.includes('尺寸')) {
            return true;
          }
        }
        const sizeLinks = selector.querySelectorAll('li a[data-value]');
        if (sizeLinks.length > 0) {
          const sizeValues = Array.from(sizeLinks).map(link => link.getAttribute('data-value'));
          const sizePatterns = [
            /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,
            /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,
            /^\d+$/,
            /^\d+[A-Z]?$/i,
            /^\d+\.\d+$/,
            /^\d+\/\d+$/,
            /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i
          ];

          let sizeCount = 0;
          sizeValues.forEach(value => {
            if (sizePatterns.some(pattern => pattern.test(value))) {
              sizeCount++;
            }
          });

          if (sizeCount / sizeValues.length >= 0.5) {
            return true;
          }
        }
      }
    }

    if (themeName === 'kalles' || themeName === 'unsen') {
      if (selector.querySelector('.t4s-swatch__item')) {
        return true;
      }
    }

    // Special handling for Unero theme
    if (themeName === 'unero') {
      if (selector.classList.contains('tawcvs-swatches') ||
        selector.querySelector('span.swatch[data-value]')) {
        return true;
      }
    }

    if (themeName === 'takeout') {
      if (selector.classList.contains('product-form__input--dropdown') ||
        selector.querySelector('.select__select') ||
        selector.closest('.product-form__input--dropdown') ||
        selector.tagName !== 'FIELDSET') {
        return false;
      }
    }

    if (themeName === 'carbon') {
      if (selector.classList.contains('product-form__input--dropdown') ||
        selector.querySelector('.select__select') ||
        selector.closest('.product-form__input--dropdown') ||
        !selector.classList.contains('product-form__input-wrapper')) {
        return false;
      }
    }

    // Check if element is visible
    const style = window.getComputedStyle(selector);

    // Improved visibility detection - relaxed conditions, consider custom dropdown structures
    // Even if the element itself appears "hidden", if it is a select element or contains a select element, we consider it visible
    const isSpecialDropdown = selector.tagName === 'SELECT' ||
      selector.querySelector('select') !== null;

    const isVisible = (style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      selector.offsetWidth > 0 &&
      selector.offsetHeight > 0) || isSpecialDropdown;

    if (!isVisible) {
      return false;
    }

    // Exclude quantity selectors
    if (selector.closest('.product-form__quantity')) {
      return false;
    }

    // Check if it's a size selector
    const legend = selector.querySelector('legend');
    const label = selector.querySelector('.form__label, .variant-swatches-text, .option-name, .variant-title, .radio__legend__label, .variant__label, .option-label');
    const radioInput = selector.querySelector('input[type="radio"][name="Size"], input[type="radio"][name*="Size"], input[type="radio"][name*="product-size"], input[type="radio"][name="size"], input[type="radio"][name*="size-option"]');
    const optionName = selector.querySelector('.option-name, .variant-title, .variant__label');
    const optionValue = selector.querySelector('.option-value, .variant-value');

    // Check if it's a color selector
    const isColorSelector =
      (optionName && optionName.textContent.toLowerCase().includes('color')) ||
      (optionValue && optionValue.textContent.toLowerCase().includes('color')) ||
      (label && label.textContent.toLowerCase().includes('color')) ||
      (legend && legend.textContent.toLowerCase().includes('color')) ||
      selector.classList.contains('color-swatch') ||
      selector.classList.contains('color-option') ||
      selector.classList.contains('color-selector') ||
      selector.getAttribute('data-option-name')?.toLowerCase().includes('color') ||
      selector.getAttribute('data-option')?.toLowerCase().includes('color');

    if (isColorSelector) {
      return false;
    }

    const isSelectWithSizeName = selector.tagName === 'SELECT' &&
      ((selector.name || '').toLowerCase().includes('size') ||
        (selector.id || '').toLowerCase().includes('option') ||
        (selector.id || '').toLowerCase().includes('single-option-form'));
    const hasSelectWithSizeName = selector.querySelector('select[name*="Size"], select[name*="size"], select[id*="option"], select[id*="single-option-form"]') !== null;

    // Check if it's a size selector
    const isSizeSelector =
      isSelectWithSizeName ||
      hasSelectWithSizeName ||
      (legend && legend.textContent.trim().toLowerCase().includes('size')) ||
      (label && label.textContent.trim().toLowerCase().includes('size')) ||
      selector.id.includes('Size') ||
      selector.id.includes('size') ||
      selector.classList.contains('variant-dropdown') ||
      selector.classList.contains('variant-selector-card') ||
      selector.classList.contains('select-size') ||
      selector.classList.contains('swatch-element') ||
      selector.classList.contains('option-selector__btns') ||
      selector.classList.contains('size__option') ||
      selector.classList.contains('block-swatch') ||
      selector.classList.contains('product-options__default') ||
      selector.classList.contains('options-selection__option-value') ||
      selector.classList.contains('BlockSwatchWrapper') ||
      selector.getAttribute('data_options') === 'Size' ||
      selector.querySelector('.quantity_box.quantity_num.option-swatch[data-option-name="SIZE"]') !== null ||
      radioInput !== null ||
      (selector.querySelector('.field-wrap-inner') && selector.querySelector('input[type="radio"][name="Size"]')) ||
      (selector.classList.contains('radio__container') && selector.querySelector('input[type="radio"][data-option="Size"]')) ||
      selector.classList.contains('radios--container') ||
      (selector.classList.contains('variant--item') && selector.querySelector('.variant-item-name')) ||
      (selector.classList.contains('variant-item')) ||
      (selector.classList.contains('inline-field-wrapper') && selector.querySelector('.input-field-title')?.textContent.toLowerCase().includes('size')) ||
      selector.classList.contains('variant_option') ||
      selector.classList.contains('variant-picker__option-values') ||
      selector.classList.contains('swatches-list-item') ||
      (selector.classList.contains('variantPickerButtonsWrap') && selector.querySelectorAll('.optionBtns').length > 0) ||
      (selector.classList.contains('options-frame') && selector.querySelectorAll('a.swatch.not-color').length > 0) ||
      (selector.classList.contains('product__color-chips') && selector.querySelectorAll('.product__chip').length > 0) ||
      (selector.classList.contains('product-form__chip-wrapper') && selector.querySelectorAll('.product-form__chip').length > 0) ||
      selector.classList.contains('option-group__chips-container') ||
      selector.classList.contains('product-variant-picker__pill-list') ||
      (selector.classList.contains('check') && !selector.closest('.mega-menu-content')) ||
      selector.classList.contains('input-select__select') ||
      (selector.getAttribute('data-property') === 'size' && selector.querySelectorAll('[data-value]').length > 0) ||
      (selector.classList.contains('product-options__section') && selector.querySelectorAll('[data-value]').length > 0) ||
      selector.classList.contains('swt-type-button') ||
      selector.classList.contains('variants__options') ||
      selector.classList.contains('swatch-group_inner') ||
      selector.classList.contains('selector-wrapper') ||
      selector.querySelector('.option-item[data-option="size"]') ||
      selector.classList.contains('bee-swatch') ||
      selector.classList.contains('bee-swatch__item') ||
      selector.classList.contains('bee-product-sizes');

    return isSizeSelector;
  });

  if (sizeSelectors.length === 0) {
    // Collect compatibility anomaly information - Found potential selectors but none passed size selector filtering
    const selectorInfo = customSizeSelectorCss && customSizeSelectorCss.trim()
      ? `Custom selectors used: ${customSizeSelectorCss}`
      : 'Using default theme selectors';

    exceptionCollector.collect(
      'sizechart_tooltip_filtering',
      `Found potential selectors but none passed size selector filtering. ${selectorInfo}. Found ${potentialSelectors.length} potential elements.`
    );
    return;
  }

  // 3. Get size chart data
  const sizeChartData = window.sizeChartData;
  let sizeInfo = {};
  let sizeInfoUnit = 'cm'; // Default unit
  let sizeOrder = []; // Add array to maintain original order

  if (sizeChartData && sizeChartData.length > 0) {
    // Find the appropriate size chart for current product
    let targetSizeChart = null;

    // First, try to find a size chart that should be displayed for current product
    for (const sizeChart of sizeChartData) {
      if (shouldDisplaySizeChart(sizeChart)) {
        targetSizeChart = sizeChart;
        break;
      }
    }

    // If no specific size chart found for current product, fallback to first one
    if (!targetSizeChart) {
      targetSizeChart = sizeChartData[0];
    }

    if (targetSizeChart?.settings?.blocks) {
      targetSizeChart.settings.blocks.forEach(block => {
        if (block.modules) {
          block.modules.forEach(module => {
            if (module.type === 'table' && module.content?.headers && module.content?.tableData) {
              const headers = module.content.headers;
              const tableData = module.content.tableData;
              const unit = module.content.unit || 'cm'; // Get unit from module content
              const sizeColumnIndex = 0;

              // Save the unit from the first table module
              if (Object.keys(sizeInfo).length === 0) {
                sizeInfoUnit = unit;
              }

              tableData.forEach(row => {
                const sizeName = row[headers[sizeColumnIndex]];
                if (sizeName) {
                  const measurements = {};
                  headers.forEach((header, index) => {
                    if (index > 0) {
                      measurements[header] = row[header];
                    }
                  });
                  sizeInfo[sizeName] = measurements;
                  // Add to sizeOrder array to maintain original order
                  sizeOrder.push(sizeName);
                }
              });
            }
          });
        }
      });
    }
  }

  // Add unit information to sizeInfo for global access
  if (Object.keys(sizeInfo).length > 0) {
    sizeInfo._unit = sizeInfoUnit;
    sizeInfo._sizeOrder = sizeOrder; // Add size order array to sizeInfo
  }

  if (Object.keys(sizeInfo).length === 0) {
    // Collect compatibility anomaly information - No size information data found
    const sizeChartInfo = {
      hasSizeChartData: !!sizeChartData,
      sizeChartDataLength: sizeChartData ? sizeChartData.length : 0,
      firstSizeChartStructure: null
    };

    if (sizeChartData && sizeChartData.length > 0) {
      const firstChart = sizeChartData[0];
      sizeChartInfo.firstSizeChartStructure = {
        hasSettings: !!firstChart.settings,
        hasBlocks: !!firstChart.settings?.blocks,
        blocksLength: firstChart.settings?.blocks?.length || 0,
        blockTypes: firstChart.settings?.blocks?.map(block => ({
          hasModules: !!block.modules,
          modulesLength: block.modules?.length || 0,
          moduleTypes: block.modules?.map(module => module.type) || []
        })) || []
      };
    }

    exceptionCollector.collect(
      'sizechart_tooltip_data',
      'Failed to extract size information from size chart data'
    );

    return;
  }

  // 4. Create size details display area for each size selector
  let existingSizeDetails = document.querySelector('.pify_size_details_container');
  if (!existingSizeDetails) {
    existingSizeDetails = document.createElement('div');
    existingSizeDetails.className = 'pify_size_details_container';
    existingSizeDetails.style.margin = '10px 0';
    existingSizeDetails.style.display = 'none';

    if (themeName === 'handy') {
      const firstSwtContainer = document.querySelector('.swt-container');
      if (firstSwtContainer && firstSwtContainer.parentNode) {
        firstSwtContainer.parentNode.insertBefore(existingSizeDetails, firstSwtContainer.nextSibling);
      }
    } else {
      // Filter out color selectors, make sure we only process size selectors
      const realSizeSelectors = sizeSelectors.filter(selector => {
        const isColorRelated =
          selector.closest('.color-option') ||
          selector.closest('.color-circle') ||
          selector.closest('.variants-image') ||
          selector.classList.contains('color-option') ||
          selector.classList.contains('color-circle') ||
          selector.querySelector('[data-pallet-color]') ||
          selector.querySelector('[style*="--swatch_color"]');

        if (isColorRelated) return false;

        // Additional check for dropdown selectors - ensure they are actually size selectors
        if (isSelect(selector)) {
          const select = selector.tagName.toLowerCase() === 'select' ? selector : selector.querySelector('select');
          if (select) {
            const selectName = select.getAttribute('name') || '';
            const isActualSizeSelector = selectName.toLowerCase().includes('size');

            // Also check the label text
            let labelText = '';
            const label = selector.querySelector('.form__label, .variant-swatches-text, .option-name, .variant-title');
            if (label) {
              labelText = label.textContent.trim().toLowerCase();
            }

            const isSizeSelectorByLabel = labelText.includes('size');

            // New: Check if it's a size selector by analyzing option values
            let isSizeSelectorByOptions = false;
            const options = select.querySelectorAll('option');
            if (options.length > 0) {
              // Common size patterns
              const sizePatterns = [
                /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,  // Standard letter sizes
                /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,   // Extended letter sizes
                /^\d+$/,                           // Numeric sizes (32, 34, 36, etc.)
                /^\d+[A-Z]?$/i,                    // Numeric with letter (32R, 34L, etc.)
                /^\d+\.\d+$/,                      // Decimal sizes (8.5, 9.5, etc.)
                /^\d+\/\d+$/,                      // Fraction sizes (1/2, 3/4, etc.)
                /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i  // One size fits all
              ];

              let sizeOptionCount = 0;
              options.forEach(option => {
                const value = option.value.trim();
                const text = option.textContent.trim();

                // Skip empty options
                if (!value || !text) return;

                // Check if value or text matches size patterns
                const matchesPattern = sizePatterns.some(pattern =>
                  pattern.test(value) || pattern.test(text)
                );

                if (matchesPattern) {
                  sizeOptionCount++;
                }
              });

              // If more than half of the options look like sizes, consider it a size selector
              const validOptions = Array.from(options).filter(opt => opt.value.trim() && opt.textContent.trim());
              if (validOptions.length > 0 && sizeOptionCount / validOptions.length >= 0.5) {
                isSizeSelectorByOptions = true;
              }
            }

            return isActualSizeSelector || isSizeSelectorByLabel || isSizeSelectorByOptions;
          }
        }

        return true;
      });

      // Use the filtered array of real size selectors
      const selectorToUse = realSizeSelectors.length > 0 ?
        realSizeSelectors[realSizeSelectors.length - 1] : sizeSelectors[0];

      // Unified handling for all themes
      const parentElement = selectorToUse.parentElement;
      if (parentElement) {
        // If there is a parent element, insert after the parent element
        parentElement.parentNode.insertBefore(existingSizeDetails, parentElement.nextSibling);
      } else {
        // If there is no parent element, insert after the selector
        selectorToUse.parentNode.insertBefore(existingSizeDetails, selectorToUse.nextSibling);
      }
    }
  }

  // Final sizeSelectors to process
  
  sizeSelectors.forEach((selector, index) => {
    // Processing selector
    
    // First check for specific selector structure
    if (isSelect(selector)) {
      // Handling as select dropdown
      // Handle dropdown
      handleSelectSizeSelector(selector, sizeInfo, existingSizeDetails);
      return;
    } else if (selector.querySelector('.product-option-picker__list-item')) {
      // Handling as li+div structure with handleLiSizeSelector
      // Handle li+div structure
      handleLiSizeSelector(selector, sizeInfo, existingSizeDetails);
      return;
    } else if (selector.tagName === 'XO-POPOVER' || selector.classList.contains('xo-field-select-custom__popover')) {
      // Handling as XO theme dropdown
      // Handle XO theme special dropdown structure
      handleXoFieldSelectCustom(selector, sizeInfo, existingSizeDetails);
      return;
    }
    // Process different structures according to theme name
    switch (themeName) {
      case 'andaman':
        // Handle Andaman theme size selector - process a + span structure
        handleAndamanSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles <a class="swatch"> + <span> structure
        break;
      case 'modules':
      case 'spark':
      case 'lorenza':
      case 'cornerstone':
      case 'stiletto':
        // Handle button-style size selector - applicable to multiple themes
        handleButtonSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles button-style selectors <div class="optionBtns"> or <div class="product__chip"> structure
        break;

      case 'eclipse':
        // Handle Eclipse theme size selector - process label > input+button structure
        handleChipSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles chip-style selectors <label class="variant-option--chips"> > <input type="radio"> + <button class="chip"> structure
        break;

      case 'aurora':
        // Handle pill style selector - label + span structure
        handlePillSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles pill-style selectors <label class="pill"> > <span class="pill__label"> structure
        break;

      case 'showcase':
        // Handle Showcase theme clickyboxes structure - process li + a structure
        handleClickyboxesSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles clickyboxes structure <ul> > <li> > <a data-value=""> structure
        break;

      case 'xtra':
        // Handle xtra theme special structure
        handleXtraSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles special structure <li> > <input type="radio" title="Default / M"> + <label> structure
        break;

      case 'momentum':
        // Handle custom dropdown menu - button + ul structure
        handleCustomDropdownSelector(selector, sizeInfo, existingSizeDetails);
        // Handles custom dropdown menu <button> + <ul role="listbox"> > <li data-option-value=""> structure
        break;

      case 'kalles':
        handleKallesSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Kalles theme structure <div class="t4s-swatch__item" data-value=""> structure
        break;

      case 'unsen':
        handleKallesSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Reuses Kalles structure handling
        break;

      case 'shella':
        handleShellaSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Shella theme structure <div class="product-options__value" data-value=""> structure
        break;

      case 'umino':
        handleUminoSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Umino theme structure <div class="bls__option-swatch" data-value=""> structure
        break;

      case 'venedor':
        // Handle Venedor theme size selector - process label structure without radio buttons
        handleVenedorSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Venedor theme structure <label class="option-label" data-value=""> structure (no radio buttons)
        break;

      case 'vinova modamate':
        // Handle Vinova Modamate theme size selector - process fieldset.product-variant-form-input structure
        handleVinovaModamateSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Vinova Modamate theme structure <fieldset> > <div class="product-single__variant-item"> > <input type="radio"> + <label> structure
        break;

      case 'foxic':
        // Handle Foxic theme size selector - process div.prd-size structure
        handlePrdSizeListSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Foxic theme structure <div class="prd-size"> > <ul class="size-list"> > <li> > <a data-value=""> structure
        break;

      case 'goodwin':
        // Handle Goodwin theme size selector - process div.prd-size structure with hidden select
        handlePrdSizeListSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Goodwin theme structure <div class="prd-size"> > <ul class="size-list"> > <li> > <a data-value=""> structure
        break;

      case 'corano':
        // Handle Corano theme size selector - process swatch structure without hover tooltips
        handleCoranoSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Corano theme structure <div class="swatch"> > <div class="swatch-element"> > <input type="radio"> + <label> structure
        break;

      case 'lusion':
        // Handle Lusion theme size selector - process div.selector-wrapper structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Lusion theme structure <div class="selector-wrapper"> > <div class="swatch"> > <span class="option-item" data-value=""> structure
        break;

      case 'lusion-fashion-women':
        // Handle Lusion theme size selector - process div.selector-wrapper structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Lusion theme structure <div class="selector-wrapper"> > <div class="swatch"> > <span class="option-item" data-value=""> structure
        break;

      case 'eva':
        // Handle Eva theme size selector - process span.swatch structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Reuses Lusion structure handling but uses <span class="swatch" data-value=""> structure
        break;

      case 'unero':
        // Handle Unero theme size selector - process span.swatch structure
        handleLusionSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Reuses Lusion structure handling but uses <span class="swatch" data-value=""> structure
        break;
        
      case 'nitro':
        // Handle Nitro theme size selector - process bee-swatch structure
        handleBeeSwatchSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Nitro theme structure <div class="bee-swatch"> > <div class="bee-swatch__item" data-value=""> structure
        break;

      case 'lumia':
        // Handle lumia theme size selector - process prd-option-list structure
        handlePrdOptionListSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles lumia theme structure <fieldset class="prd-option-list"> > <label class="label-radio"> > <input type="radio"> + <span> structure
        break;

      case 'wokiee':
        // Handle Wokiee theme size selector - process tt-wrapper structure
        handleWokieeSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles Wokiee theme structure <div class="tt-wrapper"> > <ul class="tt-options-swatch"> > <li> > <a data-value=""> structure
        break;

      default:
        // Handle traditional radio+label structure
        handleRadioSizeSelector(selector, sizeInfo, existingSizeDetails);
        // Handles traditional radio button structure <fieldset> > <input type="radio"> + <label for=""> structure
        break;
    }
  });

  // Apply theme-specific fixes using the helper function
  const themesWithPositionFixes = ['proto', 'electro theme', 'elomus', 'corano', 'lezada os 2.0', 'learts - shopify theme '];
  themesWithPositionFixes.forEach(theme => {
    if (themeName === theme) {
      fixSizeDetailsPosition(themeName, null, sizeInfo, existingSizeDetails);
    }
  });
}

function isSelect(selector) {
  if (selector.tagName === 'SELECT') {
    return true;
  }
  // 1. Check if there is a visible select element
  const select = selector.querySelector('select');
  if (!select) return false;

  // 2. Check if select is hidden
  const style = window.getComputedStyle(select);
  if (style.display === 'none' ||
    style.visibility === 'hidden' ||
    select.classList.contains('hidden') ||
    select.hasAttribute('hidden')) {
    return false;
  }

  // 3. Check if there is a radio element
  const hasRadio = selector.querySelector('input[type="radio"]') !== null;
  if (hasRadio) return false;

  // 4. Check if there is a custom dropdown style class
  const hasCustomSelectClass = selector.classList.contains('styled-pills-radio') ||
    selector.classList.contains('custom-select') ||
    selector.classList.contains('styled-select');
  if (hasCustomSelectClass) return false;

  return true;
}

// Handle dropdown size selector
function handleSelectSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  const select = selector.tagName.toLowerCase() === 'select' ?
    selector :
    selector.querySelector('select');

  if (!select || select.dataset.pifyProcessed === 'true') return;
  select.dataset.pifyProcessed = 'true';

  // Check if this is actually a size selector by checking the name attribute or label
  const selectName = select.getAttribute('name') || '';
  const isActualSizeSelector = selectName.toLowerCase().includes('size');

  // Also check the label text to confirm it's a size selector
  let labelText = '';
  const label = selector.querySelector('.form__label, .variant-swatches-text, .option-name, .variant-title');
  if (label) {
    labelText = label.textContent.trim().toLowerCase();
  }

  const isSizeSelectorByLabel = labelText.includes('size');

  // New: Check if it's a size selector by analyzing option values
  let isSizeSelectorByOptions = false;
  const options = select.querySelectorAll('option');
  if (options.length > 0) {
    // Common size patterns
    const sizePatterns = [
      /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,  // Standard letter sizes
      /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,   // Extended letter sizes
      /^\d+$/,                           // Numeric sizes (32, 34, 36, etc.)
      /^\d+[A-Z]?$/i,                    // Numeric with letter (32R, 34L, etc.)
      /^\d+\.\d+$/,                      // Decimal sizes (8.5, 9.5, etc.)
      /^\d+\/\d+$/,                      // Fraction sizes (1/2, 3/4, etc.)
      /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i  // One size fits all
    ];

    let sizeOptionCount = 0;
    options.forEach(option => {
      const value = option.value.trim();
      const text = option.textContent.trim();

      // Skip empty options
      if (!value || !text) return;

      // Check if value or text matches size patterns
      const matchesPattern = sizePatterns.some(pattern =>
        pattern.test(value) || pattern.test(text)
      );

      if (matchesPattern) {
        sizeOptionCount++;
      }
    });

    // If more than half of the options look like sizes, consider it a size selector
    const validOptions = Array.from(options).filter(opt => opt.value.trim() && opt.textContent.trim());
    if (validOptions.length > 0 && sizeOptionCount / validOptions.length >= 0.5) {
      isSizeSelectorByOptions = true;
    }
  }

  // Only proceed with container repositioning if this is actually a size selector
  if (!isActualSizeSelector && !isSizeSelectorByLabel && !isSizeSelectorByOptions) {
    return;
  }

  // Ensure select element has correct positioning
  const selectParent = select.parentNode;
  if (window.getComputedStyle(selectParent).position === 'static') {
    selectParent.style.position = 'relative';
  }

  // Create a hover tooltip for the dropdown
  const tooltip = document.createElement('div');
  tooltip.className = 'pify_size_tooltip';
  tooltip.style.opacity = '0';
  tooltip.style.display = 'none';
  selectParent.appendChild(tooltip);

  // Modify: Move the size details container after the entire selector container
  // Find the entire selector container - determine selector based on theme name
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  let selectorString;
  switch (themeName) {
    case 'sunrise':
      selectorString = '.variant-picker';
      break;
    case 'emporium':
      selectorString = '.options-selection__select-wrapper';
      break;
    case 'grid':
      selectorString = '.product-options';
      break;
    case 'berlin':
    case 'sydney':
      selectorString = '.product-parameters__item';
      break;
    case 'handmade':
      selectorString = '.product-form__wrapper';
      break;
    case 'exhibit':
      selectorString = '.product-variant-picker-block';
      break;
    case 'mojave':
      selectorString = '.main-product__form-input';
      break;
    case 'swipe':
      selectorString = '.product-form__controls';
      break;
    default:
      selectorString = '.product-form__input';
  }

  // Ensure the size details container is in the correct position in the DOM
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Get the correct selector container and insert size details
  let selectorContainer = null;

  if (themeName === 'foodie') {
    // Special handling for foodie theme - first check if the select name attribute contains "Size"
    const selectName = select.getAttribute('name') || '';
    if (selectName.toLowerCase().includes('size')) {
      // Use the current select's parent container directly
      selectorContainer = select.closest('.product-form__input');
    } else {
      // Try to find a size selector with a Size label or name attribute in the page
      const allSelects = document.querySelectorAll('.product-form__input select[name*="Size"], .product-form__input select[name*="size"]');
      if (allSelects.length > 0) {
        // Use the first found size select's parent container
        selectorContainer = allSelects[0].closest('.product-form__input');
      }

      // If still not found, try to find it through the label text
      if (!selectorContainer) {
        const sizeLabels = document.querySelectorAll('.form__label');
        for (const label of sizeLabels) {
          if (label.textContent.trim().toLowerCase().includes('size')) {
            selectorContainer = label.closest('.product-form__input');
            if (selectorContainer) break;
          }
        }
      }

      // If all else fails, use the regular method
      if (!selectorContainer) {
        selectorContainer = selector.closest(selectorString) || selector.parentElement;
      }
    }
  } else if (themeName === 'chord') {
    // Special handling for chord theme - find the correct container through the select id
    // First get the select element
    if (select.id === 'options-variant_picker-[Size]') {
      // Find the Form__Item containing this select
      selectorContainer = select.closest('.Form__Item');
      // If still not found, try to find ProductForm__Option
      if (!selectorContainer) {
        selectorContainer = select.closest('.ProductForm__Option');
      }
    } else {
      // Find the select element with id options-variant_picker-[Size] in the page
      const sizeSelect = document.getElementById('options-variant_picker-[Size]');
      if (sizeSelect) {
        selectorContainer = sizeSelect.closest('.Form__Item') || sizeSelect.closest('.ProductForm__Option');
      } else {
        selectorContainer = selector.parentElement;
      }
    }
  } else {
    selectorContainer = selector.closest(selectorString) || selector.parentElement;
  }

  // Insert the size details container after the selector container
  if (selectorContainer && selectorContainer.parentNode) {
    selectorContainer.parentNode.insertBefore(selectedSizeDetails, selectorContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Update hover tooltip content function
  const updateTooltipContent = (sizeValue) => {
    if (sizeInfo[sizeValue]) {
      tooltip.innerHTML = `
        <div class="pify_tooltip_title">${sizeValue}</div>
        ${Object.entries(sizeInfo[sizeValue])
          .map(([measurement, value]) => `<div class="pify_tooltip_row">${measurement}: ${value}</div>`)
          .join('')}
      `;
      tooltip.style.display = 'block';
    } else {
      tooltip.style.display = 'none';
    }
  };

  const handleSizeChange = function (e) {
    const selectedValue = e.target.value.split('[')[0].trim();
    updateTooltipContent(selectedValue);
    updateSizeDetails(selectedValue, sizeInfo, selectedSizeDetails);
  };

  select.removeEventListener('change', handleSizeChange);
  select.addEventListener('change', handleSizeChange, { capture: true });

  select.addEventListener('mouseenter', () => {
    const currentValue = select.value.split('[')[0].trim();
    if (sizeInfo[currentValue]) {
      tooltip.style.setProperty('opacity', '1', 'important');
    }
  });

  select.addEventListener('mouseleave', () => {
    tooltip.style.setProperty('opacity', '0', 'important');
  });

  if (select.value) {
    const cleanValue = select.value.split('[')[0].trim();
    updateTooltipContent(cleanValue);
    updateSizeDetails(cleanValue, sizeInfo, selectedSizeDetails);
  }
}

// Handle radio button size selector
function handleRadioSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Helper function to find matching size value with case variations
  function findMatchingSizeValue(value, sizeInfo) {
    // First try exact match
    if (sizeInfo[value]) {
      return value;
    }

    // Try different case variations
    const variations = [
      value.toUpperCase(),      // Uppercase (e.g., "500GM")
      value.toLowerCase(),      // Lowercase (e.g., "500gm")
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(), // Title case (e.g., "500Gm")
      value.charAt(0).toLowerCase() + value.slice(1).toUpperCase()  // camelCase (e.g., "500gM")
    ];

    for (const variation of variations) {
      if (sizeInfo[variation]) {
        return variation;
      }
    }

    return null;
  }

  // Special handling for whisk theme - distinguish between quick-add and main product selectors
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';

  if (themeName === 'whisk') {
    const radioButtons = selector.querySelectorAll('input[type="radio"]');
    if (radioButtons.length > 0) {
      const firstRadio = radioButtons[0];
      const radioName = firstRadio.getAttribute('name') || '';
      const isQuickAdd = radioName.includes('pdp-quick-add');

      if (isQuickAdd) {
        // This is a quick-add selector, find the main product selector instead
        const mainProductRadios = document.querySelectorAll('input[type="radio"][name*="--size--"]:not([name*="pdp-quick-add"])');
        if (mainProductRadios.length > 0) {
          // Use the first main product size radio's container
          const mainSizeSelector = mainProductRadios[0].closest('fieldset.variant-picker__buttons');
          if (mainSizeSelector) {
            // Ensure the size details container is positioned after the main selector
            if (selectedSizeDetails.parentNode) {
              selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
            }
            if (mainSizeSelector.parentNode) {
              mainSizeSelector.parentNode.insertBefore(selectedSizeDetails, mainSizeSelector.nextSibling);
            }
            return; // Exit early, don't process the quick-add selector
          }
        }
      }
    }
  }

  if (themeName === 'noire') {
    const radioButtons = selector.querySelectorAll('input[type="radio"]');
    if (radioButtons.length > 0) {
      const firstRadio = radioButtons[0];
      const formAttribute = firstRadio.getAttribute('form') || '';
      const isFloatedForm = formAttribute.includes('floated-product-form');

      if (isFloatedForm) {
        // This is a floated selector, find the main product selector instead
        const mainProductRadios = document.querySelectorAll('input[type="radio"][name="Size"]:not([form*="floated-product-form"])');
        if (mainProductRadios.length > 0) {
          // Use the first main product size radio's container
          const mainSizeSelector = mainProductRadios[0].closest('.variant-field');
          if (mainSizeSelector) {
            // Ensure the size details container is positioned after the main selector
            if (selectedSizeDetails.parentNode) {
              selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
            }
            if (mainSizeSelector.parentNode) {
              mainSizeSelector.parentNode.insertBefore(selectedSizeDetails, mainSizeSelector.nextSibling);
            }

            // Check for default selected radio in main product selector and update size details
            const defaultSelectedRadio = mainSizeSelector.querySelector('input[type="radio"]:checked');
            if (defaultSelectedRadio) {
              const selectedValue = defaultSelectedRadio.value.split('[')[0].trim();
              const matchedSizeValue = findMatchingSizeValue(selectedValue, sizeInfo);
              if (matchedSizeValue) {
                updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
              }
            }

            return; // Exit early, don't process the floated selector
          }
        }
      }
    }
  }

  const radioButtons = selector.querySelectorAll('input[type="radio"]');

  if (!radioButtons.length) {
    // Collect compatibility anomaly information - No radio buttons found
    exceptionCollector.collect(
      'sizechart_radio_selectors',
      'No radio buttons found in size selector element'
    );
    return;
  }

  // Check if it's a special theme structure
  // Handle themes with hidden labels
  const isSpecialTheme = selector.closest('.product-swatch-item') !== null || // Paris theme
    selector.closest('.variant-item') !== null || // Master theme
    selector.closest('.variant_option') !== null ||// Fame theme
    selector.closest('.swatch-element') !== null; // avenue theme

  // Save the original text content of the label
  const labelOriginalTextMap = new Map();

  radioButtons.forEach((radio, index) => {
    if (radio.dataset.pifyProcessed === 'true') return;
    radio.dataset.pifyProcessed = 'true';

    // Get the corresponding label - support for new label structures
    const escapedId = CSS.escape(radio.id);
    const label = selector.querySelector(`label[for="${escapedId}"]`) ||
      radio.parentElement.querySelector('label') ||
      radio.closest('.radio__button')?.querySelector('label') ||
      radio.closest('.product-selector__button__holder')?.querySelector('label') ||
      radio.closest('.variant-picker__option')?.querySelector('.variant-picker__option-button') ||
      radio.closest('li')?.querySelector('.variant-radio') ||
      radio.closest('.option-selector__btns')?.querySelector('.opt-label[for="' + escapedId + '"]') ||
      radio.closest('.button--pill') ||
      radio.closest('.variant-picker__label') ||
      radio.closest('.radio__buttons')?.querySelector(`label[for="${escapedId}"]`) ||
      radio.closest('.variant-input')?.querySelector(`label[for="${escapedId}"]`) ||
      radio.closest('.option-swatch')?.querySelector(`label[for="${escapedId}"]`) ||
      radio.closest('.xo-field-radio') ||
      radio.closest('.options-selection__option-value-label') ||
      radio.closest('.variant-option__button-label');

    if (!label) {
      return;
    }

    // Save the original text content of the label
    const originalText = label.childNodes.length > 0 ?
      (label.childNodes[0].nodeType === Node.TEXT_NODE ? label.childNodes[0].textContent.trim() : label.textContent.trim()) :
      label.textContent.trim();

    labelOriginalTextMap.set(radio.id, originalText);

    // First try to match the input's value with the size chart
    let sizeValue = radio.value.split('[')[0].trim();

    // Try to find matching size value with case variations
    let matchedSizeValue = findMatchingSizeValue(sizeValue, sizeInfo);

    // If the input value cannot find corresponding data in the size chart, try to use the label text
    if (!matchedSizeValue && label) {
      matchedSizeValue = findMatchingSizeValue(originalText, sizeInfo);
    }

    if (matchedSizeValue) {
      const tooltip = createSizeTooltip(matchedSizeValue, sizeInfo[matchedSizeValue]);

      // Ensure label has the correct positioning
      const labelStyle = window.getComputedStyle(label);
      if (labelStyle.position === 'static') {
        label.style.position = 'relative';
      }

      label.appendChild(tooltip);

      // If it's a special theme structure, add event listeners to the span element
      if (isSpecialTheme) {
        const span = radio.closest('.product-swatch-item')?.querySelector('.swatch-variant-item') ||
          radio.closest('.variant-item')?.querySelector('.variant-item-name') ||
          radio.closest('.variant_option')?.querySelector('.option') ||
          radio.closest('.swatch-element')?.querySelector('.swatch-label');

        if (span) {
          span.style.position = 'relative';
          span.appendChild(tooltip.cloneNode(true));

          const handleMouseEnter = (e) => {
            e.stopPropagation();
            const tooltips = document.querySelectorAll('.pify_size_tooltip');
            tooltips.forEach(t => {
              if (t.textContent.includes(matchedSizeValue)) {
                t.style.opacity = '1';
              }
            });
          };

          const handleMouseLeave = (e) => {
            e.stopPropagation();
            const tooltips = document.querySelectorAll('.pify_size_tooltip');
            tooltips.forEach(t => {
              if (t.textContent.includes(matchedSizeValue)) {
                t.style.opacity = '0';
              }
            });
          };

          span.addEventListener('mouseenter', handleMouseEnter);
          span.addEventListener('mouseleave', handleMouseLeave);
        }
      }

      // Use event delegation to handle mouse events
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.opacity = '1';
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.opacity = '0';
      };

      label.removeEventListener('mouseenter', handleMouseEnter);
      label.removeEventListener('mouseleave', handleMouseLeave);

      label.addEventListener('mouseenter', handleMouseEnter);
      label.addEventListener('mouseleave', handleMouseLeave);
    }

    // Add change event listener to all radio buttons, regardless of whether there is data
    const handleChange = (e) => {
      const element = e.target;
      // First try using input value
      let newSizeValue = element.value.split('[')[0].trim();
      // Try to find matching size value with case variations
      let matchedNewSizeValue = findMatchingSizeValue(newSizeValue, sizeInfo);

      // If the size chart doesn't have corresponding data, try using label text
      if (!matchedNewSizeValue) {
        // Get original text from saved Map
        const originalText = labelOriginalTextMap.get(element.id);
        if (originalText) {
          matchedNewSizeValue = findMatchingSizeValue(originalText, sizeInfo);
        }
      }

      if (matchedNewSizeValue) {
        updateSizeDetails(matchedNewSizeValue, sizeInfo, selectedSizeDetails);
      } else {
        updateSizeDetails(newSizeValue, sizeInfo, selectedSizeDetails);
      }
    };

    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);
  });

  const defaultSelectedRadio = selector.querySelector('input[type="radio"]:checked');
  if (defaultSelectedRadio) {
    // First try using input value
    let selectedValue = defaultSelectedRadio.value.split('[')[0].trim();

    // Try to find matching size value with case variations
    let matchedSelectedValue = findMatchingSizeValue(selectedValue, sizeInfo);

    // If the size chart doesn't have corresponding data, try using label text
    if (!matchedSelectedValue) {
      // Get original text from saved Map
      const originalText = labelOriginalTextMap.get(defaultSelectedRadio.id);

      if (originalText) {
        matchedSelectedValue = findMatchingSizeValue(originalText, sizeInfo);
      }
    }

    if (matchedSelectedValue) {
      updateSizeDetails(matchedSelectedValue, sizeInfo, selectedSizeDetails);
    } else {
      updateSizeDetails(selectedValue, sizeInfo, selectedSizeDetails);
    }
  }
}

// Create size tooltip
function createSizeTooltip(sizeValue, measurements) {
  const tooltip = document.createElement('div');
  tooltip.className = 'pify_size_tooltip';
  // // 确保工具提示可以接收鼠标事件
  // tooltip.style.pointerEvents = 'none';
  // 添加过渡效果
  tooltip.style.transition = 'all 0.2s ease-in-out';
  tooltip.innerHTML = `
      <div class="pify_tooltip_title"> ${sizeValue}</div>
        ${Object.entries(measurements)
      .map(([measurement, value]) => `<div class="pify_tooltip_row">${measurement}: ${value}</div>`)
      .join('')
    }
    `;
  return tooltip;
}

// Update size details display
function updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails) {
  if (sizeInfo[sizeValue]) {
    selectedSizeDetails.style.display = 'block';
    const measurements = Object.keys(sizeInfo[sizeValue]);
    const values = Object.values(sizeInfo[sizeValue]);

    // Use sizeOrder array if available, otherwise fallback to Object.keys
    const sizeOrder = sizeInfo._sizeOrder || Object.keys(sizeInfo).filter(key =>
      key !== '_unit' && key !== '_sizeOrder' && typeof sizeInfo[key] === 'object' && sizeInfo[key] !== null
    );

    const currentIndex = sizeOrder.indexOf(sizeValue);
    const prevSize = currentIndex > 0 ? sizeOrder[currentIndex - 1] : null;
    const nextSize = currentIndex < sizeOrder.length - 1 ? sizeOrder[currentIndex + 1] : null;

    // Get the original unit from sizeInfo, default to 'cm'
    const originalUnit = sizeInfo._unit || 'cm';
    const radioGroupName = `size_details_unit_${Math.random().toString(36).substr(2, 9)}`;

    // Set the original unit in dataset for unit conversion and clear any previous cache
    selectedSizeDetails.dataset.originalUnit = originalUnit;
    delete selectedSizeDetails.dataset.originalData; // Clear previous cached data

    selectedSizeDetails.innerHTML = `
      <div class="size-details-content">
        <table class="size-details-table">
          <tr>
            <th>
              <div class="size-details-unit-container">
                <label class="size-details-unit-label">
                  <input type="radio" name="${radioGroupName}" value="cm" ${originalUnit === 'cm' ? 'checked' : ''} onchange="handleSizeDetailsUnitChange(this, 'cm')">
                    <span>cm</span>
                </label>
                <label class="size-details-unit-label">
                  <input type="radio" name="${radioGroupName}" value="inch" ${originalUnit === 'inch' ? 'checked' : ''} onchange="handleSizeDetailsUnitChange(this, 'inch')">
                    <span>inch</span>
                </label>
              </div>
            </th>
            ${measurements.map(measurement => `<th>${measurement}</th>`).join('')}
          </tr>
          ${prevSize ? `
              <tr>
                <td>${prevSize}</td>
                ${measurements.map(measurement => `<td>${sizeInfo[prevSize][measurement] || '-'}</td>`).join('')}
              </tr>
            ` : ''}
          <tr class="selected-size-row">
            <td>${sizeValue}</td>
            ${values.map(value => `<td>${value}</td>`).join('')}
          </tr>
          ${nextSize ? `
              <tr>
                <td>${nextSize}</td>
                ${measurements.map(measurement => `<td>${sizeInfo[nextSize][measurement] || '-'}</td>`).join('')}
              </tr>
            ` : ''}
        </table>
        </div >
      `;

    const unitRadios = selectedSizeDetails.querySelectorAll('input[type="radio"][name^="size_details_unit_"]');
    unitRadios.forEach(unitRadio => {
      unitRadio.onchange = function () {
        handleSizeDetailsUnitChange(this, this.value);
      };
    });

    // Add additional click handling only in Galleria theme
    const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
    const specialThemes = new Set(['galleria', 'borders', 'multi', 'essence', 'ascent', 'chord', 'avante', 'lute', 'mandolin']);
    if (specialThemes.has(themeName)) {
      // Add additional click handling function, double ensure click event is captured
      const unitLabels = selectedSizeDetails.querySelectorAll('.size-details-unit-label');
      unitLabels.forEach(label => {
        label.addEventListener('click', function (e) {
          const radio = this.querySelector('input[type="radio"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            handleSizeDetailsUnitChange(radio, radio.value);
          }
        });
      });
    }
  } else {
    selectedSizeDetails.style.display = 'none';
  }
}

function handleSizeDetailsUnitChange(radio, newUnit) {
  // Update radio button selection
  const unitContainer = radio.closest('.size-details-unit-container');
  const allRadios = unitContainer.querySelectorAll('input[type="radio"]');
  allRadios.forEach(r => r.checked = false);
  radio.checked = true;

  const sizeDetailsContent = radio.closest('.pify_size_details_container');
  const table = sizeDetailsContent.querySelector('.size-details-table');

  // Get the original unit from dataset (set in updateSizeDetails function)
  const originalUnit = sizeDetailsContent.dataset.originalUnit || 'cm';

  // If no original data cached, cache the current data (only for data rows, skip header)
  if (!sizeDetailsContent.dataset.originalData) {
    const originalData = [];
    const rows = table.querySelectorAll('tbody tr, tr:not(:first-child)'); // Skip header row
    rows.forEach(row => {
      const rowData = [];
      const cells = row.querySelectorAll('td');
      cells.forEach((cell, index) => {
        if (index > 0 && cell.textContent !== '-') {
          const value = parseFloat(cell.textContent);
          if (!isNaN(value)) {
            rowData.push(value);
          } else {
            rowData.push(cell.textContent);
          }
        } else {
          rowData.push(cell.textContent);
        }
      });
      originalData.push(rowData);
    });
    sizeDetailsContent.dataset.originalData = JSON.stringify(originalData);
  }

  const originalData = JSON.parse(sizeDetailsContent.dataset.originalData);

  const rows = table.querySelectorAll('tbody tr, tr:not(:first-child)'); // Skip header row
  rows.forEach((row, rowIndex) => {
    const cells = row.querySelectorAll('td');
    cells.forEach((cell, index) => {
      if (index > 0 && cell.textContent !== '-') {
        const value = parseFloat(cell.textContent);
        if (!isNaN(value) && originalData[rowIndex] && originalData[rowIndex][index] !== undefined) {
          const originalValue = originalData[rowIndex][index];
          if (originalUnit === 'cm' && newUnit === 'inch') {
            cell.textContent = formatNumber(originalValue / 2.54);
          } else if (originalUnit === 'inch' && newUnit === 'cm') {
            cell.textContent = Math.round(originalValue * 2.54);
          } else if (originalUnit === newUnit) {
            cell.textContent = originalValue.toString();
          } else {
            cell.textContent = originalValue.toString();
          }
        }
      }
    });
  });
}

function handleLiSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  // handleLiSizeSelector called
  
  const pickerItems = selector.querySelectorAll('.product-option-picker__list-item');
  // Found picker items
  
  pickerItems.forEach((item, index) => {
    // Processing item
    
    if (item.dataset.pifyProcessed === 'true') {
      // Item already processed, skipping
      return;
    }
    item.dataset.pifyProcessed = 'true';

    let sizeValue = item.getAttribute('data-option-value') || '';
    // Initial sizeValue from data-option-value
    
    if (!sizeValue) {
      const valueSpan = item.querySelector('.product-option-label__value');
      // Looking for .product-option-label__value
      if (valueSpan) {
        sizeValue = valueSpan.textContent.trim();
        // sizeValue from span text
      }
    }
    
    // Final sizeValue check
    
    if (!sizeValue || !sizeInfo[sizeValue]) {
      // Size value not found or no size info, collecting exception
      exceptionCollector.collect(
        'The corresponding size information was not found',
        `The size value "${sizeValue}" could not be obtained or the corresponding size information was not found. Available sizes: ${Object.keys(sizeInfo).join(', ')}`
      );
      return;
    }

    const labelDiv = item.querySelector('.product-option-label');
    // Found labelDiv
    
    if (!labelDiv) {
      // No .product-option-label found, skipping tooltip creation
      return;
    }

    const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
    // Created tooltip
    
    labelDiv.appendChild(tooltip);
    // Tooltip appended to labelDiv

    labelDiv.addEventListener('mouseenter', () => {
      // Mouse entered labelDiv
      tooltip.style.setProperty('opacity', '1', 'important');
      tooltip.style.setProperty('visibility', 'visible', 'important');
      tooltip.style.setProperty('display', 'block', 'important');
      // Tooltip styles set to visible
    });
    
    labelDiv.addEventListener('mouseleave', () => {
      // Mouse left labelDiv
      tooltip.style.setProperty('opacity', '0', 'important');
      // Tooltip opacity set to 0
    });

    item.addEventListener('click', () => {
      // Item clicked
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    });

    if (item.classList.contains('chosen')) {
      // Item is chosen, updating size details
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    }
    
    // Completed processing item
  });
}

function findProductContainer() {
  // Array of selectors sorted by priority
  const selectors = [
    '[id^="ProductInfo-template"]',
    '[class^="m6pr-template"][class*="main-product"]',
    '.product-main',
    '.product__info',
    '.product__info-wrapper',
    '.product-info__blocks',
    '.product-details-wrapper',
    '.main-product--form',
    '.variant-selects',
    '.Product__MiddleLeft',
    '.ProductSummary',
    '.Product__Block',
    '.content-for-layout',
    '.product',
    '[class="#product-media"]',
    '.product-price',
    '.tt-product-single-info',
    '.base-font'
  ];

  // Find the first matching element
  for (const selector of selectors) {
    const element = document.querySelector(selector);
    if (element) return element;
  }

  return null;
}

function observeSizeSelectorChanges() {
  // Listen to the product main container
  const productMain = findProductContainer();

  if (!productMain) return;

  let observer = new MutationObserver(() => {
    addSizeSelectorTooltip();
  });

  observer.observe(productMain, {
    childList: true,
    subtree: true
  });

  // Special handling for Galleria theme, listen for body changes
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  const specialObserveThemes = ['galleria', 'multi', 'stretch', 'next', 'xclusive', 'xtra', 'tailor', 'satoshi', 'amber', 'marble', 'eclipse', 'handy'];
  if (specialObserveThemes.includes(themeName)) {
    let bodyObserver = new MutationObserver(() => {
      const sizeChartContainer = document.querySelector('.pify_inline_buttons_container');
      if (!sizeChartContainer || sizeChartContainer.offsetParent === null) {
        addCustomButtons();
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeSizeSelectorChanges);
} else {
  observeSizeSelectorChanges();
}

// Add a function for handling button-style size selectors
function handleButtonSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Support multiple theme button selectors
  let buttonSelectors = ['.optionBtns', '.product__chip', '.product-form__chip', '.product__color-chips'];

  let buttons = [];
  for (const btnSelector of buttonSelectors) {
    const foundButtons = selector.querySelectorAll(btnSelector);
    if (foundButtons.length > 0) {
      buttons = foundButtons;
      break;
    }
  }

  // Special handling for Lorenza theme - position size details after product-form__chip-wrapper
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  if (themeName === 'lorenza') {
    const chipWrapper = document.querySelector('.product-form__chip-wrapper');
    if (chipWrapper) {
      // Remove existing size details container if it exists
      if (selectedSizeDetails.parentNode) {
        selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
      }
      // Insert size details container after the chip wrapper
      chipWrapper.parentNode.insertBefore(selectedSizeDetails, chipWrapper.nextSibling);
    }
  }

  buttons.forEach(button => {
    if (button.dataset.pifyProcessed === 'true') return;
    button.dataset.pifyProcessed = 'true';

    const sizeValue = button.getAttribute('data-option-value') ||
      button.getAttribute('data-value') ||
      button.textContent.trim();

    if (!sizeValue) return;

    const buttonStyle = window.getComputedStyle(button);
    if (buttonStyle.position === 'static') {
      button.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      button.appendChild(tooltip);

      button.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      button.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    button.addEventListener('click', () => {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    const isActive = button.classList.contains('btnActive') ||
      button.classList.contains('active') ||
      button.classList.contains('selected') ||
      button.classList.contains('product-form__chip selected');
    button.dataset.selected === 'true';

    if (isActive) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Add a function for handling Andaman theme
function handleAndamanSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const swatches = selector.querySelectorAll('a.swatch');
  swatches.forEach(swatch => {
    if (swatch.dataset.pifyProcessed === 'true') return;
    swatch.dataset.pifyProcessed = 'true';

    const sizeValue = swatch.getAttribute('value');
    if (!sizeValue) return;

    // Convert the value to uppercase to match size chart data
    const uppercaseSizeValue = sizeValue.toUpperCase();

    // Ensure swatch has the correct positioning
    const swatchStyle = window.getComputedStyle(swatch);
    if (swatchStyle.position === 'static') {
      swatch.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (sizeInfo[uppercaseSizeValue]) {
      const tooltip = createSizeTooltip(uppercaseSizeValue, sizeInfo[uppercaseSizeValue]);
      swatch.appendChild(tooltip);

      swatch.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      swatch.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    swatch.addEventListener('click', () => {
      if (sizeInfo[uppercaseSizeValue]) {
        updateSizeDetails(uppercaseSizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    if (swatch.classList.contains('selected')) {
      if (sizeInfo[uppercaseSizeValue]) {
        updateSizeDetails(uppercaseSizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Add a function for handling chip-style size selectors
function handleChipSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Get all chip-style selector labels
  const chipLabels = selector.querySelectorAll('.variant-option--chips');
  if (!chipLabels.length) {
    return;
  }

  // Save size value mapping
  const sizeValueMap = new Map();

  chipLabels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const radio = label.querySelector('input[type="radio"]');
    const button = label.querySelector('button.chip');
    if (!radio || !button) return;

    // Get size value - prioritize aria-label attribute
    const sizeValue = button.getAttribute('aria-label') || button.textContent.trim();
    if (!sizeValue) return;

    // Save size value mapping - use radio ID as key, size value as value
    sizeValueMap.set(radio.id, sizeValue);

    const buttonStyle = window.getComputedStyle(button);
    if (buttonStyle.position === 'static') {
      button.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      button.appendChild(tooltip);

      const handleMouseEnter = () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      button.removeEventListener('mouseenter', handleMouseEnter);
      button.removeEventListener('mouseleave', handleMouseLeave);

      button.addEventListener('mouseenter', handleMouseEnter);
      button.addEventListener('mouseleave', handleMouseLeave);

      button.addEventListener('click', () => {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      });
    }

    const handleChange = () => {
      if (radio.checked && sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      }
    };

    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);
  });

  const defaultSelectedRadio = selector.querySelector('input[type="radio"]:checked');
  if (defaultSelectedRadio) {
    const selectedSizeValue = sizeValueMap.get(defaultSelectedRadio.id);
    if (selectedSizeValue && sizeInfo[selectedSizeValue]) {
      updateSizeDetails(selectedSizeValue, sizeInfo, selectedSizeDetails);
    }
  }
}

// Add functions for handling pill-style selectors
function handlePillSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const pillLabels = selector.querySelectorAll('.pill');
  if (!pillLabels.length) {
    return;
  }

  const sizeValueMap = new Map();

  pillLabels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const pillLabelEl = label.querySelector('.pill__label');
    if (!pillLabelEl) return;

    const sizeValue = pillLabelEl.textContent.trim();
    if (!sizeValue) return;

    const inputId = label.getAttribute('for');
    if (inputId) {
      sizeValueMap.set(inputId, sizeValue);
    }

    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      label.appendChild(tooltip);

      const handleMouseEnter = () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      label.removeEventListener('mouseenter', handleMouseEnter);
      label.removeEventListener('mouseleave', handleMouseLeave);

      label.addEventListener('mouseenter', handleMouseEnter);
      label.addEventListener('mouseleave', handleMouseLeave);
    }

    const handleClick = () => {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      }
    };

    label.removeEventListener('click', handleClick);
    label.addEventListener('click', handleClick);
  });

  const defaultSelectedPill = selector.querySelector('.pill.selected');
  if (defaultSelectedPill) {
    const pillLabelEl = defaultSelectedPill.querySelector('.pill__label');
    if (pillLabelEl) {
      const selectedSizeValue = pillLabelEl.textContent.trim();
      if (selectedSizeValue && sizeInfo[selectedSizeValue]) {
        updateSizeDetails(selectedSizeValue, sizeInfo, selectedSizeDetails);
      }
    }
  }
}

// Add a function for handling clickyboxes with the Showcase theme
function handleClickyboxesSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const sizeLinks = selector.querySelectorAll('li a');
  if (!sizeLinks.length) {
    return;
  }

  sizeLinks.forEach(link => {
    if (link.dataset.pifyProcessed === 'true') return;
    link.dataset.pifyProcessed = 'true';

    const sizeValue = link.getAttribute('data-value');
    if (!sizeValue) return;

    const linkStyle = window.getComputedStyle(link);
    if (linkStyle.position === 'static') {
      link.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      link.appendChild(tooltip);

      link.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      link.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    link.addEventListener('click', (e) => {
      e.preventDefault();

      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }

      sizeLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');
    });
  });

  const activeLink = selector.querySelector('a.active');
  if (activeLink) {
    const selectedValue = activeLink.getAttribute('data-value');
    if (selectedValue && sizeInfo[selectedValue]) {
      updateSizeDetails(selectedValue, sizeInfo, selectedSizeDetails);
    }
  }
}

function handleXtraSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const listItems = selector.querySelectorAll('li');

  listItems.forEach(item => {
    const radio = item.querySelector('input[type="radio"]');
    const label = item.querySelector('label');

    if (!radio || !label) return;

    // Get size value - extract size part from title (e.g. "Default / M" -> "M")
    const titleParts = radio.getAttribute('title').split('/');
    const sizeValue = titleParts.length > 1 ? titleParts[1].trim() : '';

    if (!sizeValue || !sizeInfo[sizeValue]) return;

    label.style.position = 'relative';

    const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
    label.appendChild(tooltip);

    label.addEventListener('mouseenter', () => {
      tooltip.style.setProperty('opacity', '1', 'important');
    });

    label.addEventListener('mouseleave', () => {
      tooltip.style.setProperty('opacity', '0', 'important');
    });

    radio.addEventListener('change', () => {
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    });

    if (radio.checked) {
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    }
  });
}

function handleCustomDropdownSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  let dropdownContainer = null;
  let button = null;
  let listbox = null;

  if (selector.tagName === 'BUTTON') {
    button = selector;
    dropdownContainer = button.closest('.variant-dropdown');
  } else if (selector.tagName === 'UL' && selector.getAttribute('role') === 'listbox') {
    listbox = selector;
    const listboxId = listbox.id;
    if (listboxId) {
      const buttonId = listboxId.replace('-dropdown', '');
      button = document.getElementById(buttonId);
    }
    dropdownContainer = listbox.closest('.variant-dropdown');
  } else if (selector.classList.contains('variant-dropdown')) {
    dropdownContainer = selector;
    button = dropdownContainer.querySelector('button[id*="SingleOptionSelector"]');
    listbox = dropdownContainer.querySelector('ul[role="listbox"]');
  }

  if (!dropdownContainer || !button) {
    return;
  }

  if (!listbox && button.id) {
    const listboxId = button.id + '-dropdown';
    listbox = document.getElementById(listboxId);
  }

  if (!listbox) {
    return;
  }

  const sizeOptions = listbox.querySelectorAll('li[data-option-name="Size"], li[data-option-value]');
  if (!sizeOptions.length) {
    return;
  }

  const buttonParent = button.parentNode;
  if (window.getComputedStyle(buttonParent).position === 'static') {
    buttonParent.style.position = 'relative';
  }

  const tooltip = document.createElement('div');
  tooltip.className = 'pify_size_tooltip';
  tooltip.style.opacity = '0';
  tooltip.style.display = 'none';
  buttonParent.appendChild(tooltip);

  const selectorContainer = dropdownContainer || buttonParent;

  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  if (selectorContainer && selectorContainer.parentNode) {
    selectorContainer.parentNode.insertBefore(selectedSizeDetails, selectorContainer.nextSibling);
  }

  const updateTooltipContent = (sizeValue) => {
    if (sizeInfo[sizeValue]) {
      tooltip.innerHTML = `
        <div class="pify_tooltip_title">${sizeValue}</div>
        ${Object.entries(sizeInfo[sizeValue])
          .map(([measurement, value]) => `<div class="pify_tooltip_row">${measurement}: ${value}</div>`)
          .join('')}
      `;
      tooltip.style.display = 'block';
    } else {
      tooltip.style.display = 'none';
    }
  };

  const handleOptionClick = (sizeValue) => {
    if (sizeValue && sizeInfo[sizeValue]) {
      updateTooltipContent(sizeValue);
      updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
    }
  };

  const selectedSpan = button.querySelector('[data-selected-option]');
  const currentValue = selectedSpan ? selectedSpan.textContent.trim() : '';

  if (currentValue && sizeInfo[currentValue]) {
    updateTooltipContent(currentValue);
    updateSizeDetails(currentValue, sizeInfo, selectedSizeDetails);
  }

  button.addEventListener('mouseenter', () => {
    const currentValue = button.querySelector('[data-selected-option]')?.textContent.trim();
    if (currentValue && sizeInfo[currentValue]) {
      tooltip.style.setProperty('opacity', '1', 'important');
    }
  });

  button.addEventListener('mouseleave', () => {
    tooltip.style.setProperty('opacity', '0', 'important');
  });

  // Listen for click events on the options
  sizeOptions.forEach(option => {
    option.addEventListener('click', () => {
      const sizeValue = option.getAttribute('data-option-value');
      handleOptionClick(sizeValue);
    });
  });

  // Listen for click events on the entire list (capturing bubbles)
  listbox.addEventListener('click', (e) => {
    const clickedOption = e.target.closest('li[data-option-value]');
    if (clickedOption) {
      const sizeValue = clickedOption.getAttribute('data-option-value');
      handleOptionClick(sizeValue);
    }
  });

  // Use MutationObserver to listen for button content changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        const selectedText = button.querySelector('[data-selected-option]')?.textContent.trim();
        if (selectedText && sizeInfo[selectedText]) {
          updateTooltipContent(selectedText);
          updateSizeDetails(selectedText, sizeInfo, selectedSizeDetails);
        }
      }
    });
  });

  observer.observe(button, { childList: true, subtree: true, attributes: true });
}

// Add function to handle XO theme custom dropdown
function handleXoFieldSelectCustom(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Get all radio button labels
  const labels = selector.querySelectorAll('.xo-field-select-custom__check');
  if (!labels.length) {
    return;
  }

  // Ensure the size details container is correctly positioned in the DOM
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Find suitable parent container to insert size details
  const parentContainer = selector.closest('.xo-product-form__options') ||
    selector.closest('.xo-product-form__field') ||
    selector.parentElement;

  if (parentContainer) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    // Fallback - insert after the original selector
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  labels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const radio = label.querySelector('input[type="radio"]');
    const labelSpan = label.querySelector('.xo-field-select-custom__label');

    if (!radio || !labelSpan) return;

    const sizeValue = labelSpan.textContent.trim();
    if (!sizeValue) return;

    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      label.appendChild(tooltip);

      const iconSpan = label.querySelector('.xo-field-select-custom__icon');
      const elementsToWatch = [label, iconSpan, labelSpan].filter(Boolean);

      elementsToWatch.forEach(element => {
        element.addEventListener('mouseenter', () => {
          tooltip.style.setProperty('opacity', '1', 'important');
        });

        element.addEventListener('mouseleave', () => {
          tooltip.style.setProperty('opacity', '0', 'important');
        });
      });
    }

    const handleChange = () => {
      if (radio.checked && sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else if (radio.checked && !sizeInfo[sizeValue]) {
        selectedSizeDetails.style.display = 'none';
      }
    };

    radio.addEventListener('change', handleChange);

    const iconSpan = label.querySelector('.xo-field-select-custom__icon');
    if (iconSpan) {
      iconSpan.addEventListener('click', () => {
        if (!radio.checked) {
          radio.checked = true;
          if (sizeInfo[sizeValue]) {
            updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
          }
        }
      });
    }
  });

  const defaultSelectedRadio = selector.querySelector('input[type="radio"]:checked');
  if (defaultSelectedRadio) {
    const label = defaultSelectedRadio.closest('.xo-field-select-custom__check');
    const labelSpan = label?.querySelector('.xo-field-select-custom__label');

    if (labelSpan) {
      const selectedSizeValue = labelSpan.textContent.trim();
      if (selectedSizeValue && sizeInfo[selectedSizeValue]) {
        updateSizeDetails(selectedSizeValue, sizeInfo, selectedSizeDetails);
      }
    }
  }

  if (window.getComputedStyle(selector).position === 'fixed') {
    selector.style.overflow = 'visible';
    selector.style.zIndex = '9999';
  }
}

function handleKallesSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const items = selector.querySelectorAll('.t4s-swatch__item');
  items.forEach(item => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();
    if (!sizeValue) return;

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      item.style.position = 'relative';
      item.appendChild(tooltip);

      // 鼠标进入尺码项时显示工具提示
      item.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
        tooltip.style.setProperty('visibility', 'visible', 'important');
        tooltip.style.setProperty('display', 'block', 'important');
      });
      
      // 鼠标离开尺码项时，检查是否移动到了工具提示上
      item.addEventListener('mouseleave', (e) => {
        // 检查鼠标是否移动到了工具提示上
        const toElement = e.relatedTarget;
        if (tooltip.contains(toElement) || tooltip === toElement) {
          // 如果移动到了工具提示上，保持显示
          return;
        }
        // 否则隐藏工具提示
        setTimeout(() => {
          // 再次检查鼠标是否在工具提示上，避免在延迟期间鼠标移动到工具提示上
          if (!tooltip.matches(':hover')) {
            tooltip.style.setProperty('opacity', '0', 'important');
          }
        }, 100);
      });
      
      // 为工具提示添加鼠标离开事件
      tooltip.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    item.addEventListener('click', () => {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    if (item.classList.contains('is--selected')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

function handleBeeSwatchSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const items = selector.querySelectorAll('.bee-swatch__item');
  items.forEach(item => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();
    if (!sizeValue) return;

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      item.style.position = 'relative';
      item.appendChild(tooltip);

      // 鼠标进入尺码项时显示工具提示
      item.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
        tooltip.style.setProperty('visibility', 'visible', 'important');
        tooltip.style.setProperty('display', 'block', 'important');
      });
      
      // 鼠标离开尺码项时，检查是否移动到了工具提示上
      item.addEventListener('mouseleave', (e) => {
        // 检查鼠标是否移动到了工具提示上
        const toElement = e.relatedTarget;
        if (tooltip.contains(toElement) || tooltip === toElement) {
          // 如果移动到了工具提示上，保持显示
          return;
        }
        
        // 添加短暂延迟，避免工具提示闪烁
        setTimeout(() => {
          // 再次检查鼠标是否在工具提示上
          if (tooltip.matches(':hover')) {
            return;
          }
          // 否则隐藏工具提示
          tooltip.style.setProperty('opacity', '0', 'important');
        }, 100);
      });
      
      // 为工具提示添加鼠标离开事件
      tooltip.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    item.addEventListener('click', () => {
      // Remove active class from all items
      items.forEach(i => i.classList.remove('active'));
      
      // Add active class to clicked item
      item.classList.add('active');
      
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    // Check if this item is initially active
    if (item.classList.contains('active')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

function handleShellaSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  const sizeSection = document.querySelector('.product-options__section[data-property="size"]');
  if (sizeSection && sizeSection.parentNode) {
    sizeSection.parentNode.insertBefore(selectedSizeDetails, sizeSection.nextSibling);
  } else {
    const parentContainer = selector.closest('.product-options__section') || selector.parentElement;
    if (parentContainer && parentContainer.parentNode) {
      parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
    }
  }

  const valueDivs = selector.querySelectorAll('.product-options__value[data-value]');
  valueDivs.forEach(div => {
    if (div.dataset.pifyProcessed === 'true') return;
    div.dataset.pifyProcessed = 'true';

    const sizeValue = div.getAttribute('data-value');
    if (!sizeValue) return;

    if (sizeInfo[sizeValue.toUpperCase()] || sizeInfo[sizeValue]) {
      const key = sizeInfo[sizeValue] ? sizeValue : sizeValue.toUpperCase();
      const tooltip = createSizeTooltip(key, sizeInfo[key]);
      div.style.position = 'relative';
      div.appendChild(tooltip);

      div.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });
      div.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    if (div.classList.contains('active')) {
      const key = sizeInfo[sizeValue] ? sizeValue : sizeValue.toUpperCase();
      if (sizeInfo[key]) {
        updateSizeDetails(key, sizeInfo, selectedSizeDetails);
      }
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('product-options__value') && target.classList.contains('active')) {
          const sizeValue = target.getAttribute('data-value');
          if (sizeValue) {
            const key = sizeInfo[sizeValue] ? sizeValue : sizeValue.toUpperCase();
            if (sizeInfo[key]) {
              updateSizeDetails(key, sizeInfo, selectedSizeDetails);
            } else {
              selectedSizeDetails.style.display = 'none';
            }
          }
        }
      }
    });
  });

  valueDivs.forEach(div => {
    observer.observe(div, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

function handleUminoSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  const swatches = selector.querySelectorAll('.bls__option-swatch');
  swatches.forEach(swatch => {
    if (swatch.dataset.pifyProcessed === 'true') return;
    swatch.dataset.pifyProcessed = 'true';

    const sizeValue = swatch.getAttribute('data-value');
    if (!sizeValue) return;

    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      swatch.style.position = 'relative';
      swatch.appendChild(tooltip);

      swatch.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });
      swatch.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    if (swatch.classList.contains('active')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Helper function to fix size details container position for specific themes
function fixSizeDetailsPosition(themeName, selector, sizeInfo, existingSizeDetails) {
  const detailsContainer = document.querySelector('.pify_size_details_container');
  if (!detailsContainer) return;

  const datasetKey = `${themeName.replace(/\s+/g, '')}Fixed`;
  if (detailsContainer.dataset[datasetKey]) return;

  let targetContainer = null;

  switch (themeName) {
    case 'proto':
    case 'electro theme':
      const swatchContainer = document.querySelector('.swatch[data-option-index="0"]');
      if (swatchContainer) {
        targetContainer = swatchContainer;
      } else {
        const swatches = document.querySelectorAll('.swatch');
        for (const swatch of swatches) {
          const header = swatch.querySelector('.header');
          if (header && header.textContent.trim().toLowerCase().includes('size')) {
            targetContainer = swatch;
            break;
          }
        }
      }
      break;

    case 'elomus':
      targetContainer = document.querySelector('.swatch[data-option-index="0"]');
      break;

    case 'corano':
      // For Corano theme, find the visible size swatch container
      const sizeSwatch = document.querySelector('.swatch[data-option-index="0"]:not([style*="display: none"]), .swatch.Size:not([style*="display: none"])');
      if (sizeSwatch) {
        // Find the parent container that contains both hidden selectors and visible swatches
        const productVariantOption = sizeSwatch.closest('.product-variant-option');
        if (productVariantOption) {
          targetContainer = productVariantOption;
        } else {
          targetContainer = sizeSwatch;
        }
      }
      break;

    case 'lezada os 2.0':
      // For Lezada theme, find the visible size swatch container
      const lezadaSizeSwatch = document.querySelector('.swatch[data-option-index="0"]:not([style*="display: none"]), .swatch.Size:not([style*="display: none"])');
      if (lezadaSizeSwatch) {
        // Find the parent container that contains both hidden selectors and visible swatches
        const productVariantOption = lezadaSizeSwatch.closest('.product-variant-option');
        if (productVariantOption) {
          targetContainer = productVariantOption;
        } else {
          targetContainer = lezadaSizeSwatch;
        }
      }
      break;

    case 'learts - shopify theme ':
      // For Learts theme, find the product-variant-option container
      const productVariantOption = document.querySelector('.product-variations');
      if (productVariantOption) {
        targetContainer = productVariantOption;
      }
      break;
  }

  if (targetContainer) {
    // Remove the details container from its current position
    if (detailsContainer.parentNode) {
      detailsContainer.parentNode.removeChild(detailsContainer);
    }
    // Insert after the target container
    targetContainer.parentNode.insertBefore(detailsContainer, targetContainer.nextSibling);
    detailsContainer.dataset[datasetKey] = "true";

    // Update size details for the default selected size
    const defaultSelectedRadio = targetContainer.querySelector('input[type="radio"]:checked');
    if (defaultSelectedRadio) {
      let selectedValue = defaultSelectedRadio.value.split('[')[0].trim();

      // Try multiple formats for size matching (same logic as handleCoranoSizeSelector)
      const sizeVariations = [
        selectedValue,                    // Original value (e.g., "s")
        selectedValue.toUpperCase(),      // Uppercase (e.g., "S")
        selectedValue.toLowerCase(),      // Lowercase (e.g., "s")
        selectedValue.charAt(0).toUpperCase() + selectedValue.slice(1).toLowerCase() // Title case (e.g., "S")
      ];

      let matchedSizeValue = null;
      for (const variation of sizeVariations) {
        if (sizeInfo[variation]) {
          matchedSizeValue = variation;
          break;
        }
      }

      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, detailsContainer);
      }
    }
  }
}

// Add a function for handling Venedor theme size selector
function handleVenedorSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle Venedor theme structure: div.product-single-option > label.option-label
  const sizeLabels = selector.querySelectorAll('label.option-label');
  if (!sizeLabels.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the selector container
  const parentContainer = selector.closest('.product-single-option') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  sizeLabels.forEach(label => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const sizeValue = label.getAttribute('data-value') || label.textContent.trim();
    if (!sizeValue) return;

    // Ensure label has the correct positioning
    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (sizeInfo[sizeValue]) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      label.appendChild(tooltip);

      label.addEventListener('mouseenter', () => {
        tooltip.style.setProperty('opacity', '1', 'important');
      });

      label.addEventListener('mouseleave', () => {
        tooltip.style.setProperty('opacity', '0', 'important');
      });
    }

    // Handle click events
    label.addEventListener('click', () => {
      // Remove active class from all labels
      sizeLabels.forEach(l => l.classList.remove('active'));
      // Add active class to clicked label
      label.classList.add('active');

      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    });

    // Check if this label is initially active
    if (label.classList.contains('active')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });
}

// Add a function for handling Vinova Modamate theme size selector
function handleVinovaModamateSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle Vinova Modamate theme structure: fieldset.product-variant-form-input > div.product-single__variant-item > label
  const variantItems = selector.querySelectorAll('div.product-single__variant-item');

  if (!variantItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the fieldset container
  const parentContainer = selector.closest('.product-variant-form-input') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }


  // Track if we have any valid size data
  let hasValidSizeData = false;

  variantItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const radio = item.querySelector('input[type="radio"]');
    const label = item.querySelector('label');

    if (!radio || !label) {
      return;
    }

    const sizeValue = radio.value || label.textContent.trim();

    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "s")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "S")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "s")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "S")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure label has the correct positioning
    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (sizeInfo[matchedSizeValue]) {
      const tooltip = createSizeTooltip(matchedSizeValue, sizeInfo[matchedSizeValue]);
      label.appendChild(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      label.removeEventListener('mouseenter', handleMouseEnter);
      label.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      label.addEventListener('mouseenter', handleMouseEnter);
      label.addEventListener('mouseleave', handleMouseLeave);

      // Also add listeners to the item container for better coverage
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Handle radio change events
    const handleChange = () => {
      if (radio.checked && sizeInfo[matchedSizeValue]) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else if (radio.checked && !sizeInfo[matchedSizeValue]) {
        selectedSizeDetails.style.display = 'none';
      }
    };

    // Remove existing listeners to prevent duplicates
    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);

    // Check if this radio is initially checked
    if (radio.checked) {
      if (sizeInfo[matchedSizeValue]) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

function handleLusionSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Get current theme name to determine if hover should be disabled
  const themeName = window.Shopify?.theme?.schema_name?.toLowerCase() || '';
  const isEvaTheme = themeName === 'eva';
  const isUneroTheme = themeName === 'unero';
  const isNoHoverTheme = isEvaTheme || isUneroTheme;

  // Handle Lusion theme structure: div.selector-wrapper > div.swatch > span.option-item
  // Handle Eva/Unero theme structure: div.tawcvs-swatches > span.swatch
  const optionItems = isNoHoverTheme ?
    selector.querySelectorAll('span.swatch') :
    selector.querySelectorAll('span.option-item');

  if (!optionItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the appropriate container
  let parentContainer;
  if (isNoHoverTheme) {
    parentContainer = selector.closest('.tawcvs-swatches') || selector.parentElement;
  } else {
    parentContainer = selector.closest('.selector-wrapper') || selector.parentElement;
  }

  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  optionItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    // Get size value based on theme
    let sizeValue;
    if (isNoHoverTheme) {
      sizeValue = item.getAttribute('data-value');
    } else {
      sizeValue = item.getAttribute('data-value') || item.textContent.trim();
    }

    if (!sizeValue) return;

    // Check if we have size data for this value
    if (sizeInfo[sizeValue]) {
      hasValidSizeData = true;
    }

    // Ensure item has the correct positioning
    const itemStyle = window.getComputedStyle(item);
    if (itemStyle.position === 'static') {
      item.style.position = 'relative';
    }

    // Add tooltip for sizes with data (only for non-Eva/Unero themes)
    if (sizeInfo[sizeValue] && !isNoHoverTheme) {
      const tooltip = createSizeTooltip(sizeValue, sizeInfo[sizeValue]);
      item.appendChild(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };
      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };
      // Remove existing listeners to prevent duplicates
      item.removeEventListener('mouseenter', handleMouseEnter);
      item.removeEventListener('mouseleave', handleMouseLeave);
      // Add new listeners
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Handle click events
    const handleClick = (e) => {
      e.preventDefault();
      // Remove selected class from all items
      optionItems.forEach(i => i.classList.remove('selected'));
      // Add selected class to clicked item
      item.classList.add('selected');
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    };
    // Remove existing listeners to prevent duplicates
    item.removeEventListener('click', handleClick);
    item.addEventListener('click', handleClick);
    // Check if this item is initially selected
    if (item.classList.contains('selected')) {
      if (sizeInfo[sizeValue]) {
        updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }

  // Listen for dynamic changes using MutationObserver (only for Eva/Unero themes)
  if (isNoHoverTheme) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('selected') && target.classList.contains('swatch')) {
            const sizeValue = target.getAttribute('data-value');
            if (sizeValue && sizeInfo[sizeValue]) {
              updateSizeDetails(sizeValue, sizeInfo, selectedSizeDetails);
              selectedSizeDetails.style.display = 'block';
            } else {
              selectedSizeDetails.style.display = 'none';
            }
          }
        }
      });
    });

    // Observe the selector container for class changes
    observer.observe(selector, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }
}

function handleGoodwinSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle Goodwin theme structure: div.prd-size > ul.size-list > li > a
  const sizeList = selector.querySelector('ul.size-list');
  if (!sizeList) {
    return;
  }

  const sizeItems = sizeList.querySelectorAll('li a');

  if (!sizeItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the prd-size container
  const parentContainer = selector.closest('.prd-size') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  sizeItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();

    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "Small")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "SMALL")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "small")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "Small")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure item has the correct positioning
    const itemStyle = window.getComputedStyle(item);
    if (itemStyle.position === 'static') {
      item.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSizeTooltip(matchedSizeValue, sizeInfo[matchedSizeValue]);
      item.appendChild(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      item.removeEventListener('mouseenter', handleMouseEnter);
      item.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Check if this item is initially active
    if (item.closest('li').classList.contains('active')) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.tagName === 'LI' && target.classList.contains('active')) {
          const link = target.querySelector('a');
          if (link) {
            const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
            if (sizeValue) {
              // Try multiple formats for size matching
              const sizeVariations = [
                sizeValue,
                sizeValue.toUpperCase(),
                sizeValue.toLowerCase(),
                sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
              ];

              let matchedSizeValue = null;
              for (const variation of sizeVariations) {
                if (sizeInfo[variation]) {
                  matchedSizeValue = variation;
                  break;
                }
              }

              if (matchedSizeValue) {
                updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
                selectedSizeDetails.style.display = 'block';
              } else {
                selectedSizeDetails.style.display = 'none';
              }
            }
          }
        }
      }
    });
  });

  const listItems = sizeList.querySelectorAll('li');
  listItems.forEach(li => {
    observer.observe(li, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

function handleCoranoSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Check if this is a color selector and skip it
  const isColorSelector =
    selector.classList.contains('color') ||
    selector.classList.contains('color-swatch') ||
    selector.classList.contains('color-option') ||
    selector.classList.contains('color-selector') ||
    selector.getAttribute('data-value')?.toLowerCase().match(/^(red|green|blue|yellow|white|black|pink|purple|orange|brown|gray|grey|navy|teal|cyan|magenta|lime|olive|maroon|silver|gold|beige|ivory|cream|tan|coral|salmon|peach|apricot|mint|lavender|plum|indigo|violet|turquoise|aqua|azure|crimson|scarlet|burgundy|ruby|emerald|jade|sapphire|diamond|pearl|amber|topaz|garnet|onyx|jet|charcoal|slate|steel|bronze|copper|brass|chrome|nickel|zinc|titanium|aluminum|aluminium)$/);

  if (isColorSelector) {
    return;
  }

  // Handle Corano theme structure: div.swatch > div.swatch-element > input[type="radio"] + label
  // Find size swatch specifically (not color swatch)
  const sizeSwatch = selector.querySelector('.swatch[data-option-index="0"], .swatch.Size');
  if (!sizeSwatch) {
    // Try to find size swatch in the entire page
    const pageSizeSwatch = document.querySelector('.swatch[data-option-index="0"], .swatch.Size');
    if (pageSizeSwatch) {
      // Use the page size swatch instead
      const pageSizeSwatchParent = pageSizeSwatch.closest('.product-variant-option') || pageSizeSwatch.parentElement;
      if (pageSizeSwatchParent && pageSizeSwatchParent.parentNode) {
        pageSizeSwatchParent.parentNode.insertBefore(selectedSizeDetails, pageSizeSwatchParent.nextSibling);
      } else {
        pageSizeSwatch.parentNode.insertBefore(selectedSizeDetails, pageSizeSwatch.nextSibling);
      }

      // Process the page size swatch
      processSwatchElements(pageSizeSwatch, sizeInfo, selectedSizeDetails);
    }
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the size swatch container
  const parentContainer = sizeSwatch.closest('.product-variant-option') || sizeSwatch.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    sizeSwatch.parentNode.insertBefore(selectedSizeDetails, sizeSwatch.nextSibling);
  }

  // Process the swatch elements
  processSwatchElements(sizeSwatch, sizeInfo, selectedSizeDetails);
}

function processSwatchElements(sizeSwatch, sizeInfo, selectedSizeDetails) {
  // Get all swatch elements (size options)
  const swatchElements = sizeSwatch.querySelectorAll('.swatch-element');
  if (!swatchElements.length) {
    return;
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;
  let initiallySelectedSize = null;

  swatchElements.forEach((swatchElement, index) => {
    if (swatchElement.dataset.pifyProcessed === 'true') return;
    swatchElement.dataset.pifyProcessed = 'true';

    const sizeValue = swatchElement.getAttribute('data-value');
    if (!sizeValue) {
      return;
    }

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "s")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "S")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "s")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "S")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Check if this element is initially selected (multiple ways to check)
    const isInitiallySelected = swatchElement.classList.contains('selected') ||
      swatchElement.querySelector('input[type="radio"]:checked') ||
      swatchElement.classList.contains('active') ||
      swatchElement.querySelector('input[type="radio"]').checked;

    if (isInitiallySelected && matchedSizeValue) {
      initiallySelectedSize = matchedSizeValue;
    }
  });

  // Function to update size details based on current selection
  const updateSizeDetailsFromCurrentSelection = () => {
    const selectedElement = sizeSwatch.querySelector('.swatch-element.selected, .swatch-element.active') ||
      sizeSwatch.querySelector('.swatch-element input[type="radio"]:checked')?.closest('.swatch-element');

    if (selectedElement) {
      const sizeValue = selectedElement.getAttribute('data-value');
      if (sizeValue) {
        const sizeVariations = [
          sizeValue,
          sizeValue.toUpperCase(),
          sizeValue.toLowerCase(),
          sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
        ];

        let matchedSizeValue = null;
        for (const variation of sizeVariations) {
          if (sizeInfo[variation]) {
            matchedSizeValue = variation;
            break;
          }
        }

        if (matchedSizeValue) {
          updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
          selectedSizeDetails.style.display = 'block';
        } else {
          selectedSizeDetails.style.display = 'none';
        }
      }
    } else {
      selectedSizeDetails.style.display = 'none';
    }
  };

  // Enhanced MutationObserver to handle class changes and radio button changes
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        const target = mutation.target;

        // Handle class attribute changes
        if (mutation.attributeName === 'class' && target.classList.contains('swatch-element')) {
          if (target.classList.contains('selected') || target.classList.contains('active')) {
            shouldUpdate = true;
          }
        }

        // Handle radio button checked state changes
        if (mutation.attributeName === 'checked' && target.type === 'radio') {
          if (target.checked) {
            shouldUpdate = true;
          }
        }
      }
    });

    if (shouldUpdate) {
      // Add a small delay to ensure DOM updates are complete
      setTimeout(updateSizeDetailsFromCurrentSelection, 10);
    }
  });

  // Observe all swatch elements for class changes
  swatchElements.forEach(swatchElement => {
    observer.observe(swatchElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also observe radio buttons for checked state changes
    const radio = swatchElement.querySelector('input[type="radio"]');
    if (radio) {
      observer.observe(radio, {
        attributes: true,
        attributeFilter: ['checked']
      });
    }
  });

  // Also observe the entire swatch container for any changes
  observer.observe(sizeSwatch, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // Add event listeners to labels for additional coverage
  swatchElements.forEach(swatchElement => {
    const label = swatchElement.querySelector('label');
    if (label) {
      // Use a more passive approach - just trigger update after a short delay
      const handleLabelInteraction = () => {
        setTimeout(updateSizeDetailsFromCurrentSelection, 50);
      };

      label.addEventListener('click', handleLabelInteraction, { passive: true });
      label.addEventListener('change', handleLabelInteraction, { passive: true });
    }

    // Also listen to radio button events
    const radio = swatchElement.querySelector('input[type="radio"]');
    if (radio) {
      const handleRadioInteraction = () => {
        setTimeout(updateSizeDetailsFromCurrentSelection, 50);
      };

      radio.addEventListener('change', handleRadioInteraction, { passive: true });
      radio.addEventListener('click', handleRadioInteraction, { passive: true });
    }
  });

  // Show initially selected size details if available
  if (initiallySelectedSize) {
    updateSizeDetails(initiallySelectedSize, sizeInfo, selectedSizeDetails);
    selectedSizeDetails.style.display = 'block';
  } else if (hasValidSizeData) {
    // If no initially selected size but we have valid data, show the first available size
    const firstSwatchElement = swatchElements[0];
    const firstSizeValue = firstSwatchElement.getAttribute('data-value');
    if (firstSizeValue) {
      const sizeVariations = [
        firstSizeValue,
        firstSizeValue.toUpperCase(),
        firstSizeValue.toLowerCase(),
        firstSizeValue.charAt(0).toUpperCase() + firstSizeValue.slice(1).toLowerCase()
      ];

      for (const variation of sizeVariations) {
        if (sizeInfo[variation]) {
          updateSizeDetails(variation, sizeInfo, selectedSizeDetails);
          selectedSizeDetails.style.display = 'block';
          break;
        }
      }
    }
  } else {
    // If no valid size data found, hide the details container
    selectedSizeDetails.style.display = 'none';
  }
}

// Handle prd-option-list size selector with quantity status
function handlePrdOptionListSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Helper function to find matching size value with case variations
  function findMatchingSizeValue(value, sizeInfo) {
    // First try exact match
    if (sizeInfo[value]) {
      return value;
    }

    // Try different case variations
    const variations = [
      value.toUpperCase(),      // Uppercase (e.g., "XS")
      value.toLowerCase(),      // Lowercase (e.g., "xs")
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(), // Title case (e.g., "Xs")
      value.charAt(0).toLowerCase() + value.slice(1).toUpperCase()  // camelCase (e.g., "xS")
    ];

    for (const variation of variations) {
      if (sizeInfo[variation]) {
        return variation;
      }
    }

    return null;
  }

  // Get all label elements with radio buttons
  const labels = selector.querySelectorAll('label.label-radio');
  if (!labels.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the fieldset container
  const parentContainer = selector.closest('.prd-option-list') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;
  let initiallySelectedSize = null;

  labels.forEach((label, index) => {
    if (label.dataset.pifyProcessed === 'true') return;
    label.dataset.pifyProcessed = 'true';

    const radio = label.querySelector('input[type="radio"]');
    if (!radio) return;

    // Get size value from label text content (remove any extra whitespace)
    const sizeValue = label.childNodes[0]?.nodeType === Node.TEXT_NODE ?
      label.childNodes[0].textContent.trim() :
      label.textContent.trim();

    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "XS")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "XS")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "xs")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "Xs")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Check if this label is initially selected
    const isInitiallySelected = label.classList.contains('swatch-active') ||
      radio.checked ||
      label.classList.contains('active') ||
      label.classList.contains('selected');

    if (isInitiallySelected && matchedSizeValue) {
      initiallySelectedSize = matchedSizeValue;
    }

    // Ensure label has the correct positioning
    const labelStyle = window.getComputedStyle(label);
    if (labelStyle.position === 'static') {
      label.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSizeTooltip(matchedSizeValue, sizeInfo[matchedSizeValue]);
      label.appendChild(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      label.removeEventListener('mouseenter', handleMouseEnter);
      label.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      label.addEventListener('mouseenter', handleMouseEnter);
      label.addEventListener('mouseleave', handleMouseLeave);
    }

    // Handle radio change events
    const handleChange = () => {
      if (radio.checked && matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else if (radio.checked && !matchedSizeValue) {
        selectedSizeDetails.style.display = 'none';
      }
    };

    // Remove existing listeners to prevent duplicates
    radio.removeEventListener('change', handleChange);
    radio.addEventListener('change', handleChange);

    // Also handle label click events for better compatibility
    const handleLabelClick = () => {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    };

    label.removeEventListener('click', handleLabelClick);
    label.addEventListener('click', handleLabelClick);

    // Check if this radio is initially checked
    if (radio.checked) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // Show initially selected size details if available
  if (initiallySelectedSize) {
    updateSizeDetails(initiallySelectedSize, sizeInfo, selectedSizeDetails);
    selectedSizeDetails.style.display = 'block';
  } else if (hasValidSizeData) {
    // If no initially selected size but we have valid data, show the first available size
    const firstLabel = labels[0];
    const firstSizeValue = firstLabel.childNodes[0]?.nodeType === Node.TEXT_NODE ?
      firstLabel.childNodes[0].textContent.trim() :
      firstLabel.textContent.trim();

    if (firstSizeValue) {
      const sizeVariations = [
        firstSizeValue,
        firstSizeValue.toUpperCase(),
        firstSizeValue.toLowerCase(),
        firstSizeValue.charAt(0).toUpperCase() + firstSizeValue.slice(1).toLowerCase()
      ];

      for (const variation of sizeVariations) {
        if (sizeInfo[variation]) {
          updateSizeDetails(variation, sizeInfo, selectedSizeDetails);
          selectedSizeDetails.style.display = 'block';
          break;
        }
      }
    }
  } else {
    // If no valid size data found, hide the details container
    selectedSizeDetails.style.display = 'none';
  }
}

// Add a generic function for handling prd-size list structure (used by Foxic and Goodwin themes)
function handlePrdSizeListSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;
  selector.dataset.pifyProcessed = 'true';

  // Handle prd-size list structure: div.prd-size > ul.size-list > li > a
  const sizeList = selector.querySelector('ul.size-list');
  if (!sizeList) {
    return;
  }

  const sizeItems = sizeList.querySelectorAll('li a');

  if (!sizeItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the prd-size container
  const parentContainer = selector.closest('.prd-size') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  sizeItems.forEach((item, index) => {
    if (item.dataset.pifyProcessed === 'true') return;
    item.dataset.pifyProcessed = 'true';

    const sizeValue = item.getAttribute('data-value') || item.textContent.trim();

    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "Small")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "SMALL")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "small")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "Small")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure item has the correct positioning
    const itemStyle = window.getComputedStyle(item);
    if (itemStyle.position === 'static') {
      item.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSizeTooltip(matchedSizeValue, sizeInfo[matchedSizeValue]);
      item.appendChild(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      item.removeEventListener('mouseenter', handleMouseEnter);
      item.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    }

    // Check if this item is initially active
    if (item.closest('li').classList.contains('active')) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.tagName === 'LI' && target.classList.contains('active')) {
          const link = target.querySelector('a');
          if (link) {
            const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
            if (sizeValue) {
              // Try multiple formats for size matching
              const sizeVariations = [
                sizeValue,
                sizeValue.toUpperCase(),
                sizeValue.toLowerCase(),
                sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
              ];

              let matchedSizeValue = null;
              for (const variation of sizeVariations) {
                if (sizeInfo[variation]) {
                  matchedSizeValue = variation;
                  break;
                }
              }

              if (matchedSizeValue) {
                updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
                selectedSizeDetails.style.display = 'block';
              } else {
                selectedSizeDetails.style.display = 'none';
              }
            }
          }
        }
      }
    });
  });

  const listItems = sizeList.querySelectorAll('li');
  listItems.forEach(li => {
    observer.observe(li, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

function handleWokieeSizeSelector(selector, sizeInfo, selectedSizeDetails) {
  if (selector.dataset.pifyProcessed === 'true') return;

  const titleElement = selector.querySelector('.tt-title-options');
  if (titleElement) {
    const titleText = titleElement.textContent.trim().toLowerCase();
    if (!titleText.includes('size') && !titleText.includes('尺寸')) {
      return;
    }
  } else {
    const sizeLinks = selector.querySelectorAll('li a[data-value]');
    if (sizeLinks.length > 0) {
      const sizeValues = Array.from(sizeLinks).map(link => link.getAttribute('data-value'));
      const sizePatterns = [
        /^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i,
        /^(2XS|3XS|2XL|3XL|4XL|5XL)$/i,
        /^\d+$/,
        /^\d+[A-Z]?$/i,
        /^\d+\.\d+$/,
        /^\d+\/\d+$/,
        /^(ONE SIZE|ONESIZE|OS|FREE SIZE|FREESIZE)$/i
      ];

      let sizeCount = 0;
      sizeValues.forEach(value => {
        if (sizePatterns.some(pattern => pattern.test(value))) {
          sizeCount++;
        }
      });

      if (sizeCount / sizeValues.length < 0.5) {
        return;
      }
    } else {
      return;
    }
  }

  selector.dataset.pifyProcessed = 'true';

  // Handle Wokiee theme structure: div.tt-wrapper > ul.tt-options-swatch > li > a
  const sizeList = selector.querySelector('ul.tt-options-swatch');
  if (!sizeList) {
    return;
  }

  const sizeItems = sizeList.querySelectorAll('li a');
  if (!sizeItems.length) {
    return;
  }

  // Ensure the size details container is correctly positioned
  if (selectedSizeDetails.parentNode) {
    selectedSizeDetails.parentNode.removeChild(selectedSizeDetails);
  }

  // Insert size details after the selector container
  const parentContainer = selector.closest('.tt-wrapper') || selector.parentElement;
  if (parentContainer && parentContainer.parentNode) {
    parentContainer.parentNode.insertBefore(selectedSizeDetails, parentContainer.nextSibling);
  } else {
    selector.parentNode.insertBefore(selectedSizeDetails, selector.nextSibling);
  }

  // Track if we have any valid size data
  let hasValidSizeData = false;

  sizeItems.forEach((link, index) => {
    if (link.dataset.pifyProcessed === 'true') return;
    link.dataset.pifyProcessed = 'true';

    const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
    if (!sizeValue) return;

    // Try multiple formats for size matching
    const sizeVariations = [
      sizeValue,                    // Original value (e.g., "S")
      sizeValue.toUpperCase(),      // Uppercase (e.g., "S")
      sizeValue.toLowerCase(),      // Lowercase (e.g., "s")
      sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase() // Title case (e.g., "S")
    ];

    let matchedSizeValue = null;
    for (const variation of sizeVariations) {
      if (sizeInfo[variation]) {
        matchedSizeValue = variation;
        break;
      }
    }

    // Check if we have size data for this value
    if (matchedSizeValue) {
      hasValidSizeData = true;
    }

    // Ensure link has the correct positioning
    const linkStyle = window.getComputedStyle(link);
    if (linkStyle.position === 'static') {
      link.style.position = 'relative';
    }

    // Add tooltip for sizes with data
    if (matchedSizeValue) {
      const tooltip = createSizeTooltip(matchedSizeValue, sizeInfo[matchedSizeValue]);
      link.appendChild(tooltip);

      // Use more specific event handling for better compatibility
      const handleMouseEnter = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '1', 'important');
      };

      const handleMouseLeave = (e) => {
        e.stopPropagation();
        tooltip.style.setProperty('opacity', '0', 'important');
      };

      // Remove existing listeners to prevent duplicates
      link.removeEventListener('mouseenter', handleMouseEnter);
      link.removeEventListener('mouseleave', handleMouseLeave);

      // Add new listeners
      link.addEventListener('mouseenter', handleMouseEnter);
      link.addEventListener('mouseleave', handleMouseLeave);
    }

    // Check if this item is initially active
    if (link.closest('li').classList.contains('active')) {
      if (matchedSizeValue) {
        updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
        selectedSizeDetails.style.display = 'block';
      } else {
        selectedSizeDetails.style.display = 'none';
      }
    }
  });

  // Add MutationObserver to watch for active state changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.tagName === 'LI' && target.classList.contains('active')) {
          const link = target.querySelector('a');
          if (link) {
            const sizeValue = link.getAttribute('data-value') || link.textContent.trim();
            if (sizeValue) {
              // Try multiple formats for size matching
              const sizeVariations = [
                sizeValue,
                sizeValue.toUpperCase(),
                sizeValue.toLowerCase(),
                sizeValue.charAt(0).toUpperCase() + sizeValue.slice(1).toLowerCase()
              ];

              let matchedSizeValue = null;
              for (const variation of sizeVariations) {
                if (sizeInfo[variation]) {
                  matchedSizeValue = variation;
                  break;
                }
              }

              if (matchedSizeValue) {
                updateSizeDetails(matchedSizeValue, sizeInfo, selectedSizeDetails);
                selectedSizeDetails.style.display = 'block';
              } else {
                selectedSizeDetails.style.display = 'none';
              }
            }
          }
        }
      }
    });
  });

  const listItems = sizeList.querySelectorAll('li');
  listItems.forEach(li => {
    observer.observe(li, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // If no valid size data found, hide the details container
  if (!hasValidSizeData) {
    selectedSizeDetails.style.display = 'none';
  }
}

// ==================== FIT CHARTS 功能集成 ====================

/**
 * 获取当前产品ID
 */
function getCurrentProductId() {
  // 方法1: 从window.pageData获取
  if (window.pageData && window.pageData.productId) {
    return window.pageData.productId.toString();
  }

  // 方法2: 从ShopifyAnalytics获取
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
    const productId = window.ShopifyAnalytics.meta.product.id;
    return productId ? productId.toString() : null;
  }

  // 方法3: 从meta标签获取
  const metaProduct = document.querySelector('meta[property="product:id"]');
  if (metaProduct) {
    return metaProduct.getAttribute('content');
  }

  // 方法4: 从URL路径解析 (/products/handle)
  const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
  if (pathMatch) {
    // 这里返回handle，后续需要其他方式获取ID
    const handle = pathMatch[1];

    // 尝试从页面中的script标签获取产品数据
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data['@type'] === 'Product' && data.sku) {
          // 某些主题可能在这里有产品ID
          const productId = data.productID || data['@id'];
          if (productId) {
            return productId.toString();
          }
        }
      } catch (e) {
        // 忽略解析错误
      }
    }
  }

  // 方法5: 从Shopify全局变量获取
  if (window.meta && window.meta.product && window.meta.product.id) {
    return window.meta.product.id.toString();
  }

  return null;
}

/**
 * 标准化产品ID格式
 */
function normalizeProductId(productId) {
  if (!productId) return null;

  // 如果是Shopify GID格式，提取数字ID
  if (productId.includes('gid://shopify/Product/')) {
    return productId.replace('gid://shopify/Product/', '');
  }

  // 移除任何非数字字符，只保留数字
  const numericId = productId.toString().replace(/\D/g, '');
  return numericId || null;
}

/**
 * 从现有数据中获取 FitProfiles
 */
function getFitProfilesFromData() {
  // 1. 检查全局 pageData 对象
  if (window.pageData && window.pageData.fitProfiles) {
    return window.pageData.fitProfiles;
  }

  // 2. 备用：从 script 元素中解析
  const scriptElement = document.getElementById('pify-sizechart-data');
  if (scriptElement) {
    try {
      const pageData = JSON.parse(scriptElement.textContent);
      if (pageData.fitProfiles) {
        return pageData.fitProfiles;
      }
    } catch (error) {
      return [];
    }
  }

  return [];
}

/**
 * 检查是否应该显示 FitChart
 * 复用 shouldDisplaySizeChart 的逻辑，适配 fit chart 的数据结构
 */
function shouldDisplayFitChart(fitChart) {
  if (!fitChart) {
    return false;
  }

  // 检查状态
  const status = fitChart.status || fitChart.settings?.status || 'active';
  if (status !== 'active') {
    return false;
  }

  // 获取 targeting 配置
  const targeting = fitChart.settings?.targeting || fitChart.targeting;
  if (!targeting) {
    return false;
  }

  // 检查是否在产品页面
  const isProductPage = window.location.pathname.startsWith('/products/') ||
    window.location.pathname.includes('/products/');
  if (!isProductPage) {
    return false;
  }

  // 复用 shouldDisplaySizeChart 的逻辑
  // 1. All products - 显示给所有产品
  if (targeting.displayPosition === 'all') return true;

  // 2. Selected products - 只在指定产品上显示
  if (targeting.displayPosition === 'products') {
    if (!window.pageData || !window.pageData.productId) return false;

    return targeting.selectedProducts.some(product => {
      if (!product || !product.id) return false;

      const productId = product.id.split('/').pop();
      const productIdStr = String(productId);
      const pageProductIdStr = String(window.pageData.productId);

      return productIdStr === pageProductIdStr;
    });
  }

  // 3. Product Collections - 只在指定集合的产品上显示
  if (targeting.displayPosition === 'collections') {
    if (!window.pageData || !window.pageData.collectionIds || !Array.isArray(window.pageData.collectionIds)) return false;

    return targeting.selectedCollections.some(collection => {
      if (!collection || !collection.id) return false;

      const collectionId = collection.id.split('/').pop();
      const collectionIdStr = String(collectionId);

      return window.pageData.collectionIds.some(pageCollectionId =>
        String(pageCollectionId) === collectionIdStr
      );
    });
  }

  // 4. Product Tags - 只在有指定标签的产品上显示
  if (targeting.displayPosition === 'tags') {
    if (!window.pageData || !window.pageData.productTags || !Array.isArray(window.pageData.productTags)) return false;
    if (!targeting.productTags || !Array.isArray(targeting.productTags)) return false;

    return targeting.productTags.some(tag =>
      window.pageData.productTags.includes(tag)
    );
  }

  return false;
}

/**
 * 渲染 Fit 选择器
 */
function renderFitSelector(fitChart) {
  const fitData = fitChart.settings?.fitSettings || fitChart.fitSettings || {};
  const container = document.createElement('div');
  container.className = 'pify_fit_selector_container';
  container.dataset.fitCode = fitChart.code;

  // 标识是否为advanced mode
  if (fitData.styles?.segmentBar?.advancedMode) {
    container.dataset.advancedMode = 'true';
  }

  // 处理数据格式兼容性
  let types = [];
  if (fitData.types && Array.isArray(fitData.types)) {
    if (typeof fitData.types[0] === 'string') {
      // 旧格式：字符串数组，转换为新格式
      const selectedType = fitData.selectedType || fitData.types[0];
      types = fitData.types.map((type, index) => ({
        id: index,
        name: type,
        isSelected: type === selectedType
      }));
    } else {
      // 新格式：对象数组
      types = fitData.types;
    }
  }

  if (!types.length) {
    return null; // 没有类型数据则不渲染
  }

  // 获取样式配置
  const titleStyle = {
    color: fitData.styles?.title?.color || '#333333',
    fontSize: fitData.styles?.title?.fontSize || '16px',
    fontWeight: fitData.styles?.title?.fontWeight || 'bold',
    margin: '0 0 8px 0',
    padding: '0',
    display: 'block'
  };

  const typesStyle = {
    color: fitData.styles?.types?.color || '#666666',
    fontSize: fitData.styles?.types?.fontSize || '12px',
    fontWeight: fitData.styles?.types?.fontWeight || 'normal',
    margin: '0',
    padding: '0'
  };

  // 创建标题
  const titleElement = document.createElement('div');
  titleElement.className = 'pify_fit_title';
  titleElement.textContent = fitData.fitTitle || 'Fit';
  titleElement.style.color = titleStyle.color;
  titleElement.style.fontSize = titleStyle.fontSize;
  titleElement.style.fontWeight = titleStyle.fontWeight;

  // 创建类型容器
  const typesContainer = document.createElement('div');
  typesContainer.className = 'pify_fit_types_container';
  // CSS 样式通过类名应用

  // 创建类型标签容器
  const typesLabelsContainer = document.createElement('div');
  typesLabelsContainer.className = 'pify_fit_types_labels';

  // 添加类型标签
  types.forEach((typeObj, index) => {
    const typeLabel = document.createElement('span');
    typeLabel.className = 'pify_fit_type_label';
    // 只有当name不为空白时才设置文本内容
    if (typeObj.name && typeObj.name.trim()) {
      typeLabel.textContent = typeObj.name;
    }
    // 使用CSS变量设置样式
    typeLabel.style.setProperty('--label-color', typesStyle.color);
    typeLabel.style.setProperty('--label-font-size', typesStyle.fontSize);
    typeLabel.style.setProperty('--label-font-weight', typesStyle.fontWeight);
    typeLabel.dataset.fitTypeId = typeObj.id;
    typeLabel.dataset.fitIndex = index;
    typesLabelsContainer.appendChild(typeLabel);
  });

  // 创建箭头指示器容器
  const arrowContainer = document.createElement('div');
  arrowContainer.className = 'pify_fit_arrow_container';

  // 创建 Segment Bar
  const segmentBarContainer = document.createElement('div');
  segmentBarContainer.className = 'pify_fit_segment_bar';

  // segment bar 样式已移到CSS类中

  // 确定当前选中的index
  const selectedIndex = types.findIndex(type => type.isSelected);

  // 添加segments
  types.forEach((typeObj, index) => {
    // 创建箭头 - 根据选中的 type 确定箭头颜色
    const arrowElement = document.createElement('div');
    arrowElement.className = 'pify_fit_arrow';
    arrowElement.style.opacity = '0';

    const arrowSize = parseInt(fitData.styles?.arrow?.size || '6px');

    // 根据Advanced Mode和segments获取箭头颜色
    let arrowColor = fitData.styles?.arrow?.color;
    if (!arrowColor && fitData.styles?.segmentBar?.advancedMode && fitData.styles?.segmentBar?.segments?.[index]) {
      arrowColor = fitData.styles.segmentBar.segments[index].activeColor;
    }
    if (!arrowColor) {
      arrowColor = fitData.styles?.segmentBar?.backgroundColor || '#007ace';
    }

    // 确保箭头颜色不为空且可见
    if (!arrowColor || arrowColor === 'transparent' || arrowColor === '') {
      arrowColor = '#007ace'; // 默认蓝色
    }

    // 使用Unicode向下箭头字符
    arrowElement.innerHTML = `
      <div class="pify_fit_arrow_icon" style="color: ${arrowColor}; font-size: ${arrowSize}px;">▼</div>
    `;

    arrowContainer.appendChild(arrowElement);

    // 创建segment
    const segment = document.createElement('div');
    segment.className = 'pify_fit_segment';
    
    // 添加零宽度空格防止被 div:empty{display:none} 规则隐藏
    segment.innerHTML = '&zwj;'; // 零宽度连接符，不可见但使元素非空

    // 根据Advanced Mode获取样式
    const isAdvancedMode = fitData.styles?.segmentBar?.advancedMode;
    const segmentStyle = isAdvancedMode && fitData.styles?.segmentBar?.segments?.[index]
      ? fitData.styles.segmentBar.segments[index]
      : null;

    // 确定当前选中的index
    const isActive = index <= selectedIndex;

    // 获取颜色（只保留颜色配置）
    let backgroundColor;
    if (segmentStyle) {
      backgroundColor = isActive ? segmentStyle.activeColor : segmentStyle.inactiveColor;
    } else {
      backgroundColor = isActive
        ? (fitData.styles?.segmentBar?.backgroundColor || '#000000')
        : (fitData.styles?.segmentBar?.inactiveColor || '#e1e3e5');
    }

    // 应用背景色样式
    segment.style.backgroundColor = backgroundColor;

    segment.dataset.fitTypeId = typeObj.id;
    segment.dataset.fitIndex = index;
    segmentBarContainer.appendChild(segment);
  });

  // segment bar 只用于显示状态，不响应点击事件

  // 组装容器 - 根据showArrow配置决定是否添加箭头
  container.appendChild(titleElement);

  // 只有当showArrow为true时才添加箭头容器
  if (fitData.showArrow !== false) { // 默认显示箭头，除非明确设置为false
    container.appendChild(arrowContainer);
  }

  container.appendChild(segmentBarContainer);
  typesContainer.appendChild(typesLabelsContainer);
  container.appendChild(typesContainer);

  // 设置默认选中状态 - 在所有元素都添加到DOM后再调用
  const defaultSelectedType = types.find(t => t.isSelected);
  if (defaultSelectedType) {
    setFitSelection(container, defaultSelectedType.id, { types, styles: fitData.styles });
  }

  return container;
}

/**
 * 设置 Fit 选择状态
 */
function setFitSelection(container, selectedId, fitData) {
  const types = fitData.types || [];
  const selectedIndex = types.findIndex(type => type.id === selectedId);

  if (selectedIndex < 0) return;

  // 更新箭头显示和颜色（仅当showArrow为true时）
  if (fitData.showArrow !== false) {
    const arrows = container.querySelectorAll('.pify_fit_arrow');
    arrows.forEach((arrow, index) => {
      const isSelected = index === selectedIndex;
      arrow.style.opacity = isSelected ? '1' : '0';

      // 如果是选中的箭头，更新其颜色
      if (isSelected) {
        const arrowDiv = arrow.querySelector('.pify_fit_arrow_icon');
        if (arrowDiv) {
          // 根据Advanced Mode和segments获取箭头颜色
          let arrowColor = fitData.styles?.arrow?.color;
          if (!arrowColor && fitData.styles?.segmentBar?.advancedMode && fitData.styles?.segmentBar?.segments?.[index]) {
            arrowColor = fitData.styles.segmentBar.segments[index].activeColor;
          }
          if (!arrowColor) {
            arrowColor = fitData.styles?.segmentBar?.backgroundColor || '#007ace';
          }

          // 确保箭头颜色可见并且格式正确
          if (!arrowColor || arrowColor === 'transparent' || arrowColor === '') {
            arrowColor = '#007ace';
          }

          // 处理颜色格式，移除alpha通道
          if (arrowColor.length > 7 && arrowColor.startsWith('#')) {
            arrowColor = arrowColor.substring(0, 7);
          }

          // 设置箭头颜色
          arrowDiv.style.color = arrowColor;
        }
      }
    });
  }

  // 更新 segments 状态
  const segments = container.querySelectorAll('.pify_fit_segment');
  segments.forEach((segment, index) => {
    const isActive = index <= selectedIndex;

    // 根据Advanced Mode获取颜色
    const isAdvancedMode = fitData.styles?.segmentBar?.advancedMode;
    const segmentStyle = isAdvancedMode && fitData.styles?.segmentBar?.segments?.[index]
      ? fitData.styles.segmentBar.segments[index]
      : null;

    let backgroundColor;
    if (segmentStyle) {
      backgroundColor = isActive ? segmentStyle.activeColor : segmentStyle.inactiveColor;
    } else {
      backgroundColor = isActive
        ? (fitData.styles?.segmentBar?.backgroundColor || '#000000')
        : (fitData.styles?.segmentBar?.inactiveColor || '#e1e3e5');
    }

    segment.style.setProperty('--segment-bg-color', backgroundColor);
  });

  // 触发自定义事件，供其他功能监听
  const selectedType = types[selectedIndex];
  const event = new CustomEvent('fitSelectionChanged', {
    detail: {
      selectedType: selectedType?.name,
      selectedId: selectedId,
      selectedIndex: selectedIndex,
      fitData: fitData
    }
  });
  container.dispatchEvent(event);
}

/**
 * 查找 Quantity 选择器
 */
function findQuantitySelector() {
  
  const fallbackSelectors = [
     //兼容性较好 
    '[class*="product-form"]',
    '[class*="product-form__buttons"]',
    '.product-form__quantity',  //有可能parent node是 flex布局
    '.product-form__input',
    //custom theme
    '.bee-product-form__buttons',   //Nitro theme


    '.variant-selector',
    '.option-selector',
    '.product-option-picker',
    '.variant-picker',
    '.variant-radios',
    '.variant-selects',
    '.product-variant-picker',
    '.swatches',
    '.color-swatch',
    '.size-selector',
    '.color-selector',
    '.product-form__variants',
    '.product-form__option',
    '.variant-picker__option',
    '.js-variant-selector',
    '.SwatchList',
    '.BlockSwatch',
    '.ImageSwatchWrapper',
    '.color-swatch-list',
    '.product-variants-selector',
    '.sticky-variant-select',
    
    // 第二级：数量选择器
    '.quantity-input',
    '.quantity-selector',
    '.product-quantity-picker',
    '.quantity-picker',
    '.quantity',
    '.qty',
    '.product__quantity-input',
    '.quantity-input-wrapper',
    '.quantity-submit-row',
    '.product-qty',
    'quantity-input',
    '[data-quantity-input]',
    'input[name="quantity"]',
    // '[class*="quantity"]', 导致样式出现严重问题
    // '[class*="product"]', 导致样式出现严重问题
    
    // 第三级：价格
    '.price',
    '.product-price',
    '.price__container',
    '.price__regular',
    '.price__sale',
    '.product__price',
    '.product-price--original',
    '.product--price',
    '.grid-product__price',
    '.main-product-price',
    '.price-container',
    '.product-buy-price',
    '.current-price',
    '.price__main',
    '.ab-price',
    '[data-price]',
    '[data-product-price]',
    '#product-price',
    '.money',
    
    // 第四级：添加到购物车
    '.product-form__buttons',
    '.add-to-cart',
    '.btn-cart',
    '.product-form__controls',
    '.product-form__actions',
    '.product-form__button-container',
    '.product-form__payment-container',
    '.product-form__atc-container',
    '.product-form__submit-container',
    '.product-form__cta',
    '.product-form__buttons-container',
    '.product-form__add-to-cart',
    '.product__submit',
    '.product__buttons',
    '.product-page__submit',
    '.add-to-cart-container',
    '.atc-btn-container',
    '.button-wrapper',
    '.button-container',
    '.btn-wrapper',
    '.form-actions',
    '.product-form__buy-buttons',
    '.product-form__atc-wrapper',
    '.product-form__button-wrapper',
    '.product-form__submit-wrapper',
    '.product-form__action-wrapper',
    '.product-buy-buttons',
    '.product-add-to-cart',
    '.product-form-inline-atc',
    '.product-form__buy-now',
    '.product-form__payment-buttons',
    '.product-form__buttons--primary',
    '.product-form__buttons--secondary',
    '.button-action-wrapper',
    '.btn-cart-wrapper',
    '.atc-button-container',
    '.product-summary__add-to-cart',
    '.product-checkout-buttons',
    '.single-add-to-cart-button',
    '.product-add-to-cart-container',
    '.product-add-to-cart-sticky',
    '.card__add-to-cart',
    '.shopify-product-form',
    '[data-add-to-cart]',
    'button[name="add"]',
    '.product-form__submit',
    '.add-to-cart__submit'
  ];

  for (const selector of fallbackSelectors) {
    const elements = document.querySelectorAll(selector);
    for (const element of elements) {
      if (isElementVisible(element)) {
        return element;
      }
    }
  }

  return null;
}

/**
 * 添加 Fit 选择器到页面
 */
function addFitSelector() {
  try {
    // 检查是否已经插入了fit选择器，避免重复插入
    if (document.querySelector('[data-pify-fit="true"]')) {
      return;
    }

    // 从现有数据中获取 FitProfiles
    window.fitChartsData = getFitProfilesFromData();

    if (!window.fitChartsData || !Array.isArray(window.fitChartsData) || window.fitChartsData.length === 0) {
      return; // 没有 fit 数据就不显示
    }

    // 过滤出应该显示的 FitChart
    const activeFitCharts = window.fitChartsData.filter(shouldDisplayFitChart);

    if (activeFitCharts.length === 0) {
      return; // 没有符合条件的 fit chart
    }

    // 如果页面上存在 pify_fit_selectors_wrapper 容器，优先插入到该容器中
    const pifyFitWrapper = document.querySelector('.pify_fit_selectors_wrapper');
    if (pifyFitWrapper) {
      console.log('finded pifyFitWrapper ');
      
      // 为每个活跃的 FitChart 创建选择器
      activeFitCharts.forEach((fitChart, index) => {
        const fitSelector = renderFitSelector(fitChart);
        fitSelector.setAttribute('data-pify-fit', 'true'); // 添加标识

        if (index > 0) {
          fitSelector.classList.add('pify_fit_selector_spacing');
        }

        pifyFitWrapper.appendChild(fitSelector);
      });
      return;
    }

    // 查找 Quantity 选择器
    const quantitySelector = findQuantitySelector();

    // 创建 fit 选择器容器
    const fitContainer = document.createElement('div');
    fitContainer.className = 'pify_fit_selectors_wrapper';
    fitContainer.setAttribute('data-pify-fit', 'true'); // 添加标识

    // 为每个活跃的 FitChart 创建选择器
    activeFitCharts.forEach((fitChart, index) => {
      const fitSelector = renderFitSelector(fitChart);

      if (index > 0) {
        fitSelector.classList.add('pify_fit_selector_spacing');
      }

      fitContainer.appendChild(fitSelector);
    });

    // 插入到 Quantity 上方
    if (quantitySelector && quantitySelector.parentNode) {
      quantitySelector.parentNode.insertBefore(fitContainer, quantitySelector);
    } else {
      // 如果找不到 Quantity 选择器，尝试插入到其他位置
      const fallbackSelectors = [
        // 第一优先级：表单按钮区域
        '.product-form__buttons',
        '.product-form__actions',
        '.product-form__button-container',
        '.product-form__submit',
        '.product__submit',
        '.product__buttons',
        '.add-to-cart-container',
        '.atc-btn-container',
        '.button-wrapper',
        '.button-container',
        '.btn-wrapper',
        '.form-actions',

        // 第二优先级：添加到购物车按钮
        'button[name="add"]',
        'button[type="submit"]',
        'button[name="add"][type="submit"]',
        'input[name="add"][type="submit"]',
        'form[action*="/cart/add"] button[type="submit"]',
        '#AddToCart',
        '#add-to-cart',
        '.add-to-cart',
        '.addtocart',
        '.add-to-cart-btn',
        '.btn-cart',
        '.product-form__submit-button',
        '.btn-add-to-cart',
        '.add-to-cart-button',

        // 第三优先级：产品选项区域
        '.product-form__input',
        '.product-form__item',
        '.product-options',
        '.product-variants',
        '.variant-picker',
        '.variant-selector',
        '.product-form__controls',
        '.product-form__field',
        '.options-selection',
        '.variant-input',
        '.product-form__input-wrapper',

        // 第四优先级：价格区域
        '.product-price',
        '.price-wrapper',
        '.price-container',
        '.product__price',
        '.price-section',
        '.product-form__price',

        // 第五优先级：产品信息区域
        '.product-form',
        '.product-form__wrapper',
        '.product-info',
        '.product__info',
        '.product-details',
        '.product-summary',
        '.product-content',
        '.product-meta',

        // 第六优先级：通用容器
        '.main-product',
        '.product-main',
        '.product-single',
        '.product-page',
        '.product-template',
        '.product-container',
        '.product-wrap',
        '.product-wrapper',
        '.product-content-wrapper',
        '.product-detail',
        '.product-info-wrapper',
        '.product-form-container'
      ];
      let inserted = false;
      for (const selector of fallbackSelectors) {
        const element = document.querySelector(selector);
        if (element && element.parentNode && isElementVisible(element)) {
          element.parentNode.insertBefore(fitContainer, element);
          inserted = true;
          break;
        }
      }

      // 最后的fallback：插入到产品信息区域
      if (!inserted) {
        const productInfo = document.querySelector('.product__info, .product-info, .product-details');
        if (productInfo) {
          productInfo.appendChild(fitContainer);
          inserted = true;
        } else {
          // 最终保障：寻找任何可能的容器
          const finalFallbacks = [
            'main',
            '.main-content',
            '.content',
            '.container',
            '.page-content',
            '.wrapper',
            '#main',
            'body'
          ];

          for (const fallback of finalFallbacks) {
            const element = document.querySelector(fallback);
            if (element) {
              element.appendChild(fitContainer);
              inserted = true;
              break;
            }
          }
        }
      }
    }
  } catch (error) {
    // 静默处理错误
  }
}

/**
 * 延迟添加 Fit 选择器（用于处理动态加载的元素）
 */
function addFitSelectorWithRetry(retryCount = 0, maxRetries = 5) {
  // 首先尝试立即添加
  addFitSelector();

  // // 检查是否成功插入
  // const fitSelector = document.querySelector('[data-pify-fit="true"]');
  // if (fitSelector) {
  //   return;
  // }

  // // 如果没有成功且还有重试次数，则延迟重试
  // if (retryCount < maxRetries) {
  //   const delay = (retryCount + 1) * 500; // 500ms, 1000ms, 1500ms...
  //   setTimeout(() => {
  //     addFitSelectorWithRetry(retryCount + 1, maxRetries);
  //   }, delay);
  // }
}

/**
 * 初始化 Fit 功能
 * 这个函数会在页面加载完成后自动运行
 */
function initializeFitFeature() {
  // 检查是否在产品页面
  const isProductPage = window.location.pathname.includes('/products/') ||
    document.querySelector('[data-section-type="product"]') ||
    document.querySelector('.product-form, .product__form, #product-form');

  if (!isProductPage) {
    return;
  }

  // 立即尝试添加
  addFitSelectorWithRetry();

  // 为动态加载的内容设置观察者
  const observer = new MutationObserver(() => {
    if (!document.querySelector('[data-pify-fit="true"]')) {
      addFitSelectorWithRetry();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 监听页面内容变化（如变体选择）
  document.addEventListener('change', () => {
    setTimeout(() => {
      if (!document.querySelector('[data-pify-fit="true"]')) {
        addFitSelectorWithRetry();
      }
    }, 100);
  });
}

/**
 * 监听sizechart.js数据加载完成
 */
function waitForSizeChartData() {
  // 检查是否已经有数据
  if (window.pageData && window.pageData.fitProfiles) {
    initializeFitFeature();
    return;
  }

  // 监听window.pageData变化
  let checkCount = 0;
  const maxChecks = 20; // 最多检查20次（10秒）

  const checkInterval = setInterval(() => {
    checkCount++;

    if (window.pageData && window.pageData.fitProfiles) {
      clearInterval(checkInterval);
      initializeFitFeature();
    } else if (checkCount >= maxChecks) {
      clearInterval(checkInterval);
      initializeFitFeature();
    }
  }, 500);
}

/**
 * 添加 Fit 选择器的 CSS 样式
 */
function addFitSelectorStyles() {
  const styleId = 'pify-fit-selector-styles';
  if (document.getElementById(styleId)) {
    return; // 已经添加过样式
  }

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    .pify_fit_selectors_wrapper {
    }
    
    .pify_fit_selector_container {
      user-select: none;
    }
    
    .pify_fit_title {
      padding: 0;
      display: block;
      font-weight: bold;
    }
    
    .pify_fit_types_container {
      margin-bottom: 12px;
    }
    
    .pify_fit_types_labels {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;
    }
    
    .pify_fit_type_label {
      flex: 1;
      text-align: center;
      transition: color 0.2s ease;
      color: var(--label-color, inherit);
      font-size: var(--label-font-size, inherit);
      font-weight: var(--label-font-weight, inherit);
    }
    
    .pify_fit_arrow_container {
      display: flex;
      gap: 8px;
      width: 100%;
      align-items: center;
      margin-bottom: 4px;
      height: 12px;
      background-color: transparent;
    }
    
    .pify_fit_arrow {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: opacity 0.2s ease;
      height: 12px;
      background-color: transparent;
    }
    
    .pify_fit_arrow_icon {
      font-size: 12px;
      line-height: 1;
      text-align: center;
      margin: 0 auto;
      display: block;
      font-weight: bold;
    }
    
    .pify_fit_segment_bar {
      display: flex;
      width: 100%;
      border-radius: 3px;
      height: 5px;
      min-height: 5px;
      gap: 2px;
    }
    
    .pify_fit_segment {
      flex: 1;
      transition: all 0.2s ease;
      box-sizing: border-box;
      display: block;
      border-radius: 3px;
      height: 5px;
      min-height: 5px;
      border: none;
    }
    
    .pify_fit_selector_spacing {
      margin-top: 20px;
    }
    
    .pify_fit_segment:first-child {
      border-top-left-radius: inherit;
      border-bottom-left-radius: inherit;
    }
    
    .pify_fit_segment:last-child {
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
    }
    
    /* 确保segments在advanced mode下能正确显示各自的样式 */
    .pify_fit_selector_container[data-advanced-mode="true"] .pify_fit_segment {
      border-radius: inherit;
    }
    
    @media (max-width: 768px) {
      .pify_fit_selectors_wrapper {
        margin-bottom: 12px;
      }
      
      .pify_fit_type_label {
        font-size: 12px;
        padding: 1px 2px;
      }
      
      .pify_fit_title {
        font-size: 14px;
      }
      
      .pify_fit_segment {
        min-height: 3px;
        height: 3px;
      }
    }
  `;

  document.head.appendChild(style);
}

// DOM加载完成后等待数据
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForSizeChartData);
} else {
  waitForSizeChartData();
}

// 额外的保险：延迟初始化
setTimeout(() => {
  if (!document.querySelector('[data-pify-fit="true"]')) {
    addFitSelectorWithRetry();
  }
}, 2000);

// 公开必要的API
window.FitSelector = {
  addFitSelector,
  addFitSelectorWithRetry,
  findQuantitySelector,
  isElementVisible,
  getFitProfilesFromData,
  shouldDisplayFitChart,
  renderFitSelector,
  setFitSelection,
  addFitSelectorStyles,
  initializeFitFeature,
  getCurrentProductId,
  normalizeProductId
};
